(function() {
  'use strict';

  angular
    .module('CarreEntrySystem', [
      'ngAnimate',
      'ngCookies',
      'angular-loading-bar',
      'ngTouch',
      'ngSanitize',
      'ngMessages',
      'ui.router',
      'ui.bootstrap',
      'toastr',
      'cgBusy',
      'ui.grid',
      'ui.grid.cellNav',
      'ui.grid.edit',
      'ui.grid.selection',
      'ui.grid.resizeColumns',
      'ui.grid.pinning',
      'ui.grid.moveColumns',
      'ui.grid.exporter',
      'ui.grid.grouping',
      'ui.grid.pagination',
      'ui.grid.autoResize',
      'ui.select',
      'pageslide-directive',
      'toggle-switch',
      'chart.js',
      'oitozero.ngSweetAlert',
      'permission',
      'angular-intro',
      'rzModule'
    ]);

})();

(function () {
  "use strict";

  angular
    .module("CarreEntrySystem")
    .controller("risk_factorsSingleController", risk_factorsSingleController);

  /** @ngInject */
  function risk_factorsSingleController(
    content,
    Risk_factors,
    uiGridGroupingConstants,
    $scope,
    uiGridConstants,
    $state
  ) {
    var vm = $scope;

    vm.id = $state.params.id;
    // init process
    if ($state.includes("**.create")) {
      vm.mode = "create";
    } else if (vm.id) {
      if ($state.includes("**.view")) {
        vm.mode = "view";
        loadRiskEvidences(vm.id);
      } else if ($state.includes("**.edit")) {
        vm.mode = "edit";
      } else {
        $state.go("404_error");
        return;
      }
    }

    $scope.$on("risk_factor:save", returnBack);
    $scope.$on("risk_factor:cancel", returnBack);

    function returnBack() {
      console.log("called", vm.id);
      if (vm.id) {
        $state.go("^.view", {
          id: vm.id,
        });
      } else $state.go("^.list");
    }

    /************** List Template **************/

    var visibleGridColumns = [
      "has_risk_factor",
      "has_observable_condition_text",
      // 'has_risk_evidence_source',
      // 'has_risk_evidence_ratio_type',
      "has_risk_evidence_ratio_value",
      // 'has_confidence_interval_min',
      // 'has_confidence_interval_max'
    ];

    function loadRiskEvidences(id) {
      vm.gridLoading = Risk_factors.risk_evidences(id).then(function (res) {
        if (res.data) {
          console.log(res.data);
          vm.mygrid.data = res.data;

          //make the response available in the view
          vm.res = res;

          /* Reset columns */
          vm.mygrid.columnDefs = [];

          vm.mygrid.columnDefs.push({
            field: "View",
            enableFiltering: false,
            enableColumnMenu: false,
            cellTemplate:
              '<div class="ui-grid-cell-contents"><button type="button" class="btn btn-xs btn-primary" ui-sref="main.risk_evidences.view({id:row.entity.id_label})"><i class="fa fa-eye"></i></button></div>',
            width: 60,
          });

          //dynamic creation of the grid columns
          content
            .fields(res.fields, visibleGridColumns)
            .forEach(function (obj) {
              vm.mygrid.columnDefs.push(obj);
            });

          vm.mygrid.columnDefs.push({
            field: "id_label",
            displayName: "ID",
            visible: false,
          });
        } else {
          vm.mygrid.columnDefs = [];
          vm.mygrid.data = [];
        }
      });
    }

    /* GRID Default options */
    vm.mygrid = content.default;
  }
})();

'use strict';

angular.module('CarreEntrySystem')

.directive('riskFactorForm', function() {
  return {
    templateUrl: 'app/pages/risk_factors/form_component/form.html',
    restrict: 'E',
    replace: true,
    scope: {
      'model': '='
    },
    controller: function($scope, Observables, Bioportal, Risk_elements, Risk_factors, Auth, toastr) {
      
      
      $scope.model = $scope.model || {};

      //get risk elements
      Risk_elements.get().then(function(res) {
        $scope.risk_elements = res.data.map(function(rl) {
            return {
              value: rl.id,
              label: rl.has_risk_element_name_label
            };
          });
      });
      
      //risk factor association types
      $scope.types = [{
        label: "is an issue in",
        value: "https://risk.thrombus.eu/ontology/risk.owl#risk_factor_association_type_is_an_issue_in"
      }, {
        label: "causes",
        value: "https://risk.thrombus.eu/ontology/risk.owl#risk_factor_association_type_causes"
      }, {
        label: "reduces",
        value: "https://risk.thrombus.eu/ontology/risk.owl#risk_factor_association_type_reduces"
      }, {
        label: "elevates",
        value: "https://risk.thrombus.eu/ontology/risk.owl#risk_factor_association_type_elevates"
      }];

      
      //Save to RDF method
      $scope.saveModel=function(){
        Risk_factors.save($scope.model,$scope.risk_factor).then(function(res){
          //success
          console.log('Risk factor saved',res);
          $scope.$emit('risk_factor:save');
          toastr.success('<b> Risk factor</b>'+($scope.model.id?' has been updated':' has been created'),'<h4>Risk factor saved</h4>');
        });
      };
      
      //Return back
      $scope.cancelForm=function(){
        $scope.$emit('risk_factor:cancel');
      };


      if ($scope.model.id) {

        /************** Edit Mode **************/
        console.info('---Edit---');


        //Init Form object
        $scope.risk_factor = {
          source: $scope.model.has_risk_factor_source[0],
          target: $scope.model.has_risk_factor_target[0],
          type: $scope.model.has_risk_factor_association_type[0],
        };


      }
      else {

        /************** Create Mode **************/
        console.info('---Create---');
        //Init Form object
        $scope.risk_factor = {
          source: "",
          target: "",
          type: ""
        };

      }

      console.info('Model: ', $scope.model);
      console.info('Form params: ', $scope.risk_factor);

    }
  };
});

(function() {
  'use strict';

  angular
    .module('CarreEntrySystem')
    .controller('risk_elementsSingleController', risk_elementsSingleController);

  /** @ngInject */
  function risk_elementsSingleController($scope, $state ) {
    var vm = $scope;
    
    vm.id=$state.params.id;
    // init process 
    if ($state.includes("**.create")) {
      vm.mode = 'create';
    } else if (vm.id) {
      if($state.includes("**.view")){
        vm.mode='view';
      } else if($state.includes("**.edit")){
        vm.mode='edit';
      } else {
        $state.go('404_error');
        return;
      }
    }
    
    $scope.$on('risk_element:save', returnBack);
    $scope.$on('risk_element:cancel', returnBack);
    
    function returnBack() {
      console.log('called',vm.id);
      if (vm.id) {
        $state.go('^.view', {
          id: vm.id
        });
      }
      else $state.go('^.list');
    }

  }

})();

'use strict';

angular.module('CarreEntrySystem')

.directive('riskElementForm', function() {
  return {
    templateUrl: 'app/pages/risk_elements/form_component/form.html',
    restrict: 'E',
    replace: true,
    scope: {
      'model': '='
    },
    controller: function($scope, Observables, Bioportal, Risk_elements,Auth,toastr) {
      
      $scope.model = $scope.model || {};
      $scope.bioportalAutocompleteResults = [];

      //get observables
      Observables.get().then(function(res) {
        //auto select initial
        var selected=[];
        $scope.observables = res.data.map(function(ob) {
            var obj={
              value: ob.id,
              label: ob.has_observable_name_label
            };
            if($scope.model.id && $scope.model.has_risk_element_observable) {
              if($scope.model.has_risk_element_observable.indexOf(ob.id)>=0) selected.push(obj.value);
            }
            return obj;
          });
        $scope.risk_element.observables=selected;
      });

      //get risk elements
      Risk_elements.get().then(function(res) {
        //auto select initial
        var selected=[];
        $scope.risk_elements = res.data.map(function(rl) {
            var obj={
              value: rl.id,
              label: rl.has_risk_element_name_label
            };
            if($scope.model.id && $scope.model.includes_risk_element) {
              if($scope.model.includes_risk_element.indexOf(rl.id)>=0) selected.push(obj.value);
            }
            return obj;
          });
          $scope.risk_element.risk_elements=selected;
      });

      //risk element types
      $scope.types = [{
        label: "behavioural",
        value: "https://risk.thrombus.eu/ontology/risk.owl#risk_element_type_behavioural"
      }, {
        label: "biomedical",
        value: "https://risk.thrombus.eu/ontology/risk.owl#risk_element_type_biomedical"
      }, {
        label: "demographic",
        value: "https://risk.thrombus.eu/ontology/risk.owl#risk_element_type_demographic"
      }, {
        label: "intervention",
        value: "https://risk.thrombus.eu/ontology/risk.owl#risk_element_type_intervention"
      }, {
        label: "genetic",
        value: "https://risk.thrombus.eu/ontology/risk.owl#risk_element_type_genetic"
      }, {
        label: "environmental",
        value: "https://risk.thrombus.eu/ontology/risk.owl#risk_element_type_environmental"
      }];

      //Bioportal stuff
      $scope.bioportalAutocomplete = function(term) {
        // var options = { };
        if (term.length < 2) return false;
        $scope.loadingElementIdentifier = true;
        Bioportal.fetch(term).then(function(res) {
          $scope.bioportalAutocompleteResults = res;
          $scope.loadingElementIdentifier = false;
        });
      };
      
      //Save to RDF method
      $scope.saveModel=function(){
        Risk_elements.save($scope.model,$scope.risk_element).then(function(res){
          //success
          console.log('Risk Element saved',res);
          
          $scope.$emit('risk_element:save');
          toastr.success('<b>'+$scope.risk_element.name+'</b>'+($scope.model.id?' has been updated':' has been created'),'<h4>Risk element saved</h4>');

        });
      };
      //Return back
      $scope.cancelForm=function(){
        $scope.$emit('risk_element:cancel');
      };


      if ($scope.model.id) {

        /************** Edit Mode **************/
        console.info('---Edit---');


        //Init Form object
        $scope.risk_element = {
          observables: [],
          risk_elements: [],
          type: $scope.model.has_risk_element_type[0],
          name: $scope.model.has_risk_element_name_label,
          identifier: $scope.model.has_risk_element_identifier_label,
          modifiable_status: $scope.model.has_risk_element_modifiable_status_label
        };


        //init Bioportal Fetch
        $scope.bioportalAutocomplete($scope.risk_element.identifier);


      }
      else {

        /************** Create Mode **************/
        console.info('---Create---');

        //Init Form object
        $scope.risk_element = {
          observables: [],
          risk_elements: [],
          type: "",
          name: "",
          identifier: "",
          modifiable_status: ""
        };


      }

      

      console.info('Model: ', $scope.model);
      console.info('Form params: ', $scope.risk_element);

    }
  };
});

/*global jsep*/
(function() {
  'use strict';

  angular
    .module('CarreEntrySystem')
    .controller('risk_evidencesSingleController', risk_evidencesSingleController);

  /** @ngInject */
  function risk_evidencesSingleController( $state, $scope, CARRE) {
    
    var vm = $scope;
    
    vm.id=$state.params.id;
    vm.pubmedId=$state.params.pubmedId;
    
    // init process 
     if ($state.is("main.risk_evidences.createWithId")) {
      console.log(vm.pubmedId);
      if(vm.pubmedId) {
        //check if already exists a risk_evidence with this PubmedID;
        CARRE.search('citation',vm.pubmedId).then(function(res){
          vm.create = true;
          console.log('risk_evidence Records for this pubmedid: '+ vm.pubmedId, res);
          res.data=res.data||[];
          if(res.data.length>0){
            
            console.log('Article found with data: ',res.data[0]);
            vm.current = { pubmedId:vm.pubmedId, citation: res.data[0].id };
            vm.mode='create';
            
          } else {
            console.log('Article not found id: ',vm.pubmedId);
            vm.current = { pubmedId:vm.pubmedId };
            vm.mode='create';
          }
        });
      } else $state.go('main.risk_evidences.create',{},{reload:true});
      
    } else if ($state.includes("**.create")) {
      vm.mode = 'create';
    } else if (vm.id) {
      if($state.includes("**.view")){
        vm.mode='view';
      } else if($state.includes("**.edit")){
        vm.mode='edit';
      } else {
        $state.go('404_error');
        return;
      }
    }
    
    $scope.$on('risk_evidence:save', returnBack);
    $scope.$on('risk_evidence:cancel', returnBack);
    
    function returnBack() {
      console.log('called',vm.id);
      if (vm.id) {
        $state.go('^.view', {
          id: vm.id
        });
      }
      else $state.go('^.list');
    }
    

  }

})();

'use strict';

angular.module('CarreEntrySystem')

.directive('riskEvidenceForm', function() {
  return {
    templateUrl: 'app/pages/risk_evidences/form_component/form.html',
    restrict: 'E',
    replace: true,
    scope: {
      'model': '='
    },
    controller: function($rootScope, $scope, $state, $stateParams, Citations, Observables, Bioportal, Risk_factors, Risk_evidences, toastr,$timeout,Measurement_types,$q) {
      
      $scope.copyModel={};
      angular.copy($scope.model,$scope.copyModel);
      
      
      $scope.showLeEditor=false;
      $scope.model = $scope.model || {};
      $scope.bioportalAutocompleteResults = [];
      
      $scope.$on('citation:save',function(res){
        $scope.showAddCitation=false;
        
        // get citations
        Citations.get().then(function(res) {
          $scope.citations = res.data.map(function(obj) {
            var label=[];
            if(obj.has_citation_summary_label) label=obj.has_citation_summary_label.split('.');
            return {
              value: obj.id||"",
              pubmed:obj.has_citation_pubmed_identifier[0]||"",
              title: label[1].replace('; ','')||"",
              authors: label[0]||"",
              date: label[2]||""
            };
          });
           updateSelectedCitation();
        });
        
        // $state.go($state.current, $stateParams, {reload: true, inherit: false});
      })

      if ($scope.model.id) {

        /************** Edit Mode **************/
        console.info('---Edit---');


        //Init Form object
        $scope.risk_evidence = {
          observables: [],
          ratio_type:$scope.model.has_risk_evidence_ratio_type?$scope.model.has_risk_evidence_ratio_type[0]:"",
          ratio_value:$scope.model.has_risk_evidence_ratio_value?parseFloat($scope.model.has_risk_evidence_ratio_value[0]):0,
          confidence_interval_min:$scope.model.has_confidence_interval_min?parseFloat($scope.model.has_confidence_interval_min[0]):0,
          confidence_interval_max:$scope.model.has_confidence_interval_max?parseFloat($scope.model.has_confidence_interval_max[0]):0,
          risk_factor:$scope.model.has_risk_factor[0],
          pubmedId:$scope.model.has_risk_evidence_source_label,
          evidence_source:$scope.model.has_risk_evidence_source[0],
          condition: $scope.model.has_observable_condition,
          condition_json: angular.fromJson($scope.model.has_observable_condition_json[0]),
          condition_text: "",
          adjusted_for:[]
        };
        
        //init expression
        $scope.filter = $scope.risk_evidence.condition_json || {
          "group": {
            "operator": "AND",
            "rules": []
          }
        };


      }
      else {

        /************** Create Mode **************/
        console.info('---Create---');

        //init expression
        $scope.filter = {
          "group": {
            "operator": "AND",
            "rules": []
          }
        };
        
        
        //Init Form object
        $scope.risk_evidence = {
          observables:[],
          pubmedId:$scope.model.pubmedId||'',
          evidence_source: $scope.model.citation||'',
          risk_factor:'',
          condition_text: "",
          adjusted_for:[]
        };


      }
      
      $scope.adjusted_for=[];
    
      
      // function loadExternalData() {
      
        //Get combined requests done in an async way!
        $q.all([Observables.get(),Measurement_types.get()]).then(function(res){
          console.log('Promises',res);      
          
          //observables
          //auto select initial
          var selected=[];
          $scope.observables = res[0].data.map(function(obj) {
              
              var result= {
                value: obj.id_label,
                id: obj.id,
                label: obj.has_observable_name_label,
                metype_label: obj.has_observable_measurement_type_label,
                metype_id: obj.has_observable_measurement_type[0]
              };
              
              if($scope.model.id) {
                if($scope.model.has_risk_evidence_observable.indexOf(obj.id)>=0) selected.push(obj.id);
              }
              
              return result;
            });
          $scope.risk_evidence.observables=selected;
          
          
          $scope.output=removeOuterParenthesis(computed($scope.filter.group));
          
          //measurement types
          $scope.metypes=res[1].data;
          $scope.showLeEditor=true;
        })
        
        //get risk evidence adjusted for
        Risk_evidences.adjusted_for().then(function(res){
          console.log('adjusted_for',res);
          $scope.adjusted_for=res;
          
          //initial selection
          if($scope.model.is_adjusted_for instanceof Array) {
            $scope.risk_evidence.adjusted_for=$scope.model.is_adjusted_for[0].split(',').map(function(str){
              return str.trim().toLocaleLowerCase();
            });
          }
        });
        
        
        //get risk factors
        Risk_factors.get().then(function(res) {
          $scope.risk_factors = res.data.map(function(obj) {
              return {
                value: obj.id,
                label: obj.has_risk_factor_source_label+' ['+obj.has_risk_factor_association_type_label+'] '+obj.has_risk_factor_target_label
              };
            });
        });
        
        //get citations
        Citations.get().then(function(res) {
          $scope.citations = res.data.map(function(obj) {
            var label=[];
            if(obj.has_citation_summary_label) label=obj.has_citation_summary_label.split('.');
              return {
                value: obj.id||"",
                pubmed:obj.has_citation_pubmed_identifier[0]||"",
                title: label[1].replace('; ','')||"",
                authors: label[0]||"",
                date: label[2]||""
              };
            });
            updateSelectedCitation();
        });
        
      // }

      //ratio types
      $scope.ratiotypes = [{
        label: "Hazard ratio",
        value: "https://risk.thrombus.eu/ontology/risk.owl#risk_evidence_ratio_type_hazard_ratio"
      }, {
        label: "Odds ratio",
        value: "https://risk.thrombus.eu/ontology/risk.owl#risk_evidence_ratio_type_odds_ratio"
      }, {
        label: "Relative risk",
        value: "https://risk.thrombus.eu/ontology/risk.owl#risk_evidence_ratio_type_relative_risk"
      }];
      
      
      //Save to RDF method
      $scope.saveModel = function() {
        //save condition text format
        $scope.risk_evidence.condition_text=$scope.output
          .replace(/<\/?[a-z][a-z0-9]*[^>]*>/ig, "")
          .replace(/&nbsp;/gi," ")
          .replace(/&amp;/gi,"&")
          .replace(/&quot;/gi,'"')
          .replace(/&lt;/gi,'<')
          .replace(/&gt;/gi,'>');
          
        //cleanse condition json format
        var condition_clean={};
        angular.copy($scope.filter,condition_clean);
        cleanseCondition(condition_clean);
        $scope.risk_evidence.condition_json=angular.toJson(condition_clean).toString().replace(/"/g, '\\"');
        
        Risk_evidences.save($scope.model, $scope.risk_evidence).then(function(res) {
          //success
          console.log('Risk Evidence saved', res);

          $scope.$emit('risk_evidence:save');
          toastr.success('<b>' + $scope.risk_evidence.pubmedId + '</b>' + ($scope.model.id ? ' has been updated' : ' has been created'), '<h4>Risk evidence saved</h4>');

        });
      };
      //Return back
      $scope.cancelForm = function() {
        $scope.$emit('risk_evidence:cancel');
      };

      
      
      /* LoadPubmed */
      $scope.loadPubmed=loadPubmed;
      function loadPubmed(){
        $scope.showPubmed=false;
        $timeout(function(){
          $scope.showPubmed=true;
          updateSelectedCitation();
        },200);
      }
      
      $scope.viewPubmed=function(item,model){
        //init Pubmed Fetch
        $scope.risk_evidence.pubmedId=item.pubmed;
        loadPubmed();
      };
      
      function updateSelectedCitation(){
        $timeout(function() {
          $scope.risk_evidence.evidence_source = $scope.CIbyPMID($scope.citations,$scope.risk_evidence.pubmedId);
        }, 0);
      }
      
      $scope.CIbyPMID=function(citations,pmid){
        if(!citations||!pmid) return null;
        else return citations.filter(function(ci){ return ci.pubmed === pmid; }).map(function(ci){ return ci.value;  })[0];  
      };

      // function htmlEntities(str) {
      //   return String(str).replace(/</g, '&lt;').replace(/>/g, '&gt;');
      // }

      function computed(group) {
          if(!$scope.observables) return "";
          if (!group) return "";
          
          var str="(";
          for (var i = 0; i < group.rules.length; i++) {
              i > 0 && (str += " <b>" + group.operator + "</b> ");
              str += group.rules[i].group ?
                  computed(group.rules[i].group) :
                  getObservableName(group.rules[i].field) + " " + group.rules[i].condition + " " + group.rules[i].data;
          }
          return str +")";
      }
      
      function computedRaw(group) {
          if(!$scope.observables) return "";
          if (!group) return "";
          
          var str="(";
          for (var i = 0; i < group.rules.length; i++) {
              i > 0 && (str += " " + group.operator + " ");
              str += group.rules[i].group ?
                  computed(group.rules[i].group) :
                  group.rules[i].field + " " + group.rules[i].condition + " " + group.rules[i].data;
          }
          return str +")";
      }

      $scope.$watch('filter', function(newValue) {
        $scope.risk_evidence.condition_json = newValue;
        $scope.output = removeOuterParenthesis(computed(newValue.group, 0, {}));
        //calculate raw condition
        $scope.risk_evidence.condition = removeOuterParenthesis(computedRaw(newValue.group, 0, {}));
      }, true);

      
      function getObservableName(id){
        if (!id) return '';
        if($scope.observables) {
          var result=$scope.observables.filter(function(ob){
            return ob.value===id;
          });
          if(result.length>0){
            return "<a href='/observables/"+id+"'>"+result[0].label+"</a>";
          } else return '';
        }
        // return <carre-linker model="risk_evidence.current" property="{{field.value}}"></carre-linker>""
      }
      
      function removeOuterParenthesis(str){
        return str.substr(1,str.length-2);
      }
      
      function cleanseCondition(obj){
        if(obj.condition) {
          delete obj.hiddenData;
          delete obj.datatype;
          delete obj.unit_label;
          delete obj.dataoptions;
          delete obj.unit;
        } else {
          //group
          if(obj.group.rules) {
            obj.group.rules.forEach(function(condition){
              cleanseCondition(condition);
            });
          }
        }
      }
      
      console.info('Model: ', $scope.model);
      console.info('Form params: ', $scope.risk_evidence);
      
      //init Pubmed Fetch
      loadPubmed();
      // loadExternalData();
    }
  };
});

(function() {
  'use strict';

  angular
    .module('CarreEntrySystem')
    .controller('medical_expertsSingleController', medical_expertsSingleController);

  /** @ngInject */
  function medical_expertsSingleController(toastr,CONFIG, content, Bioportal, Medical_experts, CARRE, SweetAlert, $stateParams, $timeout, Pubmed, $state, $scope) {
    var vm = this;
    
    var visibleFields = [
      "has_firstname",
      "has_lastname",
      "has_medical_specialty_identifier",
      "has_medical_position",
      "has_short_cv",
      "has_personal_page_url",
      "has_user_graph",
      "has_avatar",
      "is_coordinator_of_team",
      "has_team_name"
    ];
    
    var labels=[
        "Risk Factors",
        "Risk Evidences",
        "Risk Elements",
        "Observables",
        "Citations"
      ];
      
    var labels_lo=labels.map(function(str){return str.toLowerCase().replace(" ","_")});

  
    vm.colors=CONFIG.COLORS;
    vm.counterchart_options = {
      
    };
    vm.counterchart_labels = labels;
    vm.counterchart_series=["Entered","Reviewed"];
    vm.counterchart_data=[[0,0,0,0,0],[0,0,0,0,0]];
    
    /* View Risk_element */
    vm.id = $stateParams.id;
    vm.current = {};
    if (vm.id) getMedical_expert(vm.id);


    /* Helper functions */
    function getMedical_expert(id) {
      Medical_experts.get([id]).then(function(res) {
        if (res.data) {
          vm.current = res.data[0];
          
          Bioportal.fetch(vm.current.has_medical_specialty_identifier_label,{ontologies:'MESH,SNOMEDCT'}).then(function(res){
            vm.current.has_medical_specialty_label=res[0].label||"";
            vm.current.has_medical_specialty_link=res[0].link||"";
          })
          
          Medical_experts.countFor(vm.current.has_graph_uri[0]).then(function(res){
            //set data for the graph
            res.data.forEach(function(obj){
              var pos=labels_lo.indexOf(obj.type.value.split("#")[1]+'s');
              vm.counterchart_data[0][pos]=Number(obj.authored.value);
              vm.counterchart_data[1][pos]=Number(obj.reviewed.value);
            });
          });
          
        }
        else $state.go('main.medical_experts.list');
      }, function(err) {
        console.error(err);
        $state.go('main.medical_experts.list');
      });
    }
    
    
    //event on create method
    // $scope.$on('create', function (event, chart) {
    //   // set colors for each bar
    //   if(chart.datasets){
    //     chart.datasets[0].bars.map(function(obj,index){
    //       var rgb=hexToRgb(vm.colors[index])
    //       obj.fillColor="rgba("+rgb.r+","+rgb.g+","+rgb.b+",0.5)";
    //       obj.strokeColor="#FFF";
    //       return obj;
    //     });
        
    //     chart.datasets[1].bars.map(function(obj,index){
    //       var rgb=hexToRgb(vm.colors[index])
    //       obj.fillColor="rgba("+rgb.r+","+rgb.g+","+rgb.b+",1)";
    //       obj.strokeColor="#FFF";
    //       return obj;
    //     });
    //   }
    // });

  }

})();

(function() {
  'use strict';

  angular
    .module('CarreEntrySystem')
    .controller('observablesSingleController', observablesSingleController);

  /** @ngInject */
  function observablesSingleController($scope, $state ) {
    
    var vm = $scope;
    
    vm.id=$state.params.id;
    // init process 
    if ($state.includes("**.create")) {
      vm.mode = 'create';
    } else if (vm.id) {
      if($state.includes("**.view")){
        vm.mode='view';
      } else if($state.includes("**.edit")){
        vm.mode='edit';
      } else {
        $state.go('404_error');
        return;
      }
    }
    
    $scope.$on('observable:save', returnBack);
    $scope.$on('observable:cancel', returnBack);
    
    function returnBack() {
      console.log('called',vm.id)
      if (vm.id) {
        $state.go('^.view', {
          id: vm.id
        });
      }
      else $state.go('^.list');
    }
    

  }

})();

'use strict';

angular.module('CarreEntrySystem')

.directive('observableForm', function() {
  return {
    templateUrl: 'app/pages/observables/form_component/form.html',
    restrict: 'E',
    replace: true,
    scope: {
      'model': '='
    },
    controller: function($scope, Observables, Bioportal, Measurement_types,Auth,toastr,CONFIG) {
      
      $scope.model = $scope.model || {};

      //get measurement types
      Measurement_types.get().then(function(res) {
        $scope.measurement_types = res.data.map(function(obj) {
            return {
              value: obj.id,
              label: obj.has_measurement_type_name_label
            };
          });
      });
      
      //Bioportal stuff
      $scope.bioportalAutocompleteResults = [];
      $scope.bioportalAutocomplete = function(term) {
        if (term.length < 2) return false;
        $scope.loadingElementIdentifier = true;
        var options={
          ontologies:"CMO"
        };
        Bioportal.fetch(term,options,"no cui").then(function(res) {
          $scope.bioportalAutocompleteResults = res;
          $scope.loadingElementIdentifier = false;
        });
      };
      $scope.transformIndentifier=function(str){
        var formatted = str.replace(/ /g, "_").replace(/[^\w\s]/gi, "").toUpperCase();
        $scope.observable.identifier = formatted.length>0?"https://risk.thrombus.eu/external_observable_type/CMO_"+formatted:"_:blankNode";
      };
      $scope.transformPredicate=function(str){
        var formatted = str.toLowerCase();
        $scope.observable.predicate = formatted.length>0?"https://risk.thrombus.eu/ontology/sensors.owl#has_"+formatted:"_:blankNode";
      };

      //Observable types
      $scope.types = [{
        label: "Personal",
        value: "https://risk.thrombus.eu/ontology/risk.owl#observable_type_personal"
      }, {
        label: "Clinical",
        value: "https://risk.thrombus.eu/ontology/risk.owl#observable_type_clinical"
      }, {
        label: "Other",
        value: "https://risk.thrombus.eu/ontology/risk.owl#observable_type_other"
      }];

      // Sensor Predicates
      $scope.SensorPredicates = CONFIG.SENSOR_PREDICATES;
      
      //Save to RDF method
      $scope.saveModel=function(){
        Observables.save($scope.model,$scope.observable).then(function(res){
          //success
          console.log('Observable saved',res);
          $scope.$emit('observable:save');
          toastr.success('<b>'+$scope.observable.name+'</b>'+($scope.model.id?' has been updated':' has been created'),'<h4>Observable saved</h4>');
        });
      };
      //Return back
      $scope.cancelForm=function(){
        $scope.$emit('observable:cancel');
      };


      if ($scope.model.id) {

        /************** Edit Mode **************/
        console.info('---Edit---');


        //Init Form object
        $scope.observable = {
          name: $scope.model.has_observable_name[0],
          type: $scope.model.has_observable_type[0],
          measurement_type: $scope.model.has_observable_measurement_type[0],
          identifier: $scope.model.has_external_type?$scope.model.has_external_type[0]:"",
          predicate: $scope.model.has_external_predicate?$scope.model.has_external_predicate[0]:""
        };
        
        $scope.customPredicate = $scope.model.has_external_predicate?$scope.model.has_external_predicate_label.split('has_')[1]:"";
        
        //init Bioportal Fetch
        $scope.bioportalAutocomplete($scope.observable.identifier);


      }
      else {

        /************** Create Mode **************/
        console.info('---Create---');

        //Init Form object
        $scope.observable = {
          name: "",
          type: "",
          measurement_type: "",
          identifier:"",
          predicate:""
        };


      }

      

      console.info('Model: ', $scope.model);
      console.info('Form params: ', $scope.observable);

    }
  };
});

(function() {
  'use strict';

  angular
    .module('CarreEntrySystem')
    .controller('measurement_typesSingleController', measurement_typesSingleController);

  /** @ngInject */
  function measurement_typesSingleController($state, $scope ) {
    
    var vm = $scope;
    
    vm.id=$state.params.id;
    // init process 
    if ($state.includes("**.create")) {
      vm.mode = 'create';
    } else if (vm.id) {
      if($state.includes("**.view")){
        vm.mode='view';
      } else if($state.includes("**.edit")){
        vm.mode='edit';
      } else {
        $state.go('404_error');
        return;
      }
    }
    
    $scope.$on('measurement_type:save', returnBack);
    $scope.$on('measurement_type:cancel', returnBack);
    
    function returnBack() {
      console.log('called',vm.id);
      if (vm.id) {
        $state.go('^.view', {
          id: vm.id
        });
      }
      else $state.go('^.list');
    }
    
  }

})();

'use strict';

angular.module('CarreEntrySystem')

.directive('measurementTypeForm', function() {
  return {
    templateUrl: 'app/pages/measurement_types/form_component/form.html',
    restrict: 'E',
    replace: true,
    scope: {
      'model': '='
    },
    controller: function($scope, Measurement_types, toastr, Bioportal) {


      $scope.model = $scope.model || {};

      //risk element types
      $scope.datatypes = ["float","enum","integer","boolean"];
      
      
      //Bioportal stuff
      $scope.bioportalAutocompleteResults = [];
      $scope.bioportalAutocomplete = function(term) {
        if (term.length < 2) return false;
        $scope.loadingElementIdentifier = true;
        var options={
          ontologies:"UO"
        };
        Bioportal.fetch(term,options,"no cui").then(function(res) {
          $scope.bioportalAutocompleteResults = res;
          $scope.loadingElementIdentifier = false;
        });
      };
      
      $scope.transformItem=function(str){
        var formatted = str.replace(/ /g, "_").replace(/[^\w\s]/gi, "").toUpperCase();
        $scope.measurement_type.identifier = "https://risk.thrombus.eu/external_measurement_unit/UO_"+formatted;
      }
      
      //Save to RDF method
      $scope.saveModel=function(){
        
        //fix measurement type multi values
        if($scope.measurement_type.datatype==='enum'||$scope.measurement_type.datatype==='boolean') {
          $scope.measurement_type.has_enumeration_values = $scope.measurement_type.values.join(';');
          
          console.log($scope.measurement_type.values,$scope.measurement_type.has_enumeration_values);
        } else $scope.measurement_type.has_enumeration_values = "";
        delete $scope.measurement_type.values;
        
        Measurement_types.save($scope.model,$scope.measurement_type).then(function(res){
          //success
          console.log('Measurement type saved',res);
          
          $scope.$emit('measurement_type:save');
          toastr.success('<b>'+$scope.measurement_type.name+'</b>'+($scope.model.id?' has been updated':' has been created'),'<h4>Measurement type saved</h4>');

        });
      };
      
      //Return back
      $scope.cancelForm=function(){
        $scope.$emit('measurement_type:cancel');
      };


      if ($scope.model.id) {

        /************** Edit Mode **************/
        console.info('---Edit---');

        //Init Form object
        $scope.measurement_type = {
          name: $scope.model.has_measurement_type_name_label,
          unit: $scope.model.has_label_label||"",
          datatype: $scope.model.has_datatype_label,
          identifier: $scope.model.has_external_unit?$scope.model.has_external_unit[0]:""
        };

        if($scope.model.has_datatype_label==='enum'||$scope.model.has_datatype_label==='boolean') {
          $scope.measurement_type.values=$scope.model.has_enumeration_values_label.split(';');
        }
        
        //init Bioportal Fetch
        $scope.bioportalAutocomplete($scope.measurement_type.identifier);


      }
      else {

        /************** Create Mode **************/
        console.info('---Create---');

        //Init Form object
        $scope.measurement_type = {
          name: "",
          unit: "",
          datatype: "",
          values: [],
          identifier:""
        };


      }

      

      console.info('Model: ', $scope.model);
      console.info('Form params: ', $scope.measurement_type);

    }
  };
});

(function() {
  'use strict';

  angular
    .module('CarreEntrySystem')
    .controller('citationsSingleController', citationsSingleController);

  /** @ngInject */
  function citationsSingleController($stateParams, $state, CARRE, $scope){
   
    var vm = $scope;
    
    vm.id=$state.params.id;
    // init process 
     if ($state.is("main.citations.createWithId")) {
      if($stateParams.pubmedId) {
        //check if already exists a citation with this PubmedID;
        CARRE.search('citation',$stateParams.pubmedId).then(function(res){
          
          vm.create = true;
          console.log('Citation Records for this pubmedid'+ $stateParams.pubmedId, res);
          res.data=res.data||[];
          if(res.data.length>0){
            $state.go('main.citations.edit',{id:res.data[0].id_label},{reload:true});
          } else {
              console.log('Article with id: ',$stateParams.pubmedId);
              vm.current = { pubmedId:$stateParams.pubmedId };
              vm.mode='create';
          }
        });
      } else $state.go('main.citations.create',{},{reload:true});
      
    } else if ($state.includes("**.create")) {
      vm.mode = 'create';
    } else if (vm.id) {
      if($state.includes("**.view")){
        vm.mode='view';
      } else if($state.includes("**.edit")){
        vm.mode='edit';
      } else {
        $state.go('404_error');
        return;
      }
    }
    
    $scope.$on('citation:save', returnBack);
    $scope.$on('citation:cancel', returnBack);
    
    function returnBack() {
      console.log('called',vm.id);
      if (vm.id) {
        $state.go('^.view', {
          id: vm.id
        });
      }
      else $state.go('^.list');
    }
    

  }

})();

'use strict';

angular.module('CarreEntrySystem')

.directive('citationForm', function() {
  return {
    templateUrl: 'app/pages/citations/form_component/form.html',
    restrict: 'E',
    replace: true,
    scope: {
      'model': '=',
    },
    controller: function($scope, Citations, Pubmed, toastr,$timeout, CONFIG) {
      
      // $scope.pubmedId = $scope.pubmedId || null;
      $scope.model = $scope.model || {};
      $scope.pubmedAutocompleteResults = [];
      
      $scope.noPubmed = $scope.model.noPubmed;

      //citation study types
      $scope.types=[];
      // $scope.addStudyType=function(item,model){
      //   console.log("Add study type");
      //   console.log(item,model);
      //   return item;
      //   // if($scope.types.indexOf(item)===-1 && item) {
      //   //   $scope.types.push(item);
      //   //   $scope.showNewType=false;
      //   // }
      // };

      Citations.types().then(function(res){
        console.log('Citation types',res);
          $scope.types=res;
      });
      
      
      $scope.selectPubmed=function(item,model){
        //build the summary
        var summary = null;
        if(item.title) summary=item.authorString+"; "+item.title+" "+
                item.journalTitle+" "+item.pubYear+";"+
                item.journalVolume+"("+item.issue+"):"+item.pageInfo+"."+
                " doi:"+item.doi||"0000";
                
        $scope.citation.pubmedId=item.pmid || $scope.citation.pubmedId;
        $scope.citation.summary=JSON.stringify(summary || $scope.citation.summary).slice(1, -1);
        $scope.loadPubmed();
      };
      
      //refresh pubmed article
      $scope.loadPubmed=function(){
        $scope.showPubmed=false;
        $timeout(function(){
          $scope.showPubmed=true;
        },200);
      };
      
      //Autocomplete stuff
      $scope.searchPubmed = function(term) {
        // var options = { };
        if (term.length < 2) return false;
        $scope.loadingElementIdentifier = true;
        Pubmed.search(term).then(function(res) {
          /*
          
          authorString: "Levy M, Smith T, Alvarez-Perez A, Back A, Baker JN, Beck AC, Block S, Dalal S, Dans M, Fitch TR, Kapo J, Kutner JS, Kvale E, Misra S, Mitchell W, Portman DG, Sauer TM, Spiegel D, Sutton L, Szmuilowicz E, Taylor RM, Temel J, Tickoo R, Urba SG, Weinstein E, Zachariah F, Bergman MA, Scavone JL."
          citedByCount: 0
          epmcAuthMan: "N"
          hasBook: "N"
          hasDbCrossReferences: "N"
          hasLabsLinks: "N"
          hasPDF: "N"
          hasReferences: "N"
          hasSuppl: "N"
          hasTMAccessionNumbers: "N"
          hasTextMinedTerms: "N"
          id: "26733557"
          inEPMC: "N"
          inPMC: "N"
          issue: "1"
          journalIssn: "1540-1405"
          journalTitle: "J Natl Compr Canc Netw"
          journalVolume: "14"
          luceneScore: "NaN"
          pageInfo: "82-113"
          pmid: "26733557"
          pubType: "journal article"
          pubYear: "2016"
          source: "MED"
          title: "Palliative Care Version 1.2016."
          
          */
          $scope.pubmedAutocompleteResultsCount = res.count;
          $scope.pubmedAutocompleteResults = res.result
          .map(function(obj){
              obj.title = obj.title || "";
              obj.authorString = obj.authorString || "";
              obj.source =obj.source || "";
              obj.pubYear = obj.pubYear || "";
              obj.pmid = obj.pmid || obj.id;
              return obj;
          });
          $scope.loadingElementIdentifier = false;
          $scope.selectPubmed($scope.pubmedAutocompleteResults[0]||{}); //pass an empty object for no errors
        });
      };
      
      //Save to RDF method
      $scope.saveModel=function(){
        
        $scope.citation.type = $scope.citation.studyType[0];
        delete $scope.citation.studyType;
        
        Citations.save($scope.model,$scope.citation).then(function(res){
          if(!res) return;
          $scope.$emit('citation:save');
          toastr.success('<b>Citation with PMID:'+$scope.citation.pubmedId+'</b>'+($scope.model.id?' has been updated':' has been created'),'<h4>Citations saved</h4>');

        },function(err){
          console.error("Error saving citation",$scope.citation)
        });
      };
      //Return back
      $scope.cancelForm=function(){
        $scope.$emit('citation:cancel');
      };


      if ($scope.model.id) {

        /************** Edit Mode **************/
        console.info('---Edit---');


        //Init Form object
        $scope.citation = {
          type: $scope.model.has_citation_source_type_label || "",
          level: parseInt($scope.model.has_citation_source_level_label) || 1,
          summary: $scope.model.has_citation_summary_label || "",
          pubmedId: $scope.model.has_citation_pubmed_identifier_label || ""
        };
        
        //run pubmed search
        $scope.searchPubmed($scope.citation.pubmedId);
        
        $scope.citation.studyType=[$scope.citation.type]

      }
      else {

        /************** Create Mode **************/
        console.info('---Create---');

        //Init Form object
        $scope.citation = {
          type: "",
          level: 1,
          summary: "",
          pubmedId: $scope.model.pubmedId||""
        };
        
        if($scope.citation.pubmedId){
          //run pubmed search
          $scope.searchPubmed($scope.citation.pubmedId);
        }

      }

      

      console.info('Model: ', $scope.model);
      console.info('Form params: ', $scope.citation);

    }
  };
});

'use strict';

/**
 * @ngdoc directive
 * @name izzyposWebApp.directive:adminPosHeader
 * @description
 * # adminPosHeader
 */

angular.module('CarreEntrySystem')
  .directive('sidebarSearch',function() {
    return {
      templateUrl:'app/components/sidebar/sidebar-search/sidebar-search.html',
      restrict: 'E',
      replace: true,
      scope: {
      },
      controller:function($scope){
        $scope.selectedMenu = 'home';
      }
    }
  });

'use strict';

/**
 * @ngdoc directive
 * @name izzyposWebApp.directive:adminPosHeader
 * @description
 * # adminPosHeader
 */
angular.module('CarreEntrySystem')
	.directive('headerNotification',function($rootScope,$timeout,$state,$location){
		return {
            templateUrl:'app/components/header/header-notification/header-notification.html',
            restrict: 'E',
            replace: true,
            link:function(scope,elem,attr){
                scope.pathname=setPath();
                $rootScope.$on('$stateChangeSuccess', function(){ scope.pathname=setPath(); })
                function setPath(){ return $location.absUrl().replace('/edit','');}
            }
		}
	});



angular
  .module("CarreEntrySystem")
  .service("Risk_factors", function ($http, CARRE, CONFIG, QUERY) {
    this.exports = {
      get: getRisk_factors,
      save: saveRisk_factor,
      risk_evidences: getRisk_evidencesFromRisk_Factor,
    };

    function getRisk_factors(ArrayOfIDs, raw) {
      return CARRE.instances("risk_factor", ArrayOfIDs);
    }

    function saveRisk_factor(oldElem, newElem, user) {
      user = user || CONFIG.currentUser.graphName;
      var updateQuery = "",
        insertQuery = "";
      var newObj = {};

      if (newElem.source.length > 0)
        newObj.has_risk_factor_source = {
          pre: "risk",
          value: newElem.source,
          type: "node",
        };
      if (newElem.target.length > 0)
        newObj.has_risk_factor_target = {
          pre: "risk",
          value: newElem.target.toString(),
          type: "node",
        };
      if (newElem.type.length > 0)
        newObj.has_risk_factor_association_type = {
          pre: "risk",
          value: newElem.type.toString(),
          type: "node",
        };

      console.log("Old: ", oldElem);
      console.log("New: ", newElem);
      console.log("Mapped: ", newObj);

      /* invalidate Risk factors and Risk evidences */
      CARRE.invalidateCache("risk_factor_all");
      CARRE.invalidateCache("risk_evidence_all");
      CARRE.invalidateCache("count_all");

      if (oldElem.id) {
        /*Update query*/
        updateQuery = QUERY.update(oldElem, newObj);
        console.log("----Update Query----");
        return CARRE.query(updateQuery, "no prefix", true);
      } else {
        /*Insert query*/
        insertQuery = QUERY.insert(newObj, "risk_factor", "RF", user);
        console.info("-----insertQuery------");
        return CARRE.query(insertQuery, "no prefix", true);
      }
    }

    function getRisk_evidencesFromRisk_Factor(ArrayOfIDs) {
      console.log("getRisk_evidencesFromRisk_Factor", ArrayOfIDs);

      ArrayOfIDs = ArrayOfIDs
        ? ArrayOfIDs instanceof Array
          ? ArrayOfIDs
          : [ArrayOfIDs]
        : [];

      var listQuery =
        "SELECT * FROM " +
        CONFIG.CARRE_DEFAULT_GRAPH +
        " WHERE { \n\
             ?subject a risk:risk_evidence; ?predicate ?object. \n\
             ?subject risk:has_risk_factor ?filter. \n\
             VALUES (?filter) { " +
        ArrayOfIDs.map(function (id) {
          return "(" + id.split("_")[0] + ":" + id + ")";
        }).join(" ") +
        " } \n\
              OPTIONAL {    \n\
               ?object a risk:citation. \n\
               ?object risk:has_citation_pubmed_identifier ?has_citation_pubmed_identifier  \n\
              } \n\
              OPTIONAL {    \n\
               ?object a risk:observable. \n\
               ?object risk:has_observable_name ?has_observable_name  \n\
               FILTER(lang(?has_observable_name)='" +
        CONFIG.LANG +
        "') \n\
              } \n\
              OPTIONAL {    \n\
               ?object a risk:risk_element. \n\
               ?object risk:has_risk_element_name ?has_risk_element_name  \n\
               FILTER(lang(?has_risk_element_name)='" +
        CONFIG.LANG +
        "') \n\
              } \n\
              OPTIONAL {    \n\
               ?object a risk:measurement_type. \n\
               ?object risk:has_measurement_type_name ?has_measurement_type_name  \n\
               FILTER(lang(?has_measurement_type_name)='" +
        CONFIG.LANG +
        "') \n\
              } \n\
              OPTIONAL {    \n\
               ?object a risk:risk_factor.  \n\
               ?object risk:has_risk_factor_association_type ?has_risk_factor_association_type. \n\
               ?object risk:has_risk_factor_source ?has_risk_factor_source. \n\
               ?object risk:has_risk_factor_target ?has_risk_factor_target. \n\
               ?has_risk_factor_source risk:has_risk_element_name ?has_source_risk_element_name.  \n\
               ?has_risk_factor_target risk:has_risk_element_name ?has_target_risk_element_name.  \n\
               FILTER(lang(?has_source_risk_element_name)='" +
        CONFIG.LANG +
        "') \n\
               FILTER(lang(?has_target_risk_element_name)='" +
        CONFIG.LANG +
        "') \n\
              } \n";

      //add filter to query if a single observable is requested
      listQuery += " }";
      return CARRE.selectQuery(listQuery); //,null,'risk_evidences_for_'+ArrayOfIDs.join("_"));
    }

    return this.exports;
  });

/*global angular*/
(function() {
  'use strict';

  angular
    .module('CarreEntrySystem')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider) {
    
    $stateProvider
     
      /*  risk_factors  */
      .state('main.risk_factors', {
        'abstract':true,
        templateUrl: 'app/pages/risk_factors/main.html',
        url: '/risk_factors'
      })
      .state('main.risk_factors.list', {
        controller: 'risk_factorsController',
        controllerAs: 'risk_factors',
        templateUrl: 'app/pages/risk_factors/list.html',
        url: ''
      })
      .state('main.risk_factors.create', {
        templateUrl: 'app/pages/risk_factors/single/single.html',
        controller: 'risk_factorsSingleController',
        controllerAs: 'risk_factor',
        url: '/create',
        data: {
          permissions: {
            only: ['authenticated_user'],
            redirectTo: function(rejectedPromise) {
              window.location.replace(window.location.href.replace('/edit','').replace('/create',''));
            }        
            
          }
        }
      })
      .state('main.risk_factors.edit', {
        templateUrl: 'app/pages/risk_factors/single/single.html',
        controller: 'risk_factorsSingleController',
        controllerAs: 'risk_factor',
        url: '/:id/edit',
        data: {
          permissions: {
            only: ['authenticated_user'],
            redirectTo: function(rejectedPromise) {
              window.location.replace(window.location.href.replace('/edit','').replace('/create',''));
            }        
            
          }
        }
        
      })
      .state('main.risk_factors.view', {
        controller: 'risk_factorsSingleController',
        templateUrl: 'app/pages/risk_factors/single/single.html',
        controllerAs: 'risk_factor',
        url: '/:id'
      });
  }

})();

(function () {
  "use strict";

  angular
    .module("CarreEntrySystem")
    .controller("risk_factorsController", risk_factorsController);

  /** @ngInject */
  function risk_factorsController(
    toastr,
    VisibleFields,
    Risk_factors,
    currentUser,
    CONFIG,
    $stateParams,
    uiGridGroupingConstants,
    $timeout,
    Pubmed,
    uiGridConstants,
    $state,
    content
  ) {
    var vm = this; //controller as vm

    /************** List Template **************/

    var visibleGridColumns = VisibleFields("risk_factor", "list");

    var risk_factors = [];
    vm.gridLoading = Risk_factors.get().then(function (res) {
      risk_factors = res.data;
      vm.mygrid.data = risk_factors;

      console.log("Model response: ", res);
      //make the response available in the view
      vm.res = res;

      /* Reset columns */
      vm.mygrid.columnDefs = [];

      vm.mygrid.columnDefs.push({
        field: "View",
        enableFiltering: false,
        enableColumnMenu: false,
        cellTemplate:
          '<div class="ui-grid-cell-contents"><button type="button" class="btn btn-xs btn-primary" ui-sref="main.risk_factors.view({id:row.entity.id_label})"><i class="fa fa-eye"></i></button></div>',
        width: 60,
      });

      //show edit buttons
      if (currentUser.username) {
        vm.mygrid.columnDefs.push({
          field: "Edit",
          enableFiltering: false,
          enableColumnMenu: false,
          cellTemplate:
            '<div class="ui-grid-cell-contents"><button type="button" class="btn btn-xs btn-primary" ui-sref="main.risk_factors.edit({id:row.entity.id_label})"><i class="fa fa-edit"></i></button></div>',
          width: 60,
        });
      }

      //dynamic creation of the grid columns
      content.fields(res.fields, visibleGridColumns).forEach(function (obj) {
        vm.mygrid.columnDefs.push(obj);
      });

      vm.mygrid.columnDefs.push({
        field: "id_label",
        displayName: "ID",
        visible: false,
      });
    });

    /* GRID Default options */
    vm.mygrid = content.default;
  }
})();

angular
  .module("CarreEntrySystem")
  .service(
    "Risk_elements",
    function ($http, CARRE, CONFIG, QUERY, RdfFormatter) {
      this.exports = {
        get: getRisk_elements,
        save: saveRisk_element,
        associations: RiskElementAssociations,
      };

      function getRisk_elements(ArrayOfIDs) {
        return CARRE.instances("risk_element", ArrayOfIDs);
      }

      function saveRisk_element(oldElem, newElem, user) {
        user = user || CONFIG.currentUser.graphName;
        var updateQuery = "",
          insertQuery = "";
        var newObj = {};
        if (newElem.name.length > 0)
          newObj.has_risk_element_name = {
            pre: "risk",
            value: newElem.name.toString(),
            type: "lang",
          };
        if (newElem.identifier.length > 0)
          newObj.has_risk_element_identifier = {
            pre: "risk",
            value:
              "http://umls.nlm.nih.gov/sab/mth/cui/" +
              newElem.identifier.toString(),
            type: "node",
          };
        if (newElem.type.length > 0)
          newObj.has_risk_element_type = {
            pre: "risk",
            value: newElem.type.toString(),
            type: "node",
          };
        if (newElem.modifiable_status)
          newObj.has_risk_element_modifiable_status = {
            pre: "risk",
            value: newElem.modifiable_status.toString(),
            type: "string",
          };
        if (newElem.observables.length > 0)
          newObj.has_risk_element_observable = {
            pre: "risk",
            value: newElem.observables,
            type: "node",
          };
        if (newElem.risk_elements.length > 0)
          newObj.includes_risk_element = {
            pre: "risk",
            value: newElem.risk_elements,
            type: "node",
          };

        console.log("Old: ", oldElem);
        console.log("New: ", newElem);
        console.log("Mapped: ", newObj);

        /* invalidate risk_element_all */
        CARRE.invalidateCache("risk");
        CARRE.invalidateCache("count_all");

        if (oldElem.id) {
          /*Update query*/
          updateQuery = QUERY.update(oldElem, newObj);
          console.log("----Update Query----");
          return CARRE.query(updateQuery, "no prefix", true);
        } else {
          /*Insert query*/
          insertQuery = QUERY.insert(newObj, "risk_element", "RL", user);
          console.info("-----insertQuery------");
          return CARRE.query(insertQuery, "no prefix", true);
        }
      }

      function RiskElementAssociations(id) {
        var FilterString = "";
        var cache_key = "";
        var filters = [];
        if (id) {
          if (!(id instanceof Array)) {
            //convert to array;
            id = [id];
          } //else it is array

          id.forEach(function (sid, index) {
            //id fix
            var prefix = "";
            if (sid.indexOf("http") === -1) {
              cache_key = cache_key + "_" + sid;
              prefix = sid.split("_")[0];
              sid = prefix + ":" + sid;
            } else {
              cache_key =
                cache_key + "_" + sid.substring(sid.lastIndexOf("/") + 1);
              sid = "<" + sid + ">";
            }

            //now filter depending on id
            if (sid.indexOf("RL") >= 0) {
              filters.push(
                "?has_risk_factor_source=" +
                  sid +
                  "||?has_risk_factor_target=" +
                  sid
              );
            } else if (sid.indexOf("RF") >= 0) {
              filters.push("?subject=" + sid);
            }
          });

          FilterString = "FILTER (" + filters.join("||") + ")";

          //if ids>1 no cache else add prefix
          // if(id.length!==1) cache_key=null;
          cache_key = "risk_associations_for" + cache_key;
        } else cache_key = "risk_associations_for_all";

        var query =
          "SELECT * FROM " +
          CONFIG.CARRE_DEFAULT_GRAPH +
          " \n\
            WHERE { \n\
            ?subject a risk:risk_factor; ?predicate ?object. \n\
             ?subject risk:has_risk_factor_association_type ?has_risk_factor_association_type. \n\
             ?subject risk:has_risk_factor_source ?has_risk_factor_source. \n\
             ?subject risk:has_risk_factor_target ?has_risk_factor_target. \n\
            OPTIONAL {    \n\
             ?object a risk:risk_element. \n\
             ?object risk:has_risk_element_name ?has_risk_element_name  \n\
               FILTER(lang(?has_risk_element_name)='" +
          CONFIG.LANG +
          "') \n\
            } " +
          FilterString +
          " }";

        return CARRE.selectQuery(
          query,
          null,
          CONFIG.USECACHE ? cache_key : null
        ).then(function (res) {
          var graphData = {
            nodes: [],
            edges: [],
          };

          var tmp_nodes = [];
          res.data.forEach(function (rf) {
            var source = {
              label: rf.has_risk_factor_source_label,
              id: rf.has_risk_factor_source[0],
              value: 1,
            };

            var target = {
              label: rf.has_risk_factor_target_label,
              id: rf.has_risk_factor_target[0],
              value: 1,
            };

            var relation = {
              label: rf.has_risk_factor_association_type_label,
              id: rf.id,
            };

            //add the nodes
            var source_index = tmp_nodes.indexOf(source.id);
            if (source_index === -1) {
              tmp_nodes.push(source.id);
              graphData.nodes.push(source);
            } else {
              graphData.nodes[source_index].value++;
            }
            var target_index = tmp_nodes.indexOf(target.id);
            if (target_index === -1) {
              tmp_nodes.push(target.id);
              graphData.nodes.push(target);
            } else {
              graphData.nodes[target_index].value++;
            }

            //add the edges
            graphData.edges.push({
              id: relation.id,
              from: source.id,
              label: relation.label,
              to: target.id,
            });
          });
          console.log("Graph data", graphData);
          return graphData;
        });
      }

      return this.exports;
    }
  );

/*global angular*/
(function() {
  'use strict';

  angular
    .module('CarreEntrySystem')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider) {
   
    $stateProvider
    
      /*  Risk Elements  */
      .state('main.risk_elements', {
        'abstract':true,
        templateUrl: 'app/pages/risk_elements/main.html',
        controller: 'risk_elementsController',
        controllerAs: 'risk_elements',
        url: '/risk_elements'
      })
      .state('main.risk_elements.list', {
        templateUrl: 'app/pages/risk_elements/list.html',
        controller: 'risk_elementsController',
        controllerAs: 'risk_elements',
        url: ''
      })
      .state('main.risk_elements.create', {
        templateUrl: 'app/pages/risk_elements/single/single.html',
        controller: 'risk_elementsSingleController',
        controllerAs: 'risk_element',
        url: '/create',
        data: {
          permissions: {
            only: ['authenticated_user'],
            redirectTo: function(rejectedPromise) {
              window.location.replace(window.location.href.replace('/edit','').replace('/create',''));
            }        
            
          }
        }
      })
      .state('main.risk_elements.view', {
        templateUrl: 'app/pages/risk_elements/single/single.html',
        controller: 'risk_elementsSingleController',
        controllerAs: 'risk_element',
        url: '/:id'
      })
      .state('main.risk_elements.edit', {
        templateUrl: 'app/pages/risk_elements/single/single.html',
        controller: 'risk_elementsSingleController',
        controllerAs: 'risk_element',
        url: '/:id/edit',
        data: {
          permissions: {
            only: ['authenticated_user'],
            redirectTo: function(rejectedPromise) {
              window.location.replace(window.location.href.replace('/edit','').replace('/create',''));
            }
          }
        }
        
      });
  }

})();

(function () {
  "use strict";

  angular
    .module("CarreEntrySystem")
    .controller("risk_elementsController", risk_elementsController);

  /** @ngInject */
  function risk_elementsController(
    toastr,
    currentUser,
    Risk_elements,
    $stateParams,
    CONFIG,
    uiGridGroupingConstants,
    $timeout,
    Pubmed,
    uiGridConstants,
    $state,
    content,
    VisibleFields
  ) {
    var vm = this; //controller as vm

    /************** List Template **************/

    var visibleGridColumns = VisibleFields("risk_element", "list");

    var risk_elements = [];
    vm.gridLoading = Risk_elements.get().then(function (res) {
      risk_elements = res.data;
      vm.mygrid.data = risk_elements;

      console.log("Model response: ", res);
      //make the response available in the view
      vm.res = res;

      /* Reset columns */
      vm.mygrid.columnDefs = [];

      vm.mygrid.columnDefs.push({
        field: "View",
        enableFiltering: false,
        enableColumnMenu: false,
        cellTemplate:
          '<div class="ui-grid-cell-contents"><button type="button" class="btn btn-xs btn-primary" ui-sref="main.risk_elements.view({id:row.entity.id_label})"><i class="fa fa-eye"></i></button></div>',
        width: 60,
      });

      //show edit buttons
      if (currentUser.username) {
        vm.mygrid.columnDefs.push({
          field: "Edit",
          enableFiltering: false,
          enableColumnMenu: false,
          cellTemplate:
            '<div class="ui-grid-cell-contents"><button type="button" class="btn btn-xs btn-primary" ui-sref="main.risk_elements.edit({id:row.entity.id_label})"><i class="fa fa-edit"></i></button></div>',
          width: 60,
        });
      }

      //dynamic creation of the grid columns
      content.fields(res.fields, visibleGridColumns).forEach(function (obj) {
        vm.mygrid.columnDefs.push(obj);
      });

      vm.mygrid.columnDefs.push({
        field: "id_label",
        displayName: "ID",
        visible: false,
      });
    });

    /* GRID Default options */
    vm.mygrid = content.default;
  }
})();

angular
  .module("CarreEntrySystem")
  .service("Risk_evidences", function ($http, CARRE, CONFIG, QUERY) {
    this.exports = {
      get: getRisk_evidences,
      adjusted_for: getRisk_evidenceAdjusted_for,
      save: saveRisk_evidence,
    };

    function getRisk_evidenceAdjusted_for() {
      var query =
        "PREFIX risk: <https://risk.thrombus.eu/ontology/risk.owl#> \n\
              SELECT ?adjusted_for FROM " +
        CONFIG.CARRE_DEFAULT_GRAPH +
        " WHERE { ?subject a risk:risk_evidence; risk:is_adjusted_for ?adjusted_for}";
      return CARRE.query(query, "no prefix").then(function (res) {
        var types = [];
        if (res.data instanceof Array) {
          res.data.forEach(function (obj) {
            var arr = obj.adjusted_for.value.split(",");
            arr.forEach(function (elem) {
              elem = elem.trim().toLocaleLowerCase();
              if (elem.length > 0 && types.indexOf(elem) === -1)
                types.push(elem);
            });
          });
        }
        return types;
      });
    }

    function getRisk_evidences(ArrayOfIDs) {
      return CARRE.instances("risk_evidence", ArrayOfIDs);
    }

    function saveRisk_evidence(oldElem, newElem, user) {
      user = user || CONFIG.currentUser.graphName;
      var updateQuery = "",
        insertQuery = "";
      var newObj = {};

      if (newElem.observables.length > 0)
        newObj.has_risk_evidence_observable = {
          pre: "risk",
          value: newElem.observables,
          type: "node",
        };
      if (newElem.ratio_type.length > 0)
        newObj.has_risk_evidence_ratio_type = {
          pre: "risk",
          value: newElem.ratio_type.toString(),
          type: "node",
        };
      if (newElem.ratio_value)
        newObj.has_risk_evidence_ratio_value = {
          pre: "risk",
          value: newElem.ratio_value,
          type: "decimal",
        };
      if (newElem.confidence_interval_min)
        newObj.has_confidence_interval_min = {
          pre: "risk",
          value: newElem.confidence_interval_min,
          type: "decimal",
        };
      if (newElem.confidence_interval_max)
        newObj.has_confidence_interval_max = {
          pre: "risk",
          value: newElem.confidence_interval_max,
          type: "decimal",
        };
      if (newElem.risk_factor.length > 0)
        newObj.has_risk_factor = {
          pre: "risk",
          value: newElem.risk_factor,
          type: "node",
        };
      if (newElem.evidence_source.length > 0)
        newObj.has_risk_evidence_source = {
          pre: "risk",
          value: newElem.evidence_source.toString(),
          type: "node",
        };
      if (newElem.adjusted_for.length > 0)
        newObj.is_adjusted_for = {
          pre: "risk",
          value: newElem.adjusted_for.join(","),
          type: "string",
        };
      if (newElem.condition.length > 0) {
        newObj.has_observable_condition = {
          pre: "risk",
          value: newElem.condition.toString(),
          type: "string",
        };
        newObj.has_observable_condition_json = {
          pre: "risk",
          value: newElem.condition_json.toString(),
          type: "string",
        };
        newObj.has_observable_condition_text = {
          pre: "risk",
          value: newElem.condition_text.toString(),
          type: "string",
        };
      }

      console.log("Old: ", oldElem);
      console.log("New: ", newElem);
      console.log("Mapped: ", newObj);

      /* invalidate Risk factors and Risk evidences */
      CARRE.invalidateCache("risk_factor_all");
      CARRE.invalidateCache("risk_evidence_all");
      CARRE.invalidateCache("count_all");

      if (oldElem.id) {
        /*Update query*/
        updateQuery = QUERY.update(oldElem, newObj);
        console.log("----Update Query----");
        return CARRE.query(updateQuery, "no prefix", true);
      } else {
        /*Insert query*/
        insertQuery = QUERY.insert(newObj, "risk_evidence", "RV", user);
        console.info("-----insertQuery------");
        return CARRE.query(insertQuery, "no prefix", true);
      }
    }

    return this.exports;
  });

(function () {
  "use strict";

  angular
    .module("CarreEntrySystem")
    .controller("risk_evidencesController", risk_evidencesController);

  /** @ngInject */
  function risk_evidencesController(
    toastr,
    currentUser,
    VisibleFields,
    Risk_evidences,
    CONFIG,
    $stateParams,
    uiGridGroupingConstants,
    $timeout,
    Pubmed,
    uiGridConstants,
    $state,
    content
  ) {
    var vm = this; //controller as vm

    /************** List Template **************/
    var visibleGridColumns = VisibleFields("risk_evidence", "list");

    var risk_evidences = [];
    vm.gridLoading = Risk_evidences.get().then(function (res) {
      risk_evidences = res.data;
      vm.mygrid.data = risk_evidences;

      console.log("Model response: ", res);
      //make the response available in the view
      vm.res = res;

      /* Reset columns */
      vm.mygrid.columnDefs = [];

      vm.mygrid.columnDefs.push({
        field: "View",
        enableFiltering: false,
        enableColumnMenu: false,
        cellTemplate:
          '<div class="ui-grid-cell-contents"><button type="button" class="btn btn-xs btn-primary" ui-sref="main.risk_evidences.view({id:row.entity.id_label})"><i class="fa fa-eye"></i></button></div>',
        width: 60,
      });

      //show edit buttons
      if (currentUser.username) {
        vm.mygrid.columnDefs.push({
          field: "Edit",
          enableFiltering: false,
          enableColumnMenu: false,
          cellTemplate:
            '<div class="ui-grid-cell-contents"><button type="button" class="btn btn-xs btn-primary" ui-sref="main.risk_evidences.edit({id:row.entity.id_label})"><i class="fa fa-edit"></i></button></div>',
          width: 60,
        });
      }

      //dynamic creation of the grid columns
      content.fields(res.fields, visibleGridColumns).forEach(function (obj) {
        vm.mygrid.columnDefs.push(obj);
      });

      vm.mygrid.columnDefs.push({
        field: "id_label",
        displayName: "ID",
        visible: false,
      });
    });

    /* GRID Default options */
    vm.mygrid = content.default;
  }
})();

/*global angular*/
(function() {
  'use strict';

  angular
    .module('CarreEntrySystem')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider) {
    
    
    $stateProvider
  
      /*  risk_evidences  */
      .state('main.risk_evidences', {
        'abstract':true,
        templateUrl: 'app/pages/risk_evidences/main.html',
        url: '/risk_evidences'
      })
      .state('main.risk_evidences.list', {
        controller: 'risk_evidencesController',
        controllerAs: 'risk_evidences',
        templateUrl: 'app/pages/risk_evidences/list.html',
        url: ''
      })
      .state('main.risk_evidences.createWithId', {
        templateUrl: 'app/pages/risk_evidences/single/single.html',
        controller: 'risk_evidencesSingleController',
        controllerAs: 'risk_evidence',
        url: '/create/:pubmedId',
        data: {
          permissions: {
            only: ['authenticated_user'],
            redirectTo: function(rejectedPromise) {
              window.location.replace(window.location.href.replace('/edit','').replace('/create',''));
            }        
            
          }
        }
      })
      .state('main.risk_evidences.create', {
        templateUrl: 'app/pages/risk_evidences/single/single.html',
        controller: 'risk_evidencesSingleController',
        controllerAs: 'risk_evidence',
        url: '/create',
        data: {
          permissions: {
            only: ['authenticated_user'],
            redirectTo: function(rejectedPromise) {
              window.location.replace(window.location.href.replace('/edit','').replace('/create',''));
            }        
            
          }
        }
      })
      .state('main.risk_evidences.edit', {
        templateUrl: 'app/pages/risk_evidences/single/single.html',
        controller: 'risk_evidencesSingleController',
        controllerAs: 'risk_evidence',
        url: '/:id/edit',
        data: {
          permissions: {
            only: ['authenticated_user'],
            redirectTo: function(rejectedPromise) {
              window.location.replace(window.location.href.replace('/edit','').replace('/create',''));
            }            
          }
        }
        
      })
      .state('main.risk_evidences.view', {
        controller: 'risk_evidencesSingleController',
        templateUrl: 'app/pages/risk_evidences/single/single.html',
        controllerAs: 'risk_evidence',
        url: '/:id'
      });
  }

})();

(function() {
  'use strict';

angular.module('CarreEntrySystem').service('Medical_experts', function($http, CARRE, CONFIG, $q) {

  this.exports = {
    'get': getMedical_experts,
    'countFor': countAllInstancesFor,
    'saveProfile': saveMedicalExpertProfile
    // 'insert': insertMedical_expert
  };
    
  CONFIG.medical_experts=CONFIG.medical_experts|| {};
  
  function getMedical_experts(ArrayOfIDs) {
    if(ArrayOfIDs) return CARRE.instances('medical_expert', ArrayOfIDs);
    else if(CONFIG.medical_experts.cache) {
      console.info("CACHE WORKS!");
      return $q(function(resolve, reject) {
        resolve(CONFIG.medical_experts.cache)
        reject();
      });
    }
    else return CARRE.instances('medical_expert', ArrayOfIDs).then(function(res){ 
      CONFIG.medical_experts.cache=res;
      console.info("CACHE LOADED!");
      return res;
    })
  }


  function countAllInstancesFor(medicalExpert) {
    var query = "SELECT ?type (COUNT(?item_authored) AS ?authored) (COUNT(?item_reviewed) AS ?reviewed) \n\
    FROM " + CONFIG.CARRE_DEFAULT_GRAPH + " WHERE { \n\
    {?item_authored risk:has_author ?user; a ?type } UNION {?item_reviewed risk:has_reviewer ?user; a ?type} \n\
    "
    //add filter to query if a single observable is requested
    if (medicalExpert) {
      query += "FILTER ( ?user=<" +medicalExpert+ ">) }";
    }
    else query += "}";
    return CARRE.query(query);
  }

  function saveMedicalExpertProfile(oldElem, newElem, user) {
    
    user = user || CONFIG.currentUser.graphName;
    var updateQuery = "",
      insertQuery = "";
    var newObj = {};
    if (newElem.name.length > 0) newObj.has_risk_element_name = {
      pre: 'risk',
      value: newElem.name.toString(),
      type: "string"
    };
    if (newElem.identifier.length > 0) newObj.has_risk_element_identifier = {
      pre: 'risk',
      value: "http://umls.nlm.nih.gov/sab/mth/cui/" + newElem.identifier.toString(),
      type: "node"
    };
    if (newElem.type.length > 0) newObj.has_risk_element_type = {
      pre: 'risk',
      value: newElem.type.toString(),
      type: "node"
    };
    if (newElem.modifiable_status.length > 0) newObj.has_risk_element_modifiable_status = {
      pre: 'risk',
      value: newElem.modifiable_status.toString(),
      type: "string"
    };
    if (newElem.observables.length > 0) newObj.has_risk_element_observable = {
      pre: 'risk',
      value: newElem.observables,
      type: "node"
    };
    if (newElem.risk_elements.length > 0) newObj.includes_risk_element = {
      pre: 'risk',
      value: newElem.risk_elements,
      type: "node"
    };


    console.log('Old: ', oldElem);
    console.log('New: ', newElem);
    console.log('Mapped: ', newObj);

    /* invalidate risk_element_all */
    CARRE.invalidateCache('risk');
    CARRE.invalidateCache('count_all');

    if (oldElem.id) {
      /*Update query*/
      updateQuery = QUERY.update(oldElem, newObj);
      console.log('----Update Query----');
      return CARRE.query(updateQuery, 'no prefix');
    }
    else {
      /*Insert query*/
      insertQuery = QUERY.insert(newObj, "risk_element", "RL", user);
      console.info('-----insertQuery------');
      return CARRE.query(insertQuery, 'no prefix');
    }

  }

  return this.exports;

});

})();
/*global angular*/
(function() {
  'use strict';

  angular
    .module('CarreEntrySystem')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider) {
    

    
    $stateProvider
    
      /*  Medical Experts  */
      .state('main.medical_experts', {
        'abstract':true,
        templateUrl: 'app/pages/medical_experts/main.html',
        url: '/medical_experts'
      })
      .state('main.medical_experts.list', {
        controller: 'medical_expertsController',
        controllerAs: 'medical_experts',
        templateUrl: 'app/pages/medical_experts/list.html',
        url: ''
      })
      .state('main.medical_experts.view', {
        controller: 'medical_expertsSingleController',
        templateUrl: 'app/pages/medical_experts/single/view.html',
        controllerAs: 'medical_expert',
        url: '/:id'
      });
  }

})();

(function() {
  'use strict';

  angular
    .module('CarreEntrySystem')
    .controller('medical_expertsController', medical_expertsController);

  /** @ngInject */
  function medical_expertsController(Bioportal, toastr, Medical_experts, CONFIG, $stateParams, uiGridGroupingConstants, $timeout, Pubmed, uiGridConstants, $state , content) {
    var vm = this; //controller as vm
    
    
    var visibleGridColumns=[
      "has_firstname",
      "has_lastname",
      "has_medical_specialty_identifier",
      "has_medical_position",
      "has_short_cv",
      "has_personal_page_url",
      "has_user_graph",
      "has_avatar",
      "is_coordinator_of_team",
      "has_team_name"
      ];
    
    
    /************** List Template **************/
    
    var medical_experts = [];
    vm.gridLoading=Medical_experts.get().then(function(res) {
      vm.users = res.data;
      
      console.log('Model response: ', res);
      //make the response available in the view
      vm.res = res;

    });

  }
})();

angular.module('CarreEntrySystem').service('GRAPH', function(CONFIG,CARRE,RdfFormatter) {
    
  this.exports = {
    'network': getNetworkData,
    'FindIndex':FindIndex,
    'ratioMinMax':ratioMinMax,
    'ratioType':ratioType,
  };
  
  // global functions --- not a good practice
  function FindIndex(arr,val,prop,propVal){
    prop = prop || 'id';
    if(propVal) val=val[propVal];
    for (var i=0;i<arr.length;i++){
      if(val===arr[i][prop]) return i;
    }
    return -1;
  };
  
  function ratioMinMax(evidences){
    if(!evidences || evidences.length===0) return '';
    var arr=evidences.map(function(rv){return isNaN(rv.rv_ratio_value)?1:parseFloat(rv.rv_ratio_value); }).sort();
    return ": "+ (arr.length===1?arr[0]:arr[0]+"..."+arr[arr.length-1]);
  };
  
  function ratioType(val){
    return val.substring(val.lastIndexOf("risk_evidence_ratio_type_")+25).replace("_"," "); 
  };
  
  //Returns a Tree ( RF: {RL_source,RL_target,RV:{OB:[],.. })
  function getNetworkData(idFilter,edgeType){
    edgeType = edgeType || "risk_evidence";
    var FilterString="";
    var cache_key="";
    var filters=[];
    if(idFilter){
      if(!(idFilter instanceof Array)) {
        //convert to array;
        idFilter = [idFilter];
      } //else it is array
      
      idFilter.forEach(function(sid,index){
        //id fix
        var prefix = "";
        if (sid.indexOf("http") === -1) {
          cache_key=cache_key+"_"+sid;
          prefix = sid.split("_")[0];
          sid = prefix + ":" + sid;
        } else {
          cache_key=cache_key+"_"+sid.substring(sid.lastIndexOf("/")+1);
          sid = "<" + sid + ">";
        }
        
        //now filter depending on id
        if(sid.indexOf("RL")>=0){
          filters.push("?has_risk_factor_source="+sid+"||?has_risk_factor_target="+sid);
        } else if(sid.indexOf("RF")>=0) {
          filters.push("?risk_factor="+sid);
        } else if(sid.indexOf("RV")>=0) {
          filters.push("?has_risk_evidence="+sid);
        } else if(sid.indexOf("OB")>=0) {
          filters.push("?has_risk_evidence_observable="+sid);
        }
      });
        
      FilterString="FILTER ("+filters.join("||")+")";
      
      //if ids>1 no cache else add prefix
      // if(id.length!==1) cache_key=null;
      cache_key="risk_associations_for"+cache_key;
      
    } else cache_key="risk_associations_for_all";
    
     var query = "SELECT * FROM " + CONFIG.CARRE_DEFAULT_GRAPH + " \n\
            WHERE { \n\
            ?risk_factor a risk:risk_factor. \n\
            ?risk_factor risk:has_risk_factor_association_type ?has_risk_factor_association_type. \n\
            ?risk_factor risk:has_risk_factor_source ?has_risk_factor_source. \n\
            ?risk_factor risk:has_risk_factor_target ?has_risk_factor_target. \n\
            ?has_risk_factor_source risk:has_risk_element_name ?has_risk_source_element_name. \n\
            ?has_risk_factor_target risk:has_risk_element_name ?has_risk_target_element_name. \n\
            ?has_risk_evidence a risk:risk_evidence; \n\
            risk:has_risk_factor ?risk_factor; \n\
            risk:has_risk_evidence_ratio_value ?has_risk_evidence_ratio_value; \n\
            risk:has_risk_evidence_ratio_type ?has_risk_evidence_ratio_type; \n\
            risk:has_observable_condition_text ?has_observable_condition_text; \n\
            risk:has_risk_evidence_observable ?has_risk_evidence_observable. \n\
            ?has_risk_evidence_observable risk:has_observable_name ?has_risk_evidence_observable_name. \n\
            # language filters \n\
            FILTER(lang(?has_risk_source_element_name)='"+CONFIG.LANG+"') \n\
            FILTER(lang(?has_risk_target_element_name)='"+CONFIG.LANG+"') \n\
            FILTER(lang(?has_risk_evidence_observable_name)='"+CONFIG.LANG+"') \n\
            "+ FilterString+" }";
            
    return CARRE.selectQuery(query,'raw',(CONFIG.USECACHE?cache_key:null)).then(function(res) {

      var formattedData=res.data.reduce(function(init,cur){
        var val=init.valueProp;
        //construct risk factor element tree
        var rf_index=cur.risk_factor[val].substring(cur.risk_factor[val].lastIndexOf('/')+1);
        var rf={
          rf_id:cur.risk_factor[val],
          rf_type:cur.has_risk_factor_association_type[val],
          rf_source_id:cur.has_risk_factor_source[val],
          rf_source_label:cur.has_risk_source_element_name[val],
          rf_target_id:cur.has_risk_factor_target[val],
          rf_target_label:cur.has_risk_target_element_name[val],
          rf_evidences:[]
        };
        var rv_index=rf_index+'_'+cur.has_risk_evidence[val].substring(cur.has_risk_evidence[val].lastIndexOf('/')+1);
        var rv={
          rv_id:cur.has_risk_evidence[val],
          rv_observable_condition:cur.has_observable_condition_text[val],
          rv_ratio_value:cur.has_risk_evidence_ratio_value[val],
          rv_ratio_type:cur.has_risk_evidence_ratio_type[val],
          rv_observables:[]
        };
        var ob={
          ob_id:cur.has_risk_evidence_observable[val],
          ob_label:cur.has_risk_evidence_observable_name[val]
        };
        var rf_pos=init.index[rf_index];
        var rv_pos=init.index[rv_index];
        
        if (!rf_pos && rf_pos!==0) {
          rv.rv_observables.push(ob);
          rf.rf_evidences.push(rv);
          init.data.push(rf);
          init.index[rv_index] = 0;
          init.index[rf_index] = init.data.indexOf(rf);
        }
        else if (!rv_pos && rv_pos!==0) {
          rv.rv_observables.push(ob);
          init.data[rf_pos].rf_evidences.push(rv);
          init.index[rv_index] = init.data[rf_pos].rf_evidences.indexOf(rv);
        }
        else {
          init.data[rf_pos].rf_evidences[rv_pos].rv_observables.push(ob);
        }
        
        return init;
          
      },{data:[],index:{},valueProp:'value'});
      
      console.log("Graph Formatter: ",formattedData);
      
      var graphData = {
        nodes:[],
        edges:[]
      };
        
      var tmp_nodes=[];
      formattedData.data.forEach(function(rf) {
      
        var source = {
          label: rf.rf_source_label,
          id: rf.rf_source_id,
          connections:0
        };

        var target = {
          label: rf.rf_target_label,
          id: rf.rf_target_id,
          connections:0
        };

        var relation = {
          label: RdfFormatter.translate(rf.rf_type),
          id: rf.rf_id,
          evidences:rf.rf_evidences
        };

        //add the nodes
        var source_index=tmp_nodes.indexOf(source.id);
        if(source_index===-1) {
          tmp_nodes.push(source.id);
          graphData.nodes.push(source);
        } else {
          graphData.nodes[source_index].connections++;
        }
        var target_index=tmp_nodes.indexOf(target.id);
        if(target_index===-1) {
          tmp_nodes.push(target.id);
          graphData.nodes.push(target);
        } else {
          graphData.nodes[target_index].connections++;
        }
        if(edgeType==='risk_factor') { 
          graphData.edges.push({
              id:relation.id, 
              source:source.id,
              target:target.id,
              from:source.id, 
              label:relation.label, 
              to:target.id,
              evidences:relation.evidences
            });
          } else { //risk evidences
          
          relation.evidences.forEach(function(rv){
            var ratio=isNaN(rv.rv_ratio_value)?1:parseFloat(rv.rv_ratio_value);
            //add the edges
            graphData.edges.push({
              risk_factor:relation.id,
              id:rv.rv_id, 
              source:source.id,
              target:target.id,
              from:source.id, 
              label:relation.label, 
              to:target.id, 
              ratio:ratio,
              ratio_type:rv.rv_ratio_type,
              observables:rv.rv_observables
            });
            
          });
        
        }

      });
      
      console.log(graphData);
      return graphData;

    });
  }


    return this.exports;
});
/*global angular*/
(function() {
  'use strict';

  angular
    .module('CarreEntrySystem')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider) {
    
    $stateProvider
      .state('main.explore', {
        controller: 'ExploreController',
        controllerAs: 'explore',
        url: '/explore',
        templateUrl: 'app/pages/explore/index.html'
      })
      // .state('main.mineLiterature', {
      //   controller: function(){},
      //   url: '/mine-literature',
      //   templateUrl: 'app/pages/explore/mine-literature.html'
      // });
  }

})();

(function() {
  'use strict';

  angular
    .module('CarreEntrySystem')
    .controller('ExploreController', ExploreController);

  /** @ngInject */
  function ExploreController($rootScope, $timeout, toastr, CARRE, $location, CONFIG, $scope, Email, Risk_elements,$state,$http,GRAPH, Risk_factors) {
    var vm = this;
    vm.minConnections=0;
    vm.ready=true;
    vm.risk_elements_selected=[];
    vm.graph_type=$location.search().graphtype||"sankey";
    console.log("Explore state params:",$state.params)
    vm.setNewId=function(){
      vm.ready=false;
      $timeout(function(){
        vm.id=vm.risk_elements_selected;
        vm.ready=true;
      },100)
    }
    vm.examples=[
    {
      "label":"Connections between diabetes,hypertension and colorectal cancer",
      "data":["https://risk.thrombus.eu/risk_elements/RL_29","https://risk.thrombus.eu/risk_elements/RL_19","https://risk.thrombus.eu/risk_elements/RL_14"]
    },{
      "label":"How do obesity, diabetes and depression relate with each other?",
      "data":["https://risk.thrombus.eu/risk_elements/RL_38","https://risk.thrombus.eu/risk_elements/RL_19","https://risk.thrombus.eu/risk_elements/RL_18"]
    },
    {
      "label": "a complex one",
      "data": ["https://risk.thrombus.eu/risk_elements/RL_19","https://risk.thrombus.eu/risk_elements/RL_33", "https://risk.thrombus.eu/risk_elements/RL_36", "https://risk.thrombus.eu/risk_elements/RL_38", "https://risk.thrombus.eu/risk_elements/RL_25"]
    },
    {
      "label":"too complex to read",
      "data":["https://risk.thrombus.eu/risk_elements/RL_19","https://risk.thrombus.eu/risk_elements/RL_33","https://risk.thrombus.eu/risk_elements/RL_36","https://risk.thrombus.eu/risk_elements/RL_38","https://risk.thrombus.eu/risk_elements/RL_25","https://risk.thrombus.eu/risk_elements/RL_7","https://risk.thrombus.eu/risk_elements/RL_10","https://risk.thrombus.eu/risk_elements/RL_11","https://risk.thrombus.eu/risk_elements/RL_18","https://risk.thrombus.eu/risk_elements/RL_22","https://risk.thrombus.eu/risk_elements/RL_9","https://risk.thrombus.eu/risk_elements/RL_29","https://risk.thrombus.eu/risk_elements/RL_16","https://risk.thrombus.eu/risk_elements/RL_31","https://risk.thrombus.eu/risk_elements/RL_40"]
    },
    // {
    //   "label":"Demo test from unknown user",
    //   "data":["https://risk.thrombus.eu/risk_elements/RL_19","https://risk.thrombus.eu/risk_elements/RL_33","https://risk.thrombus.eu/risk_elements/RL_36","https://risk.thrombus.eu/risk_elements/RL_38","https://risk.thrombus.eu/risk_elements/RL_25"]
    // }
    ];
    
    vm.recommendPopoverUrl="recommendExampleTemplate.html";
    vm.recommendExample=function(label,items){
      var data={
        label:label,
        data:vm.risk_elements_selected
      }
      Email.example(data);
    }
    
    //play with colors
    $scope.refreshColors=function(){
      var elems=angular.element('.ui-select-match-item');
      angular.forEach(elems, function( el,index ){
         angular.element(el).css('background',CONFIG.COLORS[index]);
      });
    }
    
    //add item programmatically
    function addItem(item){
      vm.risk_elements_selected.push(item);
      $timeout(function(){$scope.refreshColors()},50);
    }
    
    //example #1
    $scope.runExample=function(exampleItems){
      var timeInterval=500;
      vm.risk_elements_selected=[];
      exampleItems.forEach(function(url,index,arr){
        $timeout(function(){ addItem(url); },index*timeInterval);
      });
      $timeout(function(){ vm.setNewId(); },exampleItems.length*timeInterval);
    }
    
    //get risk elements
    Risk_elements.get().then(function(res) {
      vm.risk_elements = res.data.map(function(rl) {
          var obj={
            value: rl.id,
            label: rl.has_risk_element_name_label
          };
          return obj;
      });
    });
    
    
    // set elements by url
    if($location.search().elements&&$location.search().elementstype){
      vm.risk_elements_selected = $location.search().elements.split(',').map(function(elem){
        return "https://risk.thrombus.eu/"+$location.search().elementstype+"/"+elem;
      })
      vm.setNewId();
    }
    
  }
})();

angular
  .module("CarreEntrySystem")
  .service("Observables", function ($http, CARRE, CONFIG, QUERY) {
    this.exports = {
      get: getObservables,
      save: saveObservable,
    };

    function getObservables(ArrayOfIDs) {
      return CARRE.instances("observable", ArrayOfIDs);
    }

    function saveObservable(oldElem, newElem, user) {
      user = user || CONFIG.currentUser.graphName;
      var updateQuery = "",
        insertQuery = "";
      var newObj = {};
      if (newElem.name.length > 0)
        newObj.has_observable_name = {
          pre: "risk",
          value: newElem.name.toString(),
          type: "lang",
        };
      if (newElem.type.length > 0)
        newObj.has_observable_type = {
          pre: "risk",
          value: newElem.type.toString(),
          type: "node",
        };
      if (newElem.measurement_type.length > 0)
        newObj.has_observable_measurement_type = {
          pre: "risk",
          value: newElem.measurement_type.toString(),
          type: "node",
        };
      if (newElem.identifier.length > 0)
        newObj.has_external_type = {
          pre: "risk",
          value: newElem.identifier.toString(),
          type: "node",
        };
      if (newElem.predicate.length > 0)
        newObj.has_external_predicate = {
          pre: "risk",
          value: newElem.predicate.toString(),
          type: "node",
        };

      console.log("Old: ", oldElem);
      console.log("New: ", newElem);
      console.log("Mapped: ", newObj);

      /* invalidate observable_all */
      CARRE.invalidateCache("observable_all");
      CARRE.invalidateCache("count_all");

      if (oldElem.id) {
        /*Update query*/
        updateQuery = QUERY.update(oldElem, newObj);
        console.log("----Update Query----");
        return CARRE.query(updateQuery, "no prefix", true);
      } else {
        /*Insert query*/
        insertQuery = QUERY.insert(newObj, "observable", "OB", user);
        console.info("-----insertQuery------");
        return CARRE.query(insertQuery, "no prefix", true);
      }
    }

    return this.exports;
  });

/*global angular*/
(function() {
  'use strict';

  angular
    .module('CarreEntrySystem')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider) {
  
    $stateProvider

      /*  Observables  */
      .state('main.observables', {
        'abstract':true,
        templateUrl: 'app/pages/observables/main.html',
        url: '/observables'
      })
      .state('main.observables.list', {
        controller: 'observablesController',
        controllerAs: 'observables',
        templateUrl: 'app/pages/observables/list.html',
        url: ''
      })
      .state('main.observables.create', {
        templateUrl: 'app/pages/observables/single/single.html',
        controller: 'observablesSingleController',
        controllerAs: 'observable',
        url: '/create',
        data: {
          permissions: {
            only: ['authenticated_user'],
            redirectTo: function(rejectedPromise) {
              window.location.replace(window.location.href.replace('/edit','').replace('/create',''));
            }        
            
          }
        }
      })
      .state('main.observables.edit', {
        templateUrl: 'app/pages/observables/single/single.html',
        controller: 'observablesSingleController',
        controllerAs: 'observable',
        url: '/:id/edit',
        data: {
          permissions: {
            only: ['authenticated_user'],
            redirectTo: function(rejectedPromise) {
              window.location.replace(window.location.href.replace('/edit','').replace('/create',''));
            }        
            
          }
        }
        
      })
      .state('main.observables.view', {
        controller: 'observablesSingleController',
        templateUrl: 'app/pages/observables/single/single.html',
        controllerAs: 'observable',
        url: '/:id'
      });
  }

})();

(function () {
  "use strict";

  angular
    .module("CarreEntrySystem")
    .controller("observablesController", observablesController);

  /** @ngInject */
  function observablesController(
    toastr,
    currentUser,
    Observables,
    CONFIG,
    $stateParams,
    uiGridGroupingConstants,
    $timeout,
    Pubmed,
    uiGridConstants,
    $state,
    content,
    VisibleFields
  ) {
    var vm = this; //controller as vm

    /************** List Template **************/
    var visibleGridColumns = VisibleFields("observable", "list");

    var observables = [];
    vm.gridLoading = Observables.get().then(function (res) {
      observables = res.data;
      vm.mygrid.data = observables;

      console.log("Model response: ", res);
      //make the response available in the view
      vm.res = res;

      /* Reset columns */
      vm.mygrid.columnDefs = [];

      vm.mygrid.columnDefs.push({
        field: "View",
        enableFiltering: false,
        enableColumnMenu: false,
        cellTemplate:
          '<div class="ui-grid-cell-contents"><button type="button" class="btn btn-xs btn-primary" ui-sref="main.observables.view({id:row.entity.id_label})"><i class="fa fa-eye"></i></button></div>',
        width: 60,
      });

      //show edit buttons
      if (currentUser.username) {
        vm.mygrid.columnDefs.push({
          field: "Edit",
          enableFiltering: false,
          enableColumnMenu: false,
          cellTemplate:
            '<div class="ui-grid-cell-contents"><button type="button" class="btn btn-xs btn-primary" ui-sref="main.observables.edit({id:row.entity.id_label})"><i class="fa fa-edit"></i></button></div>',
          width: 60,
        });
      }

      //dynamic creation of the grid columns
      content.fields(res.fields, visibleGridColumns).forEach(function (obj) {
        vm.mygrid.columnDefs.push(obj);
      });

      vm.mygrid.columnDefs.push({
        field: "id_label",
        displayName: "ID",
        visible: false,
      });
    });

    /* GRID Default options */
    vm.mygrid = content.default;
  }
})();

/*global angular*/
(function() {
  'use strict';

  angular
    .module('CarreEntrySystem')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider) {
    
    $stateProvider
      .state('main.dashboard', {
        controller: 'DashboardController',
        controllerAs: 'dashboard',
        url: '/',
        templateUrl: 'app/pages/dashboard/index.html'
      });
  }

})();

(function () {
  "use strict";

  angular
    .module("CarreEntrySystem")
    .controller("DashboardController", DashboardController);

  /** @ngInject */
  function DashboardController(
    $rootScope,
    $timeout,
    toastr,
    CARRE,
    $location,
    CONFIG,
    $scope,
    Email
  ) {
    var vm = this;

    //graph init
    vm.countAllInit = 0;
    vm.countAll = 0;

    vm.colors = CONFIG.COLORS;
    console.log(vm.colors);
    vm.counterchart_labels = [
      // "Medical Experts",
      "Risk Factors",
      "Risk Evidences",
      "Risk Elements",
      "Observables",
      "Citations",
      // "Measurement Types",
    ];
    vm.counterchart_data = [];
    vm.counterchart_data[0] = [0, 0, 0, 0, 0];

    //event on create method
    $scope.$on("create", function (event, chart) {
      // set colors for each bar
      if (
        chart &&
        chart.datasets &&
        chart.datasets[0] &&
        chart.datasets[0].bars.length > 0
      ) {
        chart.datasets[0].bars.map(function (obj, index) {
          obj.fillColor = vm.colors[index];
          obj.strokeColor = "#FFF";
          return obj;
        });
      } else {
        Email.bug({
          title: "chart datasets not exist",
          data: chart.datasets[0],
        });
        console.log("chart datasets not exist");
        $timeout(function () {
          chart.datasets[0].bars.map(function (obj, index) {
            obj.fillColor = vm.colors[index];
            obj.strokeColor = "#FFF";
            return obj;
          });
        }, 200);
      }
    });

    //get total and unreviewed elements

    CARRE.countAll().then(function (res) {
      var r = res.data[0];
      console.log("Counter data:", r);

      vm.citations = {
        total: Number(r.citations.value),
      };
      vm.measurement_types = {
        total: Number(r.measurement_types.value),
      };
      vm.observables = {
        total: Number(r.observables.value),
        noreviews: Number(r.observables_unreviewed.value),
      };
      vm.risk_elements = {
        total: Number(r.risk_elements.value),
        noreviews: Number(r.risk_elements_unreviewed.value),
      };
      vm.risk_evidences = {
        total: Number(r.risk_evidences.value),
        noreviews: Number(r.risk_evidences_unreviewed.value),
      };
      vm.risk_factors = {
        total: Number(r.risk_factors.value),
        noreviews: Number(r.risk_factors_unreviewed.value),
      };
      // vm.medical_experts = {
      //   total:Number(r.risk_factors.value),
      //   noreviews:Number(r.risk_factors_unreviewed.value)
      // };

      //set data for the graph
      vm.counterchart_data[0][0] = vm.risk_factors.total;
      vm.counterchart_data[0][1] = vm.risk_evidences.total;
      vm.counterchart_data[0][2] = vm.risk_elements.total;
      vm.counterchart_data[0][3] = vm.observables.total;
      // vm.counterchart_data[0][0]=vm.measurement_types.total;
      vm.counterchart_data[0][4] = vm.citations.total;

      //set top counter
      vm.countAll =
        vm.citations.total +
        vm.risk_elements.total +
        vm.risk_factors.total +
        vm.risk_evidences.total +
        vm.observables.total +
        vm.measurement_types.total;

      /* Donut graph temp */
      vm.counterdonut_data = [
        vm.risk_factors.total,
        vm.risk_evidences.total,
        vm.risk_elements.total,
        vm.observables.total,
        vm.citations.total,
      ];
      vm.counterdonut_labels = vm.counterchart_labels;
      vm.counterdonut_options = {};
    });
  }
})();

angular
  .module("CarreEntrySystem")
  .service("Measurement_types", function ($http, CARRE, CONFIG, QUERY) {
    this.exports = {
      get: getMeasurement_types,
      save: saveMeasurement_type,
    };

    function getMeasurement_types(ArrayOfIDs) {
      return CARRE.instances("measurement_type", ArrayOfIDs);
    }

    function saveMeasurement_type(oldElem, newElem, user) {
      user = user || CONFIG.currentUser.graphName;
      var updateQuery = "",
        insertQuery = "";
      var newObj = {};
      /*
      //Init Form object
        $scope.measurement_type = {
          name: $scope.model.has_measurement_type_name_label,
          unit: $scope.model.has_label_label||"",
          datatype: $scope.model.has_datatype_label
        };
    */
      if (newElem.name.length > 0)
        newObj.has_measurement_type_name = {
          pre: "risk",
          value: newElem.name.toString(),
          type: "lang",
        };
      if (newElem.unit.length > 0)
        newObj.has_label = {
          pre: "risk",
          value: newElem.unit.toString(),
          type: "string",
        };
      if (newElem.datatype.length > 0)
        newObj.has_datatype = {
          pre: "risk",
          value: newElem.datatype.toString(),
          type: "string",
        };
      if (newElem.has_enumeration_values.length > 0)
        newObj.has_enumeration_values = {
          pre: "risk",
          value: newElem.has_enumeration_values.toString(),
          type: "string",
        };
      if (newElem.identifier.length > 0)
        newObj.has_external_unit = {
          pre: "risk",
          value: newElem.identifier.toString(),
          type: "string",
        };

      console.log("Old: ", oldElem);
      console.log("New: ", newElem);
      console.log("Mapped: ", newObj);

      /* invalidate measurement_type_all */
      CARRE.invalidateCache("measurement_type_all");
      CARRE.invalidateCache("count_all");

      if (oldElem.id) {
        /*Update query*/
        updateQuery = QUERY.update(oldElem, newObj);
        console.log("----Update Query----");
        return CARRE.query(updateQuery, "no prefix", true);
      } else {
        /*Insert query*/
        insertQuery = QUERY.insert(newObj, "measurement_type", "ME", user);
        console.info("-----insertQuery------");
        return CARRE.query(insertQuery, "no prefix", true);
      }
    }

    return this.exports;
  });

/*global angular*/
(function() {
  'use strict';

  angular
    .module('CarreEntrySystem')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider) {
    
    $stateProvider
    
      /*  Measurement Types  */
      .state('main.measurement_types', {
        'abstract':true,
        templateUrl: 'app/pages/measurement_types/main.html',
        url: '/measurement_types'
      })
      .state('main.measurement_types.list', {
        controller: 'measurement_typesController',
        controllerAs: 'measurement_types',
        templateUrl: 'app/pages/measurement_types/list.html',
        url: ''
      })
      .state('main.measurement_types.create', {
        templateUrl: 'app/pages/measurement_types/single/single.html',
        controller: 'measurement_typesSingleController',
        controllerAs: 'measurement_type',
        url: '/create',
        data: {
          permissions: {
            only: ['authenticated_user'],
            redirectTo: function(rejectedPromise) {
              window.location.replace(window.location.href.replace('/edit','').replace('/create',''));
            }        
            
          }
        }
      })
      .state('main.measurement_types.edit', {
        templateUrl: 'app/pages/measurement_types/single/single.html',
        controller: 'measurement_typesSingleController',
        controllerAs: 'measurement_type',
        url: '/:id/edit',
        data: {
          permissions: {
            only: ['authenticated_user'],
            redirectTo: function(rejectedPromise) {
              window.location.replace(window.location.href.replace('/edit','').replace('/create',''));
            }        
            
          }
        }
        
      })
      .state('main.measurement_types.view', {
        controller: 'measurement_typesSingleController',
        templateUrl: 'app/pages/measurement_types/single/single.html',
        controllerAs: 'measurement_type',
        url: '/:id'
      });
  }

})();

(function () {
  "use strict";

  angular
    .module("CarreEntrySystem")
    .controller("measurement_typesController", measurement_typesController);

  /** @ngInject */
  function measurement_typesController(
    toastr,
    currentUser,
    Measurement_types,
    CONFIG,
    $stateParams,
    uiGridGroupingConstants,
    $timeout,
    Pubmed,
    uiGridConstants,
    $state,
    content,
    VisibleFields
  ) {
    var vm = this; //controller as vm

    var visibleGridColumns = VisibleFields("measurement_type", "list");

    /************** List Template **************/

    var measurement_types = [];
    vm.gridLoading = Measurement_types.get().then(function (res) {
      measurement_types = res.data;
      vm.mygrid.data = measurement_types;

      console.log("Model response: ", res);
      //make the response available in the view
      vm.res = res;

      /* Reset columns */
      vm.mygrid.columnDefs = [];

      vm.mygrid.columnDefs.push({
        field: "View",
        enableFiltering: false,
        enableColumnMenu: false,
        cellTemplate:
          '<div class="ui-grid-cell-contents"><button type="button" class="btn btn-xs btn-primary" ui-sref="main.measurement_types.view({id:row.entity.id_label})"><i class="fa fa-eye"></i></button></div>',
        width: 60,
      });

      //show edit buttons
      if (currentUser.username) {
        vm.mygrid.columnDefs.push({
          field: "Edit",
          enableFiltering: false,
          enableColumnMenu: false,
          cellTemplate:
            '<div class="ui-grid-cell-contents"><button type="button" class="btn btn-xs btn-primary" ui-sref="main.measurement_types.edit({id:row.entity.id_label})"><i class="fa fa-edit"></i></button></div>',
          width: 60,
        });
      }

      //dynamic creation of the grid columns
      content.fields(res.fields, visibleGridColumns).forEach(function (obj) {
        vm.mygrid.columnDefs.push(obj);
      });

      vm.mygrid.columnDefs.push({
        field: "id_label",
        displayName: "ID",
        visible: false,
      });
    });

    /* GRID Default options */
    vm.mygrid = content.default;
  }
})();

'use strict';

/**
 * @ngdoc directive
 * @name izzyposWebApp.directive:adminPosHeader
 * @description
 * # adminPosHeader
 */
angular.module('CarreEntrySystem')
    .directive('stats',function() {
    	return {
  		templateUrl:'app/components/stats/stats.html',
  		restrict:'E',
  		replace:true,
  		scope: {
        'model': '=',
        'comments': '@',
        'number': '@',
        'name': '@',
        'title': '@',
        'color': '@',
        'details':'@',
        'type':'@',
        'goto':'@'
  		},
  		// controller:function($scope){
  		    
  		//     $scope.setStyle=function(hexColor){
  		//         if(!hexColor) return "";
  		//         if(hexColor.indexOf("#")===-1) return "";
  		//         var rgb=hexToRgb(hexColor);
  		//         var bgcolor='rgba('+rgb.r+', '+rgb.g+', '+rgb.b+', 1)';
  		//         console.log(bgcolor);
  		//         return {'background-color':bgcolor};
  		//     }
  		    
  		//     function hexToRgb(hex) {
    //             // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
    //             var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    //             hex = hex.replace(shorthandRegex, function(m, r, g, b) {
    //                 return r + r + g + g + b + b;
    //             });
            
    //             var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    //             return result ? {
    //                 r: parseInt(result[1], 16),
    //                 g: parseInt(result[2], 16),
    //                 b: parseInt(result[3], 16)
    //             } : null;
    //         }

  		// }
  		
  	}
  });

angular
  .module("CarreEntrySystem")
  .service("Citations", function ($http, CARRE, CONFIG, QUERY) {
    this.exports = {
      types: getCitationTypes,
      get: getCitations,
      save: saveCitation,
    };

    function getCitations(ArrayOfIDs) {
      return CARRE.instances("citation", ArrayOfIDs);
    }

    function getCitationTypes() {
      var query =
        "PREFIX risk: <https://risk.thrombus.eu/ontology/risk.owl#> \n\
              SELECT ?citationType FROM " +
        CONFIG.CARRE_DEFAULT_GRAPH +
        " WHERE { ?subject a risk:citation; risk:has_citation_source_type ?citationType}";
      return CARRE.query(query, "no prefix").then(function (res) {
        var types = [];
        if (res.data instanceof Array) {
          res.data.forEach(function (obj) {
            var type = obj.citationType.value;
            if (type.length > 0 && types.indexOf(type) === -1) types.push(type);
          });
        }
        return types;
      });
    }

    function saveCitation(oldElem, newElem, user) {
      console.log("Inserted citation by ", CONFIG.currentUser.graphName);
      user = user || CONFIG.currentUser.graphName;
      var newObj = mapper(newElem);
      console.log("Old: ", oldElem);
      console.log("New: ", newElem);
      console.log("Mapped: ", newObj);

      /* invalidate citation_all */
      CARRE.invalidateCache("citation_all");
      CARRE.invalidateCache("count_all");

      var updateQuery = "",
        insertQuery = "";

      if (oldElem.id) {
        /*Update query*/
        updateQuery = QUERY.update(oldElem, newObj);
        console.log("----Update Query----");
        return CARRE.query(updateQuery, "no prefix", true);
      } else {
        /*Insert query*/
        insertQuery = QUERY.insert(newObj, "citation", "CI", user);
        console.info("-----insertQuery------");
        return CARRE.query(insertQuery, "no prefix", true);
      }
    }

    //map the final object to rdf properties
    function mapper(obj) {
      return {
        has_citation_source_type: {
          pre: "risk",
          value: obj.type.toString(),
          type: "string",
        },
        has_citation_source_level: {
          pre: "risk",
          value: obj.level.toString(),
          type: "integer",
        },
        has_citation_summary: {
          pre: "risk",
          value: obj.summary.toString(),
          type: "string",
        },
        has_citation_pubmed_identifier: {
          pre: "risk",
          value: obj.pubmedId.toString(),
          type: "string",
        },
      };
    }

    return this.exports;
  });

/*global angular*/
(function() {
  'use strict';

  angular
    .module('CarreEntrySystem')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider) {
    
    $stateProvider
    
      /*  Citations  */
      .state('main.citations', {
        'abstract':true,
        templateUrl: 'app/pages/citations/main.html',
        url: '/citations'
      })
      .state('main.citations.list', {
        controller: 'citationsController',
        controllerAs: 'citations',
        templateUrl: 'app/pages/citations/list.html',
        url: ''
      })
      .state('main.citations.createWithId', {
        templateUrl: 'app/pages/citations/single/single.html',
        controller: 'citationsSingleController',
        controllerAs: 'citation',
        url: '/create/:pubmedId',
        data: {
          permissions: {
            only: ['authenticated_user'],
            redirectTo: function(rejectedPromise) {
              window.location.replace(window.location.href.replace('/edit','').replace('/create',''));
            }        
            
          }
        }
      })
      .state('main.citations.create', {
        templateUrl: 'app/pages/citations/single/single.html',
        controller: 'citationsSingleController',
        controllerAs: 'citation',
        url: '/create',
        data: {
          permissions: {
            only: ['authenticated_user'],
            redirectTo: function(rejectedPromise) {
              window.location.replace(window.location.href.replace('/edit','').replace('/create',''));
            }        
            
          }
        }
      })
      .state('main.citations.edit', {
        templateUrl: 'app/pages/citations/single/single.html',
        controller: 'citationsSingleController',
        controllerAs: 'citation',
        url: '/:id/edit',
        data: {
          permissions: {
            only: ['authenticated_user'],
            redirectTo: function(rejectedPromise) {
              window.location.replace(window.location.href.replace('/edit','').replace('/create',''));
            }        
            
          }
        }
      })
      .state('main.citations.view', {
        controller: 'citationsSingleController',
        templateUrl: 'app/pages/citations/single/single.html',
        controllerAs: 'citation',
        url: '/:id'
      });
  }

})();

(function () {
  "use strict";

  angular
    .module("CarreEntrySystem")
    .controller("citationsController", citationsController);

  /** @ngInject */
  function citationsController(
    toastr,
    Citations,
    currentUser,
    $stateParams,
    CONFIG,
    uiGridGroupingConstants,
    $timeout,
    Pubmed,
    uiGridConstants,
    $state,
    content,
    VisibleFields
  ) {
    var vm = this; //controller as vm

    /************** List Template **************/
    var visibleGridColumns = VisibleFields("citation", "list");

    var citations = [];
    vm.gridLoading = Citations.get().then(function (res) {
      citations = res.data;
      vm.mygrid.data = citations;

      console.log("Model response: ", res);
      //make the response available in the view
      vm.res = res;

      /* Reset columns */
      vm.mygrid.columnDefs = [];

      vm.mygrid.columnDefs.push({
        field: "View",
        enableFiltering: false,
        enableColumnMenu: false,
        cellTemplate:
          '<div class="ui-grid-cell-contents">' +
          '<button type="button" class="btn btn-xs btn-primary" ui-sref="main.citations.view({id:row.entity.id_label})"><i class="fa fa-eye"></i></button> ' +
          // '<button type="button" class="btn btn-xs btn-primary" ng-click="citations.setPubmed(56)"><i class="fa fa-search-plus"></i></button>'+
          "</div>",
        width: 70,
      });

      //show edit buttons
      if (currentUser.username) {
        vm.mygrid.columnDefs.push({
          field: "Edit",
          enableFiltering: false,
          enableColumnMenu: false,
          cellTemplate:
            '<div class="ui-grid-cell-contents">' +
            '<button type="button" class="btn btn-xs btn-primary" ui-sref="main.citations.edit({id:row.entity.id_label})"><i class="fa fa-edit"></i></button> ' +
            "</div>",
          width: 60,
        });
      }

      //dynamic creation of the grid columns
      content.fields(res.fields, visibleGridColumns).forEach(function (obj) {
        vm.mygrid.columnDefs.push(obj);
      });

      vm.mygrid.columnDefs.push({
        field: "id_label",
        displayName: "ID",
        visible: false,
      });
    });

    /* GRID Default options */
    vm.mygrid = content.default;
  }
})();

'use strict';

angular.module('CarreEntrySystem')
  .directive('carreViewPubmed', function(CONFIG) {
    return {
      templateUrl: 'app/components/view-pubmed/view-pubmed.html',
      restrict: 'E',
      replace: true,
      scope: {
        'id': '@'
      },
      controller: function($scope, Pubmed) {
      
        $scope.loading = Pubmed.fetch($scope.id).then(function(res) {
          $scope.pubmedArticle = res.data;
        });


        //debug
      }
    };
  });

'use strict';

/**
 * @ngdoc directive
 * @name izzyposWebApp.directive:adminPosHeader
 * @description
 * # adminPosHeader
 */
angular.module('CarreEntrySystem')
  .directive('sidebar',sidebarDirective);
  
  function sidebarDirective() {
    return {
      templateUrl:'app/components/sidebar/sidebar.html',
      restrict: 'E',
      replace: true,
      scope: {},
      controllerAs:'sidebar',
      controller:function($rootScope, $scope,$state){
        
        var carreElementsMenu=[];
        angular.forEach(angular.element('#carreElements > ul.nav.nav-second-level > li > a'), function( el ){
          carreElementsMenu.push(angular.element(el).attr('ui-sref-active-if'))
        })
        function show_carreElementsMenu(state){ return carreElementsMenu.indexOf(state.substring(0,state.lastIndexOf('.')))>=0; }
        
        //handle ui-router errors
        $rootScope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams, error) {
            $scope.carreElements =  show_carreElementsMenu(toState.name);
        });
        //collapse sidebar submenus
        $scope.carreElements = show_carreElementsMenu($state.current.name);
        
        
        
        $scope.slideWidth=(window.innerWidth>730)?window.innerWidth*0.4:window.innerWidth*0.9;
        
        $(window).resize(function(){
            if($scope.showAbout) { 
              // console.log('Width changed', window.innerWidth);
              $scope.slideWidth=(window.innerWidth>730)?window.innerWidth*0.4:window.innerWidth*0.9;
              $scope.slideWidth=(window.innerWidth>730)?window.innerWidth*0.4:window.innerWidth*0.9;
              $scope.$apply(function(){ $scope.showAbout=false;  });
              $scope.$apply(function(){ $scope.showAbout=true;  });
            }
        });

      }
    };
  };

'use strict';

angular.module('CarreEntrySystem')
  .directive('carreLinker', function(CONFIG) {
    return {
      templateUrl: 'app/components/linker/linker.html',
      restrict: 'E',
      replace: true,
      scope: {
        'property': '@',
        'model': '='
      },
      controller: function($scope, CONFIG, Medical_experts) {
        
        $scope.show = 'label';
        $scope.items = [];
        var label_arr = [];
        var avoidExpressions = ['has_observable_condition'];
        var arr = $scope.model[$scope.property];
        $scope.label = $scope.model[$scope.property + '_label'];
        
        //handle medical experts
        if ($scope.property === 'has_author' || $scope.property === 'has_reviewer') {
            Medical_experts.get().then(function(res) {
              var USERS={}
              res.data.forEach(function(user){
                USERS[user.has_graph_uri_label]=user;
              });
              
              label_arr = $scope.model[$scope.property + '_label_arr'];
              $scope.show = 'links';
              label_arr.forEach(function(username){
                var user = USERS[username];
                  $scope.items.push({
                    link: (CONFIG.ENV === 'PROD' ? '' : '#/') + "medical_experts/" + user.id_label,
                    label: user.has_firstname_label+' '+user.has_lastname_label
                  });
              })
            });
        } else //handle condition
            if ($scope.property === 'has_observable_condition') {
          $scope.show='condition';
          
          $scope.model['has_risk_evidence_observable'].forEach(function(obj,index){
            var id=obj.substr(obj.lastIndexOf('/')+1);
            var link=(CONFIG.ENV === 'PROD' ? '' : '#/') + 'observables/' + id;
            var label=$scope.model['has_risk_evidence_observable_label_arr'][index];
            //construct <a> tag
            var atag="<a href="+link+">"+label+"</a>";
            //replace all OB_* in the expression
            $scope.label=$scope.label.replace(new RegExp(id, 'g'), atag)
            .replace(new RegExp(">=", 'g'), '&ge;').replace(new RegExp("<=", 'g'), '&le;'); //replace greater than and lower than symbols
          });
          
        }  else //handle external annotations
            if ($scope.property === 'has_external_type' || $scope.property === 'has_external_unit'|| $scope.property === 'has_external_predicate')  {
                $scope.show='external_link';
                $scope.external_link = "<a target='_blank' href='"+$scope.model[$scope.property]+"'>"+$scope.model[$scope.property+'_label']+"</a>";
        }
        else {
          // handle links
          if (arr instanceof Array && avoidExpressions.indexOf($scope.property) === -1) {
              
            label_arr = $scope.model[$scope.property + '_label_arr'];

            arr.forEach(function(str, index) {
              var id = str.substr(str.lastIndexOf('/') + 1);
              var cat = id.substr(0, 2);
              var type = false;
              switch (cat) {
                case 'CI':
                  // make label for observables
                  type = 'citations/';
                  break;
                case 'OB':
                  // make label for observables
                  type = 'observables/';
                  break;
                case 'ME':
                  // make label for measurent types
                  type = 'measurement_types/';
                  break;
                case 'RF':
                  // make label for risk factor                          
                  type = 'risk_factors/';
                  break;
                case 'RL':
                  // make label for risk element
                  type = 'risk_elements/';
                  break;
                case 'RV':
                  // make label for risk evidence
                  type = 'risk_evidences/';
                  break;
                default:
              }
              if (type) {
                $scope.show = 'links';
                $scope.items.push({
                  link: (CONFIG.ENV === 'PROD' ? '' : '#/') + type + id,
                  label: label_arr[index]
                });
              }

            });
          }
        }
        //debug
        // console.log('Label:',$scope.label,($scope.showlink?'link':'text'));
      }
    };
  });

'use strict';

angular.module('CarreEntrySystem')
	.directive('carreGraphControls',function(){
		return {
            templateUrl:'app/components/graph-controls/template.html',
            restrict: 'E',
            replace: false,
            bindToController: {
                
                // variables
                'selectedId': '=',
                'disableOptions':'=?',
                'enableRotation': '@',
                'rotation': '=?',
                'onlyPath':'=?',
                'showRiskEvidences':'=?',
                'ratioFilter':'=?',
                
                //functions
                'refresh':'&',
                'addSize':'&',
                'removeSize':'&',
                'navigate':'&',
                'expand':'&',
                'clear':'&'
            },
            controllerAs:'controls',
            scope: true,
            controller:function($timeout,CONFIG,content,$scope){
                var vm = this;
                
                $scope.$watch('selectedId',function(n,o){ 
                    //hack for refresh element
                    if(n && n!==o && $scope.showDetails){ 
                        $scope.showDetails=false;
                        $timeout(function(){ $scope.showDetails=true; });
                    }
                }.bind(this));
                
                $scope.applyRefresh = function (){
                    $timeout(function() { 
                        vm.refresh({}); 
                        // show slider only when risk evidences exist
                        if(vm.showRiskEvidences)  {
                            $scope.$broadcast('rzSliderForceRender'); 
                            vm.showSlider = true;
                        } else vm.showSlider = false;
                    },0);
                };
                
                vm.user = CONFIG.currentUser.username;
                vm.getType=content.typeFromId;
                
                // Slider configuration
                vm.showSlider = vm.showRiskEvidences?true:false;
                var maxLimit = 50.5;
                var step = 0.5;
                var stepsArray = [];
                for(var i=0; i<maxLimit; i=i+step){ stepsArray.push( Number(Math.round(i+'e2')+'e-2') );}
                vm.slider_toggle = {
                    options: {
                        stepsArray:stepsArray
                    }
                };
                
            }
    	};
	});



'use strict';

angular.module('CarreEntrySystem')

.directive('leEditor', ['$compile','$timeout','$q', function($compile,$timeout,$q) {
    return {
        restrict: 'E',
        scope: {
            group: '=',
            observables: '=',
            metypes: '='
        },
        templateUrl: 'app/components/le_editor/le_editor.html',
        compile: function(element, attrs) {
            var content, directive;
            content = element.contents().remove();
            return function(scope, element, attrs) {
                scope.operators = [{
                        name: 'AND'
                    },
                    // { name: 'AND NOT' },
                    {
                        name: 'OR'
                    }
                    // { name: 'OR NOT' }
                ];

                scope.field = {};

                scope.conditions = [
                    {
                        name: '=',  value: '=', types:'integer,float,enum,boolean'
                    },
                    {
                        name: '<',  value: '<', types:'integer,float'
                    }, 
                    {
                        name: '≤',  value: '<=', types:'integer,float'
                    }, 
                    {
                        name: '>',  value: '>', types:'integer,float'
                    }, 
                    {
                        name: '≥',  value: '>=', types:'integer,float'
                    }
                ];

                scope.getMeasurementType = function(item, model, rule) {
                    rule.hiddenData=true;
                    $timeout(function() { 
                        
                        var me_id = '';
                        if (!item) {
                            for (var i = 0; i < scope.observables.length; i++) {
                                if (scope.observables[i].value === model) {
                                    console.log(scope.observables[i])
                                    me_id = scope.observables[i].metype_id;
                                    break;
                                }
                            }
                            me_id = me_id.substring(me_id.indexOf('ME_'));
                            console.log('Get measurement type called!',me_id);
                        }
                        else {
                            me_id = item.metype_id;
                            me_id = me_id.substring(me_id.indexOf('ME_'));
                            console.log('Get measurement type called!',me_id);
                        }
                            
                        for (var i = 0; i < scope.metypes.length; i++) {
                            if (scope.metypes[i].id_label === me_id) {
                                //do stuff
                                rule.datatype = scope.metypes[i].has_datatype_label;
                                rule.unit = scope.metypes[i].has_label_label;
                                rule.unit_label = scope.metypes[i].has_measurement_type_name_label;
                                if (scope.metypes[i].has_enumeration_values_label) rule.dataoptions = scope.metypes[i].has_enumeration_values_label.split(';').map(function(obj) {
                                    return {
                                        value: obj,
                                        name: obj
                                    }
                                });
                                break;
                            }
                        }
                        
                        //make it like loading
                        $timeout(function(){rule.hiddenData=!rule.hiddenData;},400);
                        
                    }, 500);

                };

                scope.addCondition = function() {
                    scope.group.rules.push({
                        condition: '=',
                        field: {
                            selected: {
                                label: ''
                            }
                        },
                        data: ''
                    });
                };

                scope.removeCondition = function(index) {
                    scope.group.rules.splice(index, 1);
                };

                scope.addGroup = function() {
                    scope.group.rules.push({
                        group: {
                            operator: 'AND',
                            rules: []
                        }
                    });
                };

                scope.removeGroup = function() {
                    "group" in scope.$parent && scope.$parent.group.rules.splice(scope.$parent.$index, 1);
                };

                directive || (directive = $compile(content));

                element.append(directive(scope, function($compile) {
                    return $compile;
                }));
            }
        }


    }
}]);

'use strict';

angular.module('CarreEntrySystem')
  .directive('carreGraphSankeyRisk', function() {
    return {
      templateUrl: 'app/components/graph-sankey/template.html',
      restrict: 'E',
      scope: {
        'limitNewConnections': '@',
        'height': '@',
        'riskid': '='
      },
      controller: function($scope, $timeout, toastr, CARRE, $location, CONFIG, GRAPH, content,$q) {

        var vm = $scope;
        vm.loading = false;
        vm.containerId = "sankey";
        
          //graph init configuration
        vm.limitNewConnections = $scope.limitNewConnections || 30;
        vm.minConnections = 6;
        vm.height = vm.height || 600;
        vm.customHeight=0;
        
        vm.alwaysOnDetails=true;
        vm.showRiskEvidences=false;
        vm.onlyCore= false;
        
        
        // ratio filter
        vm.ratioFilter = {
          "min":0,
          "max":50
        };
        function ratioFilterFn (a) {
          if(!vm.showRiskEvidences) return true;
          if(a.ratio>=vm.ratioFilter.min&&a.ratio<=vm.ratioFilter.max) return true;
          else {
            // console.debug(a.id+':'+vm.ratioFilter.min+'<'+a.ratio+'<'+vm.ratioFilter.max);
            return false;
          }
        }
        $scope.$watch('ratioFilter.min',function(n,o){
          if(n&&o&&n!==o) vm.renderSankey();
        })
        $scope.$watch('ratioFilter.max',function(n,o){
          if(n&&o&&n!==o) vm.renderSankey();
        })
        
        //resize events
        $(window).resize(function(){ vm.renderSankey(); });
        vm.addSize=function(){
          if(vm.customHeight>=800) return false;
          vm.customHeight+=100;
          $timeout(function() {
            vm.renderSankey();
          });
        };
        vm.removeSize=function(){
          if(vm.customHeight<=-300) return false;
          vm.customHeight-=100;
          $timeout(function() {
            vm.renderSankey();
          });
        };
        
        vm.init =function (id){
          
          id = id || vm.riskid;
          
          vm.loading = GRAPH.network(id,!vm.showRiskEvidences?'risk_factor':null).then(function(data) {

            //set initial nodes and edges
            vm.nodesArr = id ? data.nodes.map(function(obj,index) {
              var obj_pos = -1;
              //handle colors
              if (id instanceof Array ) {
                if(id[0].indexOf("RL_")>=0) obj_pos = id.indexOf(obj.id); else {
                  //if this is not a risk element array
                  obj_pos = index;
                }
              } else {
                if(id[0].indexOf("RL_")>=0) id.substring(id.lastIndexOf("/") + 1) === obj.id.substring(obj.id.lastIndexOf("/") + 1) ? 0 : -1; else {
                  //if this is not a risk element
                  obj_pos = index;
                }
              }                         
              if (obj_pos >= 0) obj.color = CONFIG.COLORS[obj_pos];
              return obj;
            })
            // .filter(function(node){
            //   if(vm.onlyCore) {
            //     return node.color?true:false;
            //   } else return true;
            // }) 
            :data.nodes.filter(function(obj) {
              return obj.connections > vm.minConnections;
            });            
            
            //filter edges
            vm.edgesArr = data.edges.filter(function(edge) {
              var from = false;
              var to = false;
              for (var i = 0, len = vm.nodesArr.length; i < len; i++) {
                if (vm.nodesArr[i].id === edge.from) from = true;
                if (vm.nodesArr[i].id === edge.to) to = true;
              }
              return from && to;
            });
            
            $timeout(function() {vm.renderSankey();}, 0);

          });
        };
        
        //start the initialization
        vm.init(vm.riskid);
        
        
        /* Graph manipulations */
        vm.goToSelected = function(){
          var elem = vm.selectedItem.obj||{},
              id = elem.id.substring(elem.id.lastIndexOf("/")+1),
              label,
              type = vm.selectedItem.type;
              
          if(type==='node') label=elem.label;
          else if (type==='link'){
              label=elem.source.label+" "+elem.label+" "+elem.target.label;
          } else return false;
          content.goTo(id,label);
        };
        
        vm.addNodeRelations = function () {
          var id = vm.selectedId;
          vm.loading=GRAPH.network(id,!vm.showRiskEvidences?'risk_factor':null).then(function(data){
            var limit=vm.limitNewConnections;
            var nodes={};
            data.nodes.forEach(function(node){
              nodes[node.id]=node;
            });
            data.edges.forEach(function(edge){
              if(GRAPH.FindIndex(vm.edgesArr,edge.id)===-1&&limit>0) {
                if(GRAPH.FindIndex(vm.nodesArr,edge.from)===-1) vm.nodesArr.push(nodes[edge.from]);
                if(GRAPH.FindIndex(vm.nodesArr,edge.to)===-1) vm.nodesArr.push(nodes[edge.to]);
                vm.edgesArr.push(edge);
                limit--;
              }
            });
            //re-render graph
            $timeout(function() {vm.renderSankey();}, 0);
          });
          
        };
        vm.deleteSelected = function(d){
          if(!vm.selectedItem || vm.selectedItem.type!=='node') return false; 
          var elem = vm.selectedItem.obj||{};
          //remove connected edges
          elem.sourceLinks.forEach(function(link){ vm.edgesArr.splice(GRAPH.FindIndex(vm.edgesArr,link.id), 1); });
          elem.targetLinks.forEach(function(link){ vm.edgesArr.splice(GRAPH.FindIndex(vm.edgesArr,link.id), 1); });
          //remove related nodes
          vm.nodesArr=vm.nodesArr.filter(function(node){ 
            return GRAPH.FindIndex(vm.edgesArr,node.id,'from')+GRAPH.FindIndex(vm.edgesArr,node.id,'to')>=-1;
          });
          if(d) d3.event.preventDefault();
          //re-render graph
          $timeout(function() {vm.renderSankey();}, 0);
        };

        //main graph render function
        vm.renderSankey = function() {
          // Some setup stuff.
          var node_index = {};
          var graph = {};
          
          graph.nodes = vm.nodesArr.map(function(obj, index) {
              node_index[obj.id] = {
                index: index,
                value: obj.value
              };
              obj.name = obj.label;
              return obj;
            });
            
          graph.links = vm.edgesArr
            .map(function(obj) {
              if(vm.showRiskEvidences) obj.ratio_type = GRAPH.ratioType(obj.ratio_type);
              obj.value = Number(obj.ratio)||1;
              obj.source = node_index[obj.from].index;
              obj.target = node_index[obj.to].index;
              return obj;
            });
          
          console.log("Sankey graph data",graph);
          
          var calculated_height = vm.customHeight+Math.log(graph.links.length)*250;
          
            var margin = {top: 10, right: 10, bottom: 10, left: 10},
                width = chartCss('width') - margin.left - margin.right,
                height = (calculated_height>vm.height?calculated_height:vm.height) - margin.top - margin.bottom;
                
            var viewBox = '0 0 '+(angular.element(window).width()+40)+' '+(height+20);
            
            var formatNumber = d3.format(",.0f"), 
                format = function(d) { return formatNumber(d); },
                d3colors = d3.scale.category20b();
            	
            // append the svg canvas to the page
            angular.element("#"+vm.containerId+" svg").remove();
            var svg = d3.select("#"+vm.containerId).append("svg")
              .attr("xmlns","http://www.w3.org/2000/svg")
              .attr("xmlns:xlink","http://www.w3.org/1999/xlink")
                .attr("width", "100%")
                .attr("height", "100%")
                .attr("viewBox",viewBox)
              .append("g")
                .attr("transform", 
                      "translate(" + margin.left + "," + margin.top + ")");
            
            	   
            // Set the sankey diagram properties
            var sankey = d3.sankey()
                .nodeWidth(20)
                .nodePadding(12)
                .size([width, height]);
            var path = sankey.link();
            sankey
              .nodes(graph.nodes)
              .links(graph.links)
              .layout(32);

            // add in the links
            var link = svg.append("g").selectAll(".link")
              .data(graph.links.filter(ratioFilterFn))
              .enter().append("path")
              .attr("id", function(d,i){return idLabel(d.id)})
              .attr("class", "link")
              .attr("d", path)
              .style("stroke", function(d, i) {
                return vm.riskid?(d.source.color||'#aaaaaa'):CONFIG.COLORS[node_index[d.source.id].index];
              })
              .style("stroke-width", function(d) {
                return Math.max(2, d.dy)-1; //add white seperator
              })
              .sort(function(a, b) {
                return b.dy - a.dy;
              });
              
              link.append("title")
                .text(function(d) {
                return d.source.name +" --> "+ d.target.name + (vm.showRiskEvidences
                ?", "+d.ratio_type+" = "+d.ratio
                :", "+d.evidences.length+" evidence(s) "+GRAPH.ratioMinMax(d.evidences));
              });
              
              // var linkText = svg.append("g")
              // .selectAll(".link")
              // .data(graph.links.filter(ratioFilterFn))
              // .enter().append("text").attr("class","linkText")
              // .attr("id", function(d,i){return idLabel(d.id)+"-text"})
              // .append("textPath").attr("class", "textpath")
              // .attr("xlink:href",function(d,i){return "#"+idLabel(d.id)})
              // .text(function(d) {
              //   return d.source.name +" --> "+ d.target.name + (vm.showRiskEvidences?", risk ratio = "+d.ratio:"");
              // })
              
              
              // svg.append("g")
              // .selectAll(".link")
              // .data(graph.links.filter(ratioFilterFn))
              // .enter().append("use")
              // .attr("id", function(d,i){return idLabel(d.id)+"-line"})
              // .attr("xlink:href",function(d,i){return "#"+idLabel(d.id)})
              
              
              
            // add in the nodes
            var node = svg.append("g").selectAll(".node")
              .data(graph.nodes)
              .enter().append("g")
              .attr("class", "node")
              .attr("transform", function(d) {
                return "translate(" + d.x + "," + d.y + ")";
              })
              .call(d3.behavior.drag()
                .origin(function(d) {
                  return d;
                })
                .on("dragstart", function() {
                  this.parentNode.appendChild(this);
                })
                .on("dragend", function() {
                    sankey.relayout();
                })
                .on("drag", dragmove));
              
            // add the rectangles for the nodes
            node.append("rect")
              .attr("height", function(d) {
                return d.dy;
              })
              .attr("width", 
                sankey.nodeWidth()
              )
              .style("stroke", function(d, i) {
                return vm.riskid?(d.color||'#aaaaaa'):CONFIG.COLORS[i]; // = color(i);
              })
              .style("fill", function(d, i) {
                return vm.riskid?(d.color||'#aaaaaa'):CONFIG.COLORS[i]; // = color(i);
              })
              // .style("stroke", function(d) {
              //   return d3.rgb('#aaaaaa');
              // })
              .attr('data-title', function(d) {
                return d.name// + "\n" + format(d.value);
              })


            // add in the title for the nodes
            node.append("text")
              .attr("x", -6)
              .attr("y", function(d) {
                return d.dy / 2;
              })
              .attr("dy", "0.50em")
              .attr("text-anchor", "end")
              .attr("transform", null)
              .text(function(d) {
                return d.name.charAt(0).toUpperCase() + d.name.slice(1);;
              })
              .filter(function(d) {
                return d.x < width / 2;
              })
              .attr("x", 6 + sankey.nodeWidth())
              .attr("text-anchor", "start");
              
              
            // the function for moving the nodes
          function dragmove(d) {
              d3.select(this).attr("transform",
                "translate(" + d.x + "," + (
                  d.y = Math.max(0, Math.min(height - d.dy, d3.event.y))
                ) + ")");
              link.attr("d", path);
            }
            
            //assign events
            node.on('mousedown',clickNode);
            link.on('mousedown',clickLink);
            
            node.on('dblclick',vm.addNodeRelations);
            link.on('dblclick',vm.goToSelected);
            
            node.on('contextmenu',vm.deleteSelected);
            
        };
            
        //register events==============================>
        
        function clickNode(obj,i){ 
          clearSelection();
          d3.select(this).select("rect").classed("selected", !d3.select(this).classed("selected"));
          selectElement(obj,'node');
          d3.event.stopPropagation(); //events hack
        }
        function clickLink(obj,i){ 
          clearSelection();
          d3.select(this).classed("selected", !d3.select(this).classed("selected"));
          selectElement(obj,'link');
          d3.event.stopPropagation(); //events hack
        }

        //clear selection event
        angular.element("#"+vm.containerId).on('mousedown',clearSelection);
        
        //help functions
        function clearSelection(){
          $timeout(function(){vm.selectedId = null; },0);
          d3.select("#"+vm.containerId+" svg").selectAll(".link").classed("selected", false);
          d3.select("#"+vm.containerId+" svg").selectAll(".node").select("rect").classed("selected", false);
        }
        function selectElement(obj,type){
          var id = obj?obj.id:null;
          if(!id) return;
          else {
            if(id.indexOf('/')!==-1) id = id.substr(id.lastIndexOf('/')+1);
            $timeout(function(){
              vm.selectedId = id; 
              vm.selectedItem={type:type,obj:obj};
            },0);
            if(vm.showDetails && vm.alwaysOnDetails) { //reload element hack
              $timeout(function(){vm.showDetails=false; },0);
              $timeout(function(){vm.showDetails = true;},100);
            }
          }
        }
        function idLabel(id){
          return id.substr(id.lastIndexOf("/")+1);
        }
        function chartCss(attr){
          var elem=document.getElementById(vm.containerId);
          if(elem) return Number(getComputedStyle(elem, null).getPropertyValue(attr).replace('px',''));
          else return null;
        }
        
        //end of controller
      }

    };
  });

'use strict';

angular.module('CarreEntrySystem')
  .directive('carreGraphChordRisk', function() { 
return {
    templateUrl: 'app/components/graph-chord/template.html',
    restrict: 'E',
    scope: {
        'limitNewConnections':'@',
        'height': '@',
        'riskid': '='
    },
    controller: function($scope, $timeout, toastr, CARRE, $location, CONFIG, GRAPH,$state,SweetAlert,content) {
  
        var vm = $scope;
        vm.loading=false;
        vm.containerId = "chord";
        
        //graph init configuration
        vm.limitNewConnections = $scope.limitNewConnections||10;
        vm.minConnections = 5;
        vm.height = vm.height || 700;
        vm.customHeight=0;
        vm.rotation=0;
        
        vm.alwaysOnDetails=true;
        vm.showRiskEvidences=false;
        vm.onlyCore= false;
        
        //resize events
        
        //resize events
        $(window).resize(function(){ vm.renderChord(); });
        vm.addSize=function(){
          if(vm.customHeight>=800) return false;
          vm.customHeight+=100;
          $timeout(function() {
            vm.renderChord();
          });
        };
        vm.removeSize=function(){
          if(vm.customHeight<=-300) return false;
          vm.customHeight-=100;
          $timeout(function() {
            vm.renderChord();
          });
        };
        
        
        vm.init =function (id){
          
          id = id || vm.riskid;
          
          vm.loading = GRAPH.network(id,!vm.showRiskEvidences?'risk_factor':null).then(function(data) {

            //set initial nodes and edges
            vm.nodesArr=id?data.nodes.map(function(obj){
                var obj_pos=-1;
                //handle colors
                if(id instanceof Array) obj_pos=id.indexOf(obj.id);
                else obj_pos=id.substring(id.lastIndexOf("/")+1)===obj.id.substring(obj.id.lastIndexOf("/")+1)?0:-1;
                if(obj_pos>=0) obj.color=CONFIG.COLORS[obj_pos];
                
                return obj;
              }):data.nodes.filter(function(obj){ return obj.connections>vm.minConnections;});
              
            //filter edges
            vm.edgesArr=data.edges.filter(function(edge){
              var from=false;
              var to=false;
              for (var i=0,len=vm.nodesArr.length;i<len;i++){
                if(vm.nodesArr[i].id===edge.from) from=true;
                if(vm.nodesArr[i].id===edge.to) to=true;
              }
              return from&&to;
            });
            //init network after 50ms delay
            $timeout(function(){ vm.renderChord(); },0);
            
          }); 
        }
        
        //start the initialization
        vm.init(vm.riskid);
        
      
        /* Graph manipulations */
        vm.goToSelected = function () {
          var elem = vm.selectedItem.obj||{},
              id = elem.id.substring(elem.id.lastIndexOf("/")+1),
              label,
              type = vm.selectedItem.type;
          if(type==='node') label=elem.label;
          else if (type==='link'){
              label=vm.nodesArr[GRAPH.FindIndex(vm.nodesArr,elem.from)].label
              +" "+elem.label+" "+
              vm.nodesArr[GRAPH.FindIndex(vm.nodesArr,elem.to)].label;
          } else return false;
          content.goTo(id,label);
        };
        
        vm.addNodeRelations = function () {
          var id = vm.selectedId;
          vm.loading=GRAPH.network(id,!vm.showRiskEvidences?'risk_factor':null).then(function(data){
            var limit=vm.limitNewConnections;
            var nodes={};
            data.nodes.forEach(function(node){
              nodes[node.id]=node;
            });
            data.edges.forEach(function(edge){
              if(GRAPH.FindIndex(vm.edgesArr,edge.id)===-1&&limit>0) {
                if(GRAPH.FindIndex(vm.nodesArr,edge.from)===-1) vm.nodesArr.push(nodes[edge.from]);
                if(GRAPH.FindIndex(vm.nodesArr,edge.to)===-1) vm.nodesArr.push(nodes[edge.to]);
                vm.edgesArr.push(edge);
                limit--;
              }
            });
            //re-render graph
            $timeout(function() {vm.renderChord();}, 0);
          });
          
        };
        vm.deleteSelected = function(d){
          if(!vm.selectedItem || vm.selectedItem.type!=='node') return false; 
          var elem = vm.selectedItem.obj||{};
          //remove connected edges
          vm.edgesArr=vm.edgesArr.filter(function(link, i) {
            return !(link.from===elem.id||link.to===elem.id);
          });          
          vm.nodesArr=vm.nodesArr.filter(function(node){ 
            return GRAPH.FindIndex(vm.edgesArr,node.id,'from')+GRAPH.FindIndex(vm.edgesArr,node.id,'to')>=-1;
          });
          if(d) {
            
            console.debug("Context Menu",d3.event,this,d);
            d3.event.preventDefault();
          }
          //re-render graph
          $timeout(function() {vm.renderChord();}, 0);
        };
    
        vm.renderChord = function() {
            if(vm.rotationWatch) vm.rotationWatch();
      
            var options = {
                "rotation": vm.rotation
            };
            var nodesIndex={};
            var edgeMatrix = [];
            var matrix = [];
            vm.nodesArr.forEach(function(n,i){
              nodesIndex[n.id]={i:i,obj:n};
              edgeMatrix[i]=edgeMatrix[i]||[];
              matrix[i]=matrix[i]||[];
              vm.nodesArr.forEach(function(m,j){
                edgeMatrix[i][j]=0;
                matrix[i][j]=0;
              });
            });
            vm.edgesArr.forEach(function(e,i){
              edgeMatrix[nodesIndex[e.from].i][nodesIndex[e.to].i]=e;
              matrix[nodesIndex[e.from].i][nodesIndex[e.to].i]=1;
            });
            
            
            console.log("Chord graph data matrix",matrix,edgeMatrix);
            
            // initialize the chord configuration variables
            var config = {
                width: chartCss('width'),
                height: 700+vm.customHeight,
                rotation: 0,
                textgap: 10
            };
            
            // add options to the chord configuration object
            if (options) {
                extend(config, options);
            }
            
            // set chord visualization variables from the configuration object
            var offset = Math.PI * vm.rotation,
                width = config.width,
                height = config.height,
                textgap = config.textgap,
                colors = d3.scale.category20b();
            // set viewBox and aspect ratio to enable a resize of the visual dimensions 
            var viewBoxDimensions = "0 0 " + width + " " + height,
                aspect = width / height;
            
    
            // start the d3 magic
            var chord = d3.layout.chord()
                .padding(.05)
                .sortSubgroups(d3.descending)
                .matrix(matrix);
    
            var innerRadius = Math.min(width, height) * .31,
                outerRadius = innerRadius * 1.1;
    
            var fill = function(d, i) {
                    i = i||d;
                    return vm.riskid?(vm.nodesArr[i].color||'#aaaaaa'):colors(i) // = color(i);
            }
              
            var rotate=function(){
                d3.select("#"+vm.containerId+" svg g")
                .transition()
                .duration(1000)
                .attr("transform", "translate(" + width / 2 + "," + height / 2 + ")rotate("+vm.rotation+")")
            }
            
            vm.rotationWatch=$scope.$watch('rotation',function(){
                $timeout(function(){ rotate(); },0);
            });
        
            
            angular.element("#"+vm.containerId+" svg").remove();
            var svg = d3.select("#"+vm.containerId).append("svg")
                .attr("viewBox", viewBoxDimensions)
                .attr("preserveAspectRatio", "xMinYMid")    // add viewBox and preserveAspectRatio
                .attr("width", width)
                .attr("height", height)
                .append("g")
                .attr("transform", "translate(" + width / 2 + "," + height / 2 + ")");
    
            var g = svg.selectAll("g.group")
                .data(chord.groups)
                .enter().append("svg:g")
                .attr("class", "group");
    
                //group arc
                g.append("svg:path")
                .style("fill", function(d) { return fill(d.index); })
                .style("stroke", function(d) { return fill(d.index); })
                .attr("id", function(d, i) { return "group" + d.index; })
                .attr("d", d3.svg.arc().innerRadius(innerRadius).outerRadius(outerRadius).startAngle(startAngle).endAngle(endAngle))
                //group text
                g.append("svg:text")
                .each(function(d) {d.angle = ((d.startAngle + d.endAngle) / 2) + offset; })
                .attr("dy", ".35em")
                .attr("text-anchor", function(d) { return d.angle > Math.PI ? "end" : null; })
                .attr("transform", function(d) {
                    return "rotate(" + (d.angle * 180 / Math.PI - 90) + ")"
                        + "translate(" + (outerRadius + textgap) + ")"
                        + (d.angle > Math.PI ? "rotate(180)" : "");
                  })
                .text(function(d) { return vm.nodesArr[d.index].label; })
                .style("fill", function(d) { return fill(d.index); });
    
            var link=svg.append("g")
                .attr("class", "chord")
                .selectAll("path")
                .data(chord.chords)
                .enter().append("path")
                .attr("d", d3.svg.chord().radius(innerRadius).startAngle(startAngle).endAngle(endAngle))
                .style("fill", function(d) { return fill(d.source.index); })
                .style("opacity", 1);
                
            //link text
            link.append("svg:title").text(function(d) { 
                return  vm.nodesArr[d.source.index].label +" "+ 
                edgeMatrix[d.source.index][d.target.index].label +" "+ 
                vm.nodesArr[d.target.index].label; 
            });
        
            // helper functions start here
            
            function startAngle(d) { return d.startAngle + offset; }
            function endAngle(d) { return d.endAngle + offset; }
            function extend(a, b) { for(var i in b) {a[i]=b[i];} }
            
            // Returns an event handler for fading a given chord group.
            function fade(opacity) {
                return function(g, i) {
                  svg.selectAll(".chord path")
                  .filter(function(d) { return d.source.index != i && d.target.index != i; })
                  .transition().style("opacity", opacity);
                };
            }
            
            //assign events
            g.on("mouseover", fade(.1))
                .on("mouseout", fade(1))
                .on('click',clickNode)
                .on('dblclick',vm.addNodeRelations)
                // .on('contextmenu',vm.deleteSelected);
                
            link.on('click',clickLink)
                .on('dblclick',vm.goToSelected);
    
        }
        
        //register events==============================>
        
        function clickNode(obj,i){ 
          console.debug("Click",d3.event,this,obj,i);
          clearSelection();
          d3.select(this).classed("selected", !d3.select(this).classed("selected"));
          selectElement(vm.nodesArr[i],'node');
          if(d3.event.type==="click") d3.event.stopPropagation(); //events hack
        }
        function clickLink(obj,i){
          // console.debug("Link",this,obj,i);
          clearSelection();
          d3.select(this).classed("selected", !d3.select(this).classed("selected"));
          var link=vm.edgesArr.filter(function(link){
            return link.from===vm.nodesArr[obj.source.index].id && link.to===vm.nodesArr[obj.target.index].id;
          })[0];
          selectElement(link,'link');
          d3.event.stopPropagation(); //events hack
        }

        //clear selection event
        angular.element("#"+vm.containerId).on('click',clearSelection);
        
        //help functions
        function clearSelection(){
          $timeout(function(){vm.selectedId = null; },0);
          d3.select("#"+vm.containerId+" svg").selectAll(".chord path").classed("selected", false);
          d3.select("#"+vm.containerId+" svg").selectAll(".group").classed("selected", false);
        }
        function selectElement(obj,type){
          var id = obj?obj.id:null;
          if(!id) return;
          else {
            if(id.indexOf('/')!==-1) id = id.substr(id.lastIndexOf('/')+1);
            $timeout(function(){
              vm.selectedId = id; 
              vm.selectedItem={type:type,obj:obj};
            },0);
            if(vm.showDetails && vm.alwaysOnDetails) { //reload element hack
              $timeout(function(){vm.showDetails=false; },0);
              $timeout(function(){vm.showDetails = true;},100);
            }
          }
        }
        function chartCss(attr){
          var elem=document.getElementById(vm.containerId);
          if(elem) return Number(getComputedStyle(elem, null).getPropertyValue(attr).replace('px',''));
          else return null;
        }
        
        


    }

    
    //end of controller
}
      
      
    
});
'use strict';

/**
 * @ngdoc directive
 * @name izzyposWebApp.directive:adminPosHeader
 * @description
 * # adminPosHeader
 */
angular.module('CarreEntrySystem')
	.directive('carreHeader',function(){
		return {
            templateUrl:'app/components/header/header.html',
            restrict: 'E',
            replace: true,
            controllerAs:'header',
            controller:function($scope,$rootScope,$window){
                var vm = this;
                $scope.toggleNavbar=function(){
                    if($('div.navbar-collapse').hasClass('collapse')) {
                        $('div.navbar-collapse').removeClass('collapse');
                    } else {
                        $('div.navbar-collapse').addClass('collapse');
                    }
                }
                //when you change state close again the navbar
                $rootScope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams){
                    // console.log(fromState,toState);
                    if(fromState!==toState) $('div.navbar-collapse').addClass('collapse');
                })
            }
    	}
	});



'use strict';

angular.module('CarreEntrySystem')
  .directive('carreGraphRisk', function() {
    return {
      templateUrl: 'app/components/graph-network-vis/template.html',
      restrict: 'E',
      scope: {
        'limitNewConnections':'@',
        'height': '@',
        'riskid': '='
      },
      controller: function($scope, $timeout, toastr, $location, CONFIG, GRAPH ,content,$q) {
      
        var vm = $scope;
        vm.loading=null;
        //graph init configuration
        vm.limitNewConnections = $scope.limitNewConnections||4;
        vm.minConnections = 7;
        vm.height = vm.height || 600;
        vm.customHeight=0;
        
        vm.alwaysOnDetails=true;
        vm.showRiskEvidences=$location.search().elementstype==='risk_evidences'?true:false||false;
        vm.onlyCore= false;
        
        var network;
        vm.containerId="network";
        var d3colors=d3.scale.category20b();
        
        //resize events
        vm.addSize=function(){
          vm.customHeight+=100;
          network.setSize('100%',Number(vm.height)+vm.customHeight+'px');
          network.redraw();
          network.fit();
        };
        vm.removeSize=function(){
          if(vm.customHeight<=0) return false;
          vm.customHeight-=100;
          network.setSize('100%',Number(vm.height)+vm.customHeight+'px');
          network.redraw();
          network.fit();
        };
        
        
        vm.init=function(id) {
          
          id = id || vm.riskid;
          
          //check if loading promise exists and act accordingly
          $timeout(function(){vm.loading=$q.defer();},0);
          
          GRAPH.network(id,!vm.showRiskEvidences?'risk_factor':null).then(function(data){ 
            
            //set initial nodes and edges
            vm.nodesArr=id
              ?
              data.nodes.map(function(obj,index){
                var obj_pos = -1;
                //handle colors
                if (id instanceof Array ) {
                  if(id[0].indexOf("RL_")>=0) obj_pos = id.indexOf(obj.id); else {
                    //if this is not a risk element array
                    obj_pos = index;
                  }
                } else {
                  if(id[0].indexOf("RL_")>=0) id.substring(id.lastIndexOf("/") + 1) === obj.id.substring(obj.id.lastIndexOf("/") + 1) ? 0 : -1; else {
                    //if this is not a risk element
                    obj_pos = index;
                  }
                }                         
                if (obj_pos >= 0) obj.color = CONFIG.COLORS[obj_pos];
                return obj;
              })
              :
              data.nodes.filter(function(obj){ return obj.connections>vm.minConnections;}).map(function(obj,i){
                obj.color = CONFIG.COLORS[i]; //d3colors(i);
                return obj;
              });
              
            //filter edges
            vm.edgesArr=data.edges.filter(function(edge){
              var from=false;
              var to=false;
              for (var i=0,len=vm.nodesArr.length;i<len;i++){
                if(vm.nodesArr[i].id===edge.from) from=true;
                if(vm.nodesArr[i].id===edge.to) to=true;
              }
              return from&&to;
            }).map(function(edge){
              var pos=(id instanceof Array)?id.indexOf(edge.from):null;
              edge.color = pos>=0?CONFIG.COLORS[pos]:"#aaaaaa";
              return edge;
            })
            
            $timeout(function(){
              if(vm.onlyCore && vm.riskid instanceof Array && vm.riskid.length>1) {
                  var nodeIds=[];
                  vm.startNetwork({
                    nodes:vm.nodesArr.filter(function(node){
                    if(network.getConnectedEdges(node.id).length>1 || node.color ){
                      if(nodeIds.indexOf(node.id)===-1) nodeIds.push(node.id);
                      return true;
                    } else return false;
                  }),
                    edges:vm.edgesArr.filter(function(edge){
                    return nodeIds.indexOf(edge.from)>=0 && nodeIds.indexOf(edge.to)>=0;
                  })
                    
                  });
              } else vm.startNetwork();
            },0);
            
          }); 
        };
        
        //start the initialization
        vm.init(vm.riskid);
        
        /* Graph manipulations */
        vm.addNodeRelations = function (id) {
          var id = id || vm.selectedId;
          vm.loading=GRAPH.network(id,!vm.showRiskEvidences?'risk_factor':null).then(function(data){
            var limit=vm.limitNewConnections;
            var nodes={};
            data.nodes.forEach(function(node){
              nodes[node.id]=node;
            });
            data.edges.forEach(function(edge){
              if(!vm.edges._data[edge.id]&&limit>0) {
                if(!vm.nodes._data[edge.from]) vm.nodes.add(nodes[edge.from]);
                if(!vm.nodes._data[edge.to]) vm.nodes.add(nodes[edge.to]);
                vm.edges.add(edge);
                limit--;
              }
            });
          });
        };
        
        vm.selectElement = function(id){
          if(!id) $timeout(function(){vm.selectedId = false; },0);
          else {
            if(id.indexOf('/')!==-1) id = id.substr(id.lastIndexOf('/')+1);
            $timeout(function(){vm.selectedId = id; },0);
            if(vm.showDetails && vm.alwaysOnDetails) { //reload element hack
              $timeout(function(){vm.showDetails=false; },0);
              $timeout(function(){vm.showDetails = true;},100);
            }
          }
          
        };
        vm.deleteSelected = function(id){
          var node=id||network.getSelectedNodes()[0];
          if(!node) return false; 
          var nodeData={
            nodes:[node],
            edges:network.getConnectedEdges(node)
          }
          vm.removeOrphan(nodeData);
        }
        
        vm.goToSelected = function(){
          var nodes=network.getSelectedNodes();
          var edges=network.getSelectedEdges();
          var id,label;
          
          if(nodes.length===1) {
             //then it is a risk element
            id=nodes[0].substring(nodes[0].lastIndexOf("/")+1);
            label=vm.nodes._data[nodes[0]].label;
          
          } else if (edges.length===1){
              var edge=vm.edges._data[edges[0]];
              id=edges[0].substring(edges[0].lastIndexOf("/")+1);
              label=vm.nodes._data[edge.from].label+" "+edge.label+" "+vm.nodes._data[edge.to].label;
              
          } else return false;
          content.goTo(id,label);
        }
        
        vm.removeOrphan = function(data){
          data.nodes.forEach(function(node){vm.nodes.remove(node);});
          data.edges.forEach(function(edge){ vm.edges.remove(edge);});
          var nodes=Object.keys(vm.nodes._data);
          nodes.forEach(function(node){
            var edges=network.getConnectedEdges(node);
            if(edges.length<=0) {
              vm.nodes.remove(node);
            }
          });
        };
    
        /* Network Graph native configuration */
        vm.startNetwork = function(externalData) {
            if(!vm.loading || !vm.loading.promise || vm.loading.promise.$$state.status===1) $timeout(function(){vm.loading=$q.defer();},0);
          
            externalData = externalData || {}
            vm.customHeight=0;
            vm.edges = new vis.DataSet(externalData.edges||vm.edgesArr);
            vm.nodes = new vis.DataSet(externalData.nodes||vm.nodesArr);
            
            // create a network
            var container = document.getElementById(vm.containerId);
            var data = {
                nodes: vm.nodes,
                edges: vm.edges
            };
            var options = {
              autoResize:true,
              height: vm.height+'px',
              width: '100%',
              manipulation: {
                enabled:false,
              },
              configure: {
                enabled:false
              },  
              edges:{
                smooth:{enabled:true,type:'dynamic'},
                arrows: 'to',
                color:'#aaaaaa',
                font: {
                  color: '#343434',
                  size: 11, // px
                  face: 'arial',
                  background: 'none',
                  strokeWidth: 1, // px
                  strokeColor: '#ffffff',
                  // align:'middle'
                }
              },
              nodes:{
                color:{
                  border:'#aaaaaa',
                  background:'#ffffff'
                }
                
              },
              physics:{
                enabled: true,
                barnesHut: {
                  gravitationalConstant: -1000,
                  centralGravity: 0.1,
                  springLength: 200,
                  springConstant: 0.001,
                  damping: 0.09,
                  avoidOverlap: 0
                },
                forceAtlas2Based: {
                  gravitationalConstant: -70,
                  centralGravity: 0.01,
                  springConstant: 0.08,
                  springLength: 100,
                  damping: 0.4,
                  avoidOverlap: 1
                },
                maxVelocity: 50,
                minVelocity: 0.1,
                solver: 'barnesHut',
                stabilization: {
                  enabled: true,
                  iterations: 300,
                  updateInterval: 100,
                  onlyDynamicEdges: false,
                  fit: true
                },
                timestep: 0.5,
                adaptiveTimestep: true
              }
            };
            network = new vis.Network(container, data, options);
            
            //register events
            network.on("doubleClick", function (params) {
                if(params.nodes.length===1) vm.addNodeRelations(params.nodes[0]);
                else if(params.edges.length===1) {
                  
                  // vm.addRiskEvidences(vm.edges._data[params.edges[0]]);
                  
                  // do something with the edge
                  var edge=vm.edges._data[params.edges[0]];
                  var rf_id=params.edges[0].substring(params.edges[0].lastIndexOf("/")+1);
                  var rf_label=vm.nodes._data[edge.from].label+" "+edge.label+" "+vm.nodes._data[edge.to].label;
                  content.goTo(rf_id,rf_label);
                }
            });
            //left click
            network.on("click", function (params) {
              if(params.nodes.length===1) {
                vm.selectElement(params.nodes[0]);
              } else if(params.edges.length===1) {
                vm.selectElement(params.edges[0]);
              } else {
                vm.selectElement();
              }
            });
            //right click
            network.on("oncontext", function (params) {
              var nodeId=network.getNodeAt(params.pointer.DOM);
              if(nodeId) {
                params.event.preventDefault();
                vm.deleteSelected(nodeId);
              }
            });
            
            //after render
            network.on("afterDrawing", function (params) {
              if(vm.loading && vm.loading.promise && vm.loading.promise.$$state.status===0) $timeout(function(){vm.loading.resolve();},50);
              
        
            });
        };
        //end of controller
      }
    
    };
  });

'use strict';

/**
 * @ngdoc directive
 * @name izzyposWebApp.directive:adminPosHeader
 * @description
 * # adminPosHeader
 */
angular.module('CarreEntrySystem')
	.directive('carreFooter',function(){
		return {
        templateUrl:'app/components/footer/footer.html',
        restrict: 'E',
        replace: true
    	}
	});



'use strict';

angular.module('CarreEntrySystem')
  .directive('carreGraphNetworkD3', function() {
    return {
      templateUrl: 'app/components/graph-network-d3/template.html',
      restrict: 'E',
      scope: {
        'limitNewConnections':'@',
        'height': '@',
        'riskid': '='
      },
      controller: function($scope, $timeout, toastr, $location, CONFIG, GRAPH ,$state,SweetAlert,$q) {
      
  var vm = $scope;
        vm.loading=false;
        //graph init configuration
        vm.limitNewConnections = $scope.limitNewConnections||4;
        vm.minConnections = 10;
        vm.height = vm.height || 600;
        vm.customHeight=0;
        var network;
        vm.options = {
          showRiskEvidences:false,
          onlyCore: false
        }
        $timeout(function() {
            vm.selectedId = 'RL_2'
        },3000);
        $scope.$watch('options',function(n,o){
          if(n.showRiskEvidences!==o.showRiskEvidences) {
            console.debug('ShowRiskEvidences')
          } else if(n.onlyCore!==o.onlyCore) {
            console.debug('onlyCore')
          }
          if(n.showRiskEvidences!==o.showRiskEvidences||n.onlyCore!==o.onlyCore)
            vm.loading=$q.defer();
            $timeout(function(){
              vm.loading=vm.init(vm.riskid); 
            },250);
        });
        
        
        vm.addSize=function(){
          console.debug("size++")
        }
        
        vm.removeSize=function(){
          console.debug("size--")
        }
        
        
        
        vm.init=function(id) {
          if(!id) id = vm.riskid;
          vm.loading=GRAPH.network(id,!vm.options.showRiskEvidences?'risk_factor':null).then(function(data){ 
            
            //set initial nodes and edges
            vm.nodesArr=id?data.nodes.map(function(obj){
                var obj_pos=-1;
                //handle colors
                if(id instanceof Array) obj_pos=id.indexOf(obj.id);
                else obj_pos=id.substring(id.lastIndexOf("/")+1)===obj.id.substring(obj.id.lastIndexOf("/")+1)?0:-1;
                if(obj_pos>=0) obj.color=CONFIG.COLORS[obj_pos];
                
                return obj;
              }):data.nodes.filter(function(obj){ return obj.connections>vm.minConnections;});
              
            //filter edges
            vm.edgesArr=data.edges.filter(function(edge){
              
              
              var from=false;
              var to=false;
              for (var i=0,len=vm.nodesArr.length;i<len;i++){
                if(vm.nodesArr[i].id===edge.from) from=true;
                if(vm.nodesArr[i].id===edge.to) to=true;
              }
              return from&&to;
            });
            
            //init network after 50ms delay
            $timeout(function(){
              
            
              if(vm.options.onlyCore && vm.riskid instanceof Array && vm.riskid.length>1) {
                  var nodeIds=[];
                  vm.loading=vm.startNetwork({
                    nodes:vm.nodesArr.filter(function(node){
                    if(network.getConnectedEdges(node.id).length>1 || node.color ){
                      if(nodeIds.indexOf(node.id)===-1) nodeIds.push(node.id);
                      return true;
                    } else return false;
                  }),
                    edges:vm.edgesArr.filter(function(edge){
                    return nodeIds.indexOf(edge.from)>=0 && nodeIds.indexOf(edge.to)>=0;
                  })
                    
                  });
              } else vm.startNetwork();
              
              
            },50);
            
          }); 
        }
        
        //start the initialization
        vm.init(vm.riskid);
        
        
        vm.showRiskFactor=function(id,label){
          //implement a basic confirm popup
          SweetAlert.swal({
              title: "Show the Risk factor?",
              text: "This will redirect you to the \""+label+"\" risk factor's detail page.",
              type: "info",
              showCancelButton: true,
              confirmButtonColor: "#2E8B57",
              confirmButtonText: "Yes, show me!",
              closeOnConfirm: true,
              closeOnCancel: true
            },
            function(isConfirm) {
              if (isConfirm) {
                $state.go("main.risk_factors.view",{id:id});
              }
            });
          
        };
        
        vm.showRiskElement=function(id,label){
          //implement a basic confirm popup
          SweetAlert.swal({
              title: "Show the Risk element?",
              text: "This will redirect you to the \""+label+"\" risk element's detail page.",
              type: "info",
              showCancelButton: true,
              confirmButtonColor: "#2E8B57",
              confirmButtonText: "Yes, show me!",
              closeOnConfirm: true,
              closeOnCancel: true
            },
            function(isConfirm) {
              if (isConfirm) {
                $state.go("main.risk_elements.view",{id:id});
              }
            });
          
        };
        
        /* Graph manipulations */
        vm.addNodeRelations = function (id) {
          id = id || vm.selectedId;
          vm.loading=GRAPH.network(id,!vm.options.showRiskEvidences?'risk_factor':null).then(function(data){
            var limit=vm.limitNewConnections;
            var nodes={};
            data.nodes.forEach(function(node){
              nodes[node.id]=node;
            });
            data.edges.forEach(function(edge){
              if(!vm.edges._data[edge.id]&&limit>0) {
                if(!vm.nodes._data[edge.from]) vm.nodes.add(nodes[edge.from]);
                if(!vm.nodes._data[edge.to]) vm.nodes.add(nodes[edge.to]);
                vm.edges.add(edge);
                limit--;
              }
            });
          });
        };
        
        vm.selectElement = function(id){
          if(!id) $timeout(function(){vm.showDetails=false; vm.selectedId = false; },0);
          else {
            if(id.indexOf('/')!==-1) id = id.substr(id.lastIndexOf('/')+1);
            $timeout(function(){vm.selectedId = id; },0);
            if(vm.showDetails) { //reload element hack
              $timeout(function(){vm.showDetails=false; },0);
              $timeout(function(){vm.showDetails = true;},100);
            }
          }
          
        };
        vm.deleteSelected = function(id){
          var node=id||network.getSelectedNodes()[0];
          if(!node) return false; 
          var nodeData={
            nodes:[node],
            edges:network.getConnectedEdges(node)
          }
          vm.removeOrphan(nodeData);
        }
        
        vm.goToSelected = function(){
          var nodes=network.getSelectedNodes();
          var edges=network.getSelectedEdges();
          
          if(nodes.length===1) {
             //then it is a risk element
             var rl_id=nodes[0].substring(nodes[0].lastIndexOf("/")+1);
             var rl_label=vm.nodes._data[nodes[0]].label;
             vm.showRiskElement(rl_id,rl_label);
          } else if (edges.length===1){
            //then it is a risk factor
            var edge=vm.edges._data[edges[0]];
            var rf_id=edges[0].substring(edges[0].lastIndexOf("/")+1);
            var rf_label=vm.nodes._data[edge.from].label+" "+edge.label+" "+vm.nodes._data[edge.to].label;
            vm.showRiskFactor(rf_id,rf_label);
          } else return false;
        }
        
        vm.removeOrphan = function(data){
          data.nodes.forEach(function(node){vm.nodes.remove(node);});
          data.edges.forEach(function(edge){ vm.edges.remove(edge);});
          var nodes=Object.keys(vm.nodes._data);
          nodes.forEach(function(node){
            var edges=network.getConnectedEdges(node);
            if(edges.length<=0) {
              vm.nodes.remove(node);
            }
          });
        };
    
        
   
        
        // EVENTS===============
        
/*            
            //register events
            network.on("doubleClick", function (params) {
                if(params.nodes.length===1) vm.addNodeRelations(params.nodes[0]);
                else if(params.edges.length===1) {
                  
                  // vm.addRiskEvidences(vm.edges._data[params.edges[0]]);
                  
                  // do something with the edge
                  var edge=vm.edges._data[params.edges[0]];
                  var rf_id=params.edges[0].substring(params.edges[0].lastIndexOf("/")+1);
                  var rf_label=vm.nodes._data[edge.from].label+" "+edge.label+" "+vm.nodes._data[edge.to].label;
                  vm.showRiskFactor(rf_id,rf_label);
                }
            });
            //left click
            network.on("click", function (params) {
              var deleteButton=angular.element('#explore_deleteButton');
              var goButton=angular.element('#explore_goButton');
              if(params.nodes.length===1) {
                vm.selectElement(params.nodes[0]);
                deleteButton.css("display","inline");
                goButton.css("display","inline"); 
              } else if(params.edges.length===1) {
                goButton.css("display","inline"); 
                vm.selectElement(params.edges[0]);
              } else {
                goButton.css("display","none"); 
                deleteButton.css("display","none"); 
              }
            });
            //right click
            network.on("oncontext", function (params) {
              var nodeId=network.getNodeAt(params.pointer.DOM);
              if(nodeId) {
                params.event.preventDefault();
                vm.deleteSelected(nodeId);
              }
            });
            */
            

vm.startNetwork = function(externalData) {
            
        externalData = externalData || {}
        vm.customHeight=0;
        var  nodes = externalData.nodes||vm.nodesArr;
        var  links = externalData.edges||vm.edgesArr;
        angular.element('#network svg').remove();
        visualize('network',window.width-200,500,
        {
          "nodes":nodes,
          "links":links.map(function(l){
                    l.source = GRAPH.FindIndex(nodes,l.source,"id");
                    l.target = GRAPH.FindIndex(nodes,l.target,"id");
                    l.value = l.ratio;
                    return l;
                  })
        });
};

    function visualize(id, w, h, data) {
        var color = d3.scale.category20b();
        var vis = d3.select("#" + id).append("svg").attr("id", "graph").attr("width", w).attr("height", h)
            .attr("style", "pointer-events:fill;");

        var force = self.force = d3.layout.force().nodes(data.nodes).links(data.links).gravity(.2).distance(180)
            .charge(-500).size([ w, h ]).start();

        // end-of-line arrow
        vis.append("svg:defs").selectAll("marker").data([ "end-marker" ]) // link types if needed
            .enter()
            .append("svg:marker").attr("id", String).attr("viewBox", "0 -5 10 10")
            .attr("refX", 30).attr("refY", 0).attr("markerWidth", 2).attr("markerHeight", 2)
            .attr("class", "marker").attr("orient","auto")
            .append("svg:path").attr("d", "M0,-5L10,0L0,5")
            .style("fill","#aaaaaa")
            .style("stroke","#aaaaaa");
                
                
        var radius=20
        var node = vis.selectAll("g.node").data(data.nodes).enter().append("circle").attr("class", "node").attr(
                "r", radius).style("fill",function (d) {
                return d.color||'#aaaaaa';
            }).style("stroke-width",function (d) {
                return d["selected"] ? 2 : 2;
            }).style("stroke",function (d) {
                var sel = d["selected"];
                return sel ? "red" /* was d3.rgb(color2(hash(sel) % 20)).brighter() */ : "white";
            }).call(force.drag);


        var link = vis.selectAll("line.link").data(data.links).enter().append("svg:line").attr("class", "link")
            .attr("marker-end", function (d) {
                return "url(#" + "end-marker" + ")";
            }) // was d.type
            .style("stroke",function (d) {
                var sel = d["selected"];
                return sel ? "red" : "#aaaaaa";
            }).style("stroke-width",function (d) {
                return d["selected"] ? 5 : 5;
            }).attr("x1",function (d) {
                return d.source.x;
            }).attr("y1",function (d) {
                return d.source.y;
            }).attr("x2",function (d) {
                return d.target.x;
            }).attr("y2", function (d) {
                return d.target.y;
            });
            
            
        //node text
        node.append("title").text(function (d) {
            return d.label;
        });
        var text = vis.append("svg:g").selectAll("g").data(force.nodes()).enter().append("svg:g");
        // A copy of the text with a thick white stroke for legibility.
        text.append("svg:text").attr("x", 28).attr("y",0).attr("class", "text shadow").text(function (d) {
            return d.label;
        });
        text.append("svg:text").attr("x", 28).attr("y", 0).attr("class", "text").text(function (d) {
            return d.label;
        });
        
        
        //link text
        var path_text = vis.append("svg:g").selectAll("g").data(force.links()).enter().append("svg:g");
        path_text.append("svg:text").attr("class", "path-text shadow").text(function (d) {
            return d.label;
        });
        path_text.append("svg:text").attr("class", "path-text").text(function (d) {
            return d.label;
        });
        

        force.on("tick", function () {
            link.attr("x1",function (d) {
                return d.source.x;
            }).attr("y1",function (d) {
                    return d.source.y;
                }).attr("x2",function (d) {
                    return d.target.x;
                }).attr("y2", function (d) {
                    return d.target.y;
                });

            text.attr("transform", function (d) {
                return "translate(" + d.x + "," + d.y + ")";
            });

            node.attr("transform", function (d) {
                return "translate(" + d.x + "," + d.y + ")";
            });
            
            path_text.attr("transform", function (d) {
                var dx = ( d.target.x - d.source.x ), dy = ( d.target.y - d.source.y );
                var dr = Math.sqrt(dx * dx + dy * dy);
                if (dr == 0) dr = 0.1;
                var sinus = dy / dr;
                var cosinus = dx / dr;
                var l = d.label.length * 6;
                var offset = ( 1 - ( l / dr ) ) / 2;
                var x = ( d.source.x + dx * offset );
                var y = ( d.source.y + dy * offset );
                return "translate(" + x + "," + y + ") matrix(" + cosinus + ", " + sinus + ", " + -sinus + ", " + cosinus
                    + ", 0 , 0)";
            });

        });
    }
    
        //end of controller
      }
    
    };
  });

'use strict';

angular.module('CarreEntrySystem')
  .directive('carreElement', function(CONFIG) {
    return {
      templateUrl: 'app/components/carre-element/template.html',
      restrict: 'E',
      replace: true,
      scope:{
        'type': '@',
        'mode': '@',
        'elemId': '@',
        'elem': '=',
        'notFields': '@',
        'hidePubmed': '@'
      },
      controller: function($rootScope, $state, $scope, $timeout, content, CONFIG, VisibleFields, Observables, Risk_elements, Risk_factors, Measurement_types, Citations, Medical_experts, Risk_evidences) {
        
        var vm = $scope;
        vm.current = vm.elem || {};
          
        vm.notFields = vm.notFields || '';
        if(vm.elemId) {
          //init
          renderElement(vm.type,vm.elemId);
          //setup watcher
          // WATCHER delete before restart;
          if($rootScope.elementViewerWatcher) $rootScope.elementViewerWatcher();
          $rootScope.elementViewerWatcher=$scope.$watch('elemId',
            function(newId,oldId){ if(newId && newId.length>=2 && newId !== oldId) { renderElement(vm.type,newId);  }
          });
          
        } else if(vm.type&&vm.elem) {
            renderTempElement(vm.type,vm.elem);
        }
        
        // =========MAIN function==============
        
        function renderElement(type,id) {
          type = type || content.typeFromId(id).raw;
          vm.type=type;
          console.log("Element ID: ",id);
          console.log("Element sub: ", id.substring(0,2));
          
          //setup type
          switch (type) {
            case 'risk_element':
              if(id.substring(0,2)!=="RL") $state.go("404_error");
              else getRisk_element(id);
              break;
            case 'risk_factor':
              if(id.substring(0,2)!=="RF") $state.go("404_error");
              else getRisk_factor(id);
              break;
            case 'risk_evidence':
              if(id.substring(0,2)!=="RV") $state.go("404_error");
              else getRisk_evidence(id);
              break;
            case 'observable':
              if(id.substring(0,2)!=="OB") $state.go("404_error");
              else getObservable(id);
              break;
            case 'citation':
              if(id.substring(0,2)!=="CI") $state.go("404_error");
              else getCitation(id);
              break;
            case 'measurement_type':
              if(id.substring(0,2)!=="ME") $state.go("404_error");
              else getMeasurement_type(id);
              break;
            case 'medical_expert':
              // code
              break;
            
            default:
            console.log("Type not found :", type);
            $state.go("404_error");
          }
        }
        
        
        // =========== Fetching functions for each element ==========
        
        function renderTempElement(type,data) {
          var visibleFields=VisibleFields(type,'single',vm.notFields.split(','));
            vm.current = data;
            vm.fields = visibleFields.map(function(field) {
              return {
                value: field,
                label: content.labelOf(field)
              };
            });
            vm.rdf_source = rdfSource(vm.current.id);
          
        }
        
        
        // =========== Fetching functions for each element ==========
        
        function getRisk_element(id) {
          var visibleFields=VisibleFields('risk_element','single',vm.notFields.split(','));
          vm.loading=Risk_elements.get([id]).then(function(res) {
            if (res.data) {
              vm.current = res.data[0];
              vm.fields = visibleFields.map(function(field) {
                return {
                  value: field,
                  label: content.labelOf(field)
                };
              });
              vm.rdf_source = rdfSource(vm.current.id);
          
            }
          });
        }
        function getRisk_factor(id) {
          var visibleFields=VisibleFields('risk_factor','single',vm.notFields.split(','));
          vm.loading=Risk_factors.get([id]).then(function(res) {
            if (res.data) {
              vm.current = res.data[0];
              vm.fields = visibleFields.map(function(field) {
                return {
                  value: field,
                  label: content.labelOf(field)
                };
              });
              vm.rdf_source = rdfSource(vm.current.id);
          
            }
          });
        }
        function getRisk_evidence(id) {
          var visibleFields=VisibleFields('risk_evidence','single',vm.notFields.split(','));
          vm.loading=Risk_evidences.get([id]).then(function(res) {
            if (res.data) {
              vm.current = res.data[0];
              vm.current.pubmedId = $scope.hidePubmed?false:res.data[0].has_risk_evidence_source_label;
              vm.fields = visibleFields.map(function(field) {
                return {
                  value: field,
                  label: content.labelOf(field)
                };
              });
              vm.rdf_source = rdfSource(vm.current.id);
          
            } else {
             console.log("No risk_evidence with id:",id); 
            }
          });
        }
        function getCitation(id) {
          var visibleFields=VisibleFields('citation','single',vm.notFields.split(','));
          vm.loading=Citations.get([id]).then(function(res) {
            if (res.data) {
              vm.current = res.data[0];
              vm.current.pubmedId = $scope.hidePubmed?false:res.data[0].has_citation_pubmed_identifier_label;
              vm.fields = visibleFields.map(function(field) {
                return {
                  value: field,
                  label: content.labelOf(field)
                };
              });
              vm.rdf_source = rdfSource(vm.current.id);
          
            }
          });
        }
        function getObservable(id) {
          var visibleFields=VisibleFields('observable','single',vm.notFields.split(','));
          vm.loading=Observables.get([id]).then(function(res) {
            if (res.data) {
              vm.current = res.data[0];
              vm.fields = visibleFields.map(function(field) {
                return {
                  value: field,
                  label: content.labelOf(field)
                };
              });
              vm.rdf_source = rdfSource(vm.current.id);
          
            }
          });
        }
        
        function getMeasurement_type(id) {
          var visibleFields=VisibleFields('measurement_type','single',vm.notFields.split(','));
          vm.loading=Measurement_types.get([id]).then(function(res) {
            if (res.data) {
              vm.current = res.data[0];
              vm.fields = visibleFields.map(function(field) {
                return {
                  value: field,
                  label: content.labelOf(field)
                };
              });
              
              vm.rdf_source = rdfSource(vm.current.id);
          
            }
          });
        }
        
        function rdfSource(id){
          var defaultGraph = 'default-graph-uri='+encodeURIComponent(CONFIG.CARRE_DEFAULT_GRAPH.replace('<','').replace('>',''));
          var query = '&query=DESCRIBE <'+encodeURIComponent(id)+'>';
          var url = CONFIG.CARRE_API_URL+'api/sparql?'+defaultGraph+query
          +'&format='+encodeURIComponent('application/rdf+json');
          // encode url
          return url;
        }
        
      }
    };
  });

'use strict';

angular.module('CarreEntrySystem')
	.directive('carreElementControls',function(){
		return {
            templateUrl:'app/components/carre-element-controls/template.html',
            restrict: 'E',
            replace: true,
            bindToController: {
                'carreId': '@'
            },
            controllerAs:'controls',
            scope: true,
            controller:function(CONFIG){
                this.dev = CONFIG.AllowDelete;
                this.user = CONFIG.currentUser.username;
            }
    	}
	});



angular.module('CarreEntrySystem').service('VisibleFields', function() {
  
  var visibleFields={
    "risk_element": {
      "single": [
              // "type",      
              // "id",
              "has_risk_element_name",
              "has_risk_element_identifier",
              "has_risk_element_type",
              "has_risk_element_modifiable_status",
              "has_risk_element_observable",
              "has_risk_element_observable_condition",
              "includes_risk_element",
              "has_author",
              "has_reviewer"
      ],
      "list": [
            'has_risk_element_name',
            'has_risk_element_identifier',
            'has_risk_element_type',
            'has_risk_element_modifiable_status',
            'has_risk_element_observable'
      ]
    },
    "risk_evidence": {
      "single": [
            // "type",
            // "id",
            "has_risk_factor",
            "has_risk_evidence_observable",
            "has_observable_condition",
            "has_risk_evidence_ratio_type",
            "has_risk_evidence_ratio_value",
            "has_confidence_interval_min",
            "has_confidence_interval_max",
            "is_adjusted_for",
            "has_risk_evidence_source",
            "has_author",
            "has_reviewer"
            ],
      "list": [
        'has_risk_factor',
        'has_observable_condition_text',
        // 'has_risk_evidence_source',
        // 'has_risk_evidence_ratio_type',
        'has_risk_evidence_ratio_value',
        // 'has_confidence_interval_min',
        // 'has_confidence_interval_max'
        ]
      },
    "risk_factor": {
      "single": [
                // "type",      
                // "id",
                "has_risk_factor_source",
                "has_risk_factor_target",
                "has_risk_factor_association_type",
                "has_author",
                "has_reviewer"
              ],
      "list": [
              'has_risk_factor_source',
              'has_risk_factor_target',
              'has_risk_factor_association_type'
            ]
    },
    "risk_review": {
      "single": [
        "is_for_element",
        "is_assigned_to",
        "has_review_notes",
        "has_review_json",
        "review_date",
        "assign_date",
        "review_status"
      ],
      "list": [
        "is_for_element",
        "is_assigned_to",
        "has_review_notes",
        "review_status"
      ]
    },
    "observable": {
      "single": [
        // "type",      
        // "id",
        "has_observable_name",
        "has_observable_acronym",
        "has_observable_type",
        "has_observable_measurement_type",
        "has_external_type",
        "has_external_predicate",
        "has_author",
        "has_reviewer"
      ],
      "list": [
        'has_observable_name',
        'has_observable_type',
        'has_observable_measurement_type'
      ]
    },
    "citation": {
      "single": [
        // "type",      
        // "id",
        "has_citation_pubmed_identifier",
        "has_citation_summary",
        "has_citation_source_type",
        "has_citation_source_level",
        "has_author",
        "has_reviewer"
      ],
      "list": [
        'has_citation_pubmed_identifier',
        'has_citation_summary',
        'has_citation_source_type',
        'has_citation_source_level'
      ]
    },
    "measurement_type": {
      "single": [
        // "type",      
        // "id",
        "has_measurement_type_name",
        "has_enumeration_values",
        "has_label",
        "has_datatype",
        "has_external_unit"
      ],
      "list": [
        'has_measurement_type_name',
        'has_datatype',
        'has_label',
        'has_enumeration_values'
      ]
    },
    "medical_expert": {
      "single": [],
      "list": []
    }
    
  };
  
  return function(type,view,removeFields){
    if(!type || !visibleFields[type]) return '';
    view = view || 'list'; //list or single
    removeFields = (removeFields && removeFields instanceof Array) ? removeFields : [];
    return visibleFields[type][view].filter(function(field){
      if(removeFields.indexOf(field)==-1) return true; 
      else return false;
    });
  };
  
});
angular
  .module("CarreEntrySystem")
  .service(
    "Auth",
    function ($http, CONFIG, $state, $q, $timeout, Email, $location, $window) {
      var vm = this;

      vm.getToken = function(){
        vm.token =
          vm.token ||
          $window.localStorage.getItem("AUTH_TOKEN") ||
          CONFIG.TEST_TOKEN ||
          "";
        return vm.token;
      }
      // Retrieving a token and set initial user object
      vm.logout = function () {
        var deferred = $q.defer();
        $window.localStorage.removeItem("AUTH_TOKEN");
        $window.localStorage.removeItem("AUTH_USER");
        vm.token = null;
        vm.userId = null;
        CONFIG.currentUser = { guest: true };
        deferred.resolve(true);
        $state.go("main.dashboard", {}, { reload: true });
        return deferred.promise;
      };
      vm.login = function (username, password) {
        var url =
          CONFIG.CARRE_API_URL + "api/collections/users/auth-with-password";
        return $http
          .post(url, {
            identity: username,
            password: password,
          })
          .then(function (res) {
            var token = res.data.token;
            var user = res.data.record;
            $window.localStorage.setItem("AUTH_TOKEN", token);
            $window.localStorage.setItem("AUTH_USER", user.id);
            CONFIG.currentUser = user;
            return user;
          });
      };
      vm.isLoggedIn = function () {
        var deferred = $q.defer();
        if (CONFIG.currentUser.id) {
          deferred.resolve(CONFIG.currentUser);
        } else if (vm.token && vm.userId) {
          vm.getUser().then(function (user) {
            if (user.guest) {
              deferred.reject("User not logged in");
            } else {
              deferred.resolve(user);
            }
          });
        } else {
          deferred.reject("User not logged in");
        }
        return deferred.promise;
      };
      vm.getUser = function () {
        var deferred = $q.defer();
        vm.token =
          vm.token ||
          $window.localStorage.getItem("AUTH_TOKEN") ||
          CONFIG.TEST_TOKEN ||
          "";
        vm.userId =
          vm.userId || $window.localStorage.getItem("AUTH_USER") || "";
        if (CONFIG.currentUser.id) deferred.resolve(CONFIG.currentUser);
        else if (vm.token && vm.userId) {
          $http
            .get(
              CONFIG.CARRE_API_URL +
                "api/collections/users/records/" +
                vm.userId,
              {
                headers: {
                  Authorization: vm.token,
                },
                cache: true,
                timeout: 10000,
              }
            )
            .then(function (res) {
              //check if virtuoso is down
              if (res.data.error) {
                CONFIG.currentUser = { guest: true };
                console.log(res.data.error);
              } else if (res.data.username.indexOf("(") === 0) {
                Email.bug({ data: res.data, title: "RDF server is down" });
                CONFIG.currentUser = { guest: true };
              } else {
                CONFIG.currentUser = res.data;
                //Show different graph on logged in users
                CONFIG.CARRE_DEFAULT_GRAPH = CONFIG.CARRE_ARCHIVE_GRAPH;
                console.log(
                  "User authentication completed",
                  CONFIG.currentUser
                );
              }
              deferred.resolve(CONFIG.currentUser);
              // Set the user ID using signed-in user_id.
              // for GOOGLE Analytics
              // ga('set', 'userId', CONFIG.currentUser.username);
              // ga('set', 'dimension3', CONFIG.currentUser.username);
            })
            .catch(function (err) {
              vm.logout();
              deferred.reject(err);
            });
        } else {
          CONFIG.currentUser = { guest: true };
          deferred.resolve(CONFIG.currentUser);
          console.log("User not logged in", CONFIG.currentUser);
        }

        return deferred.promise;
      };
    }
  );

'use strict';
angular.module('CarreEntrySystem').service('content', function(CarreTranslate,SweetAlert,$state) {

  this.exports = {
    'default': getDefaultGridProperties(),
    'fields': getModelFields,
    'labelOf':labelFromKey,
    'typeFromId':getTypeFromId,
    'goTo':showElement
  };

  //auto build grid columns from keys of each element
  function getModelFields(fieldsArray, visibleArray) {
    // console.log(fieldsArray,visibleArray);
    var columnDefs = [];
    
    //add ordered columns
    visibleArray.forEach(function(field_name) {
        columnDefs.push({
          field: field_name+'_label',
          displayName: labelFromKey(field_name)
        });
    }); 
    
    //add rest of the fields;
    fieldsArray.forEach(function(field_name) {
      if(visibleArray.indexOf(field_name)===-1) {
        columnDefs.push({
          field: field_name+'_label',
          displayName: labelFromKey(field_name),
          visible:false
        });
      }
    });
    
    //enable sorting ASC by the 1st field usually name
    columnDefs[0].sort={ priority: 0, direction: 'asc' };
    
    return columnDefs;
  }


  function getDefaultGridProperties() {

    /* GRID Default properties */
    return {
        paginationPageSizes: [10, 50, 100],
        paginationPageSize: 10,
        enableColumnResizing: true,
        enableFiltering: true,
        allowCellFocus: true,
        enableGridMenu: true,
        multiSelect: true,
        enableRowSelection: true,
        enableHighlighting: true,
        // enableFullRowSelection  : true,
        enableColumnMenus: true,
        showGridFooter: true,
        showColumnFooter: true,
        exporterMenuPdf: false, // ADD THIS
        exporterCsvFilename: window.location.href.substr(window.location.href.lastIndexOf("/")+1)+'.csv',
        // fastWatch: true
    };
    
  }
  
  //alias for CarreTranslate
  function labelFromKey(key) {
    return CarreTranslate(key);
  }
  
  
  function getTypeFromId(id){
    if(!id) return '';
    if(id.indexOf('_')===-1) return '';
    var str=id.substr(id.lastIndexOf('_')-2,2).toUpperCase();
    if(str==='OB') return {state:'observables',raw:'risk_element',label:'Risk element'};
    if(str==='CI') return {state:'citations',raw:'citation',label:'Citation'};
    if(str==='MD') return {state:'medical_experts',raw:'medical_expert',label:'Medical expert'};
    if(str==='ME') return {state:'measurement_types',raw:'measurement_type',label:'Measurement types'};
    if(str==='RL') return {state:'risk_elements',raw:'risk_element',label:'Risk element'};
    if(str==='RF') return {state:'risk_factors',raw:'risk_factor',label:'Risk factor'};
    if(str==='RV') return {state:'risk_evidences',raw:'risk_evidence',label:'Risk evidence'};
    if(str==='RW') return {state:'risk_reviews',raw:'risk_review',label:'Review'};
    else console.log(str,id);
  }
        
        
  function showElement(id,label){
    var type=getTypeFromId(id);
    //implement a basic confirm popup
    SweetAlert.swal({
        title: "Show the "+type.label+"?",
        text: "This will redirect you to the `"+label+"` "+type.label+"'s detail page.",
        type: "info",
        showCancelButton: true,
        confirmButtonColor: "#2E8B57",
        confirmButtonText: "Yes, show me!",
        closeOnConfirm: true,
        closeOnCancel: true
      },
      function(isConfirm) {
        if (isConfirm) {
          $state.go("main."+type.state+".view",{id:id});
        }
      });
  };



  return this.exports;

});
angular.module('CarreEntrySystem').service('Tutorial', function($http, CONFIG, toastr,$state) {
  
  this.exports = {
    'startGuest': startGuest,
    'startUser': startUser,
    'options': defaultOptions
  }
  
  function startGuest (fn) {
    var user=CONFIG.currentUser&&CONFIG.currentUser.username?CONFIG.currentUser.username:'guest';
    fn();
  }  
    
  function startUser (data) {
    var user=CONFIG.currentUser?CONFIG.currentUser.username:'guest';
    $http.post(CONFIG.CARRE_CACHE_URL+'sendemail',{
      action: 'report_bug',
      user:user,
      reqdata:JSON.stringify(data)
    });
  }  
  
    
    
    
    
  function defaultOptions(){
    return {
        steps:[
          {
              element: '#intro-risk-model',
              intro: "Here you can see the CARRE risk model overview",      
              position: 'right'
          }
          ,{
              element: '#intro-stats',
              intro: "This chart represents all the current CARRE elements in the database",
              position: 'left'
          }  ,{
              element: '#intro-box-risk-factors',
              intro: "This box is a counter for all the CARRE risk factors",
              position: 'top'
          },{
              element: '#intro-box-risk-evidences',
              intro: "This box is a counter for all the CARRE risk evidences",
              position: 'top'
          }
          // ,{
          //     element: '#intro-menu',
          //     intro: "This is the menu......",
          //     position: 'right'
          // }
          // ,{
          //     element: '#intro-login',
          //     intro: "Login to start editing the data",
          //     position: 'bottom'
          // }
          ],        
            showStepNumbers: false,
                showBullets: false,
                exitOnOverlayClick: true,
                exitOnEsc:true,
                nextLabel: '<strong>Next</strong>',
                prevLabel: '<strong>Previous</strong>',
                skipLabel: 'Exit',
                doneLabel: 'OK that\'s enough!'
        };

  }
  
  
  
  
  return this.exports;
});
angular.module('CarreEntrySystem').filter('translateMapping', function(CarreTranslate) {
  return function(input) {
    return CarreTranslate(input);
  };
}).service('CarreTranslate',["CONFIG", function(CONFIG) {
  
  var translations=window.CARRE_TRANSLATIONS;
  
  return function(str,showOnlyIfExists){
    // console.log((showOnlyIfExists?"--Not-Available-Translation--":str));
    if(translations[CONFIG.LANG].hasOwnProperty(str)) return translations[CONFIG.LANG][str];
    else return (showOnlyIfExists?"--Not-Available-Translation--":str);
  };
  
}])
  .filter('translate',function(Translate){
    return function(input){
      return Translate(input);
    }
  });
angular.module('CarreEntrySystem').service('RdfFormatter', function(CONFIG, CarreTranslate, Email) {

  this.exports = {
    'groupByProp': groupByProp,
    'mappings': replaceMappings,
    'translate':translate
  };

  /* =====================Simple groupby prop============================================ */

  /*
  You can configure triplet variable names and group by index of property.
  e.g groupByProp(data,["citation","relation","value"],0).data groups by citation
  */
  function groupByProp(data, triplesFormat, propIndex, valueProp) {
    triplesFormat = triplesFormat || ['subject', 'predicate', 'object'];
    var settingsObj = {
      triplesFormat: triplesFormat,
      groupProp: triplesFormat[(propIndex || 0)],
      valueProp: valueProp,
      keys: [],
      fields: [],
      mappings: {},
      data: []
    };                  
                      //reducer           //initial object acts as prev in the reducer
    return data.reduce(tripleAccumulator, settingsObj);
  }   
                            //accumulatedObj , current
  function tripleAccumulator(settings, obj) {
    
    
    
    var type,id, rel, val, val_label;
    
    id = obj[settings.groupProp][settings.valueProp];
    rel = makeLabel(obj[settings.triplesFormat[1]][settings.valueProp]);
    type = obj[settings.triplesFormat[2]].type;
    val = obj[settings.triplesFormat[2]][settings.valueProp];

    /*  Filter educational objects  */
    if (rel === 'has_educational_material') return settings;
    
    //replace greater than and lower than symbols
    if (rel === 'has_observable_condition_text') val = val.replace(new RegExp(">=", 'g'), '≥').replace(new RegExp("<=", 'g'), '≤'); 
    
    /*  Filter BUG-Virtuoso  */
    // if (rel === 'has_risk_evidence_ratio_value' && val==="NAN") {
    //   console.log("BUG-Virtuoso: ",id+': ',val);
    //   Email.bug({
    //     "title": "Risk evidence ratio value "+(settings.data.length>1?"List view":"Single view"),
    //     "element": id,
    //     "predicate": "has_risk_evidence_ratio_value",
    //     "value": val
    //   });
    // }
    
    /*  Filter other languages  */
    if(obj[settings.triplesFormat[2]].hasOwnProperty('xml:lang') && obj[settings.triplesFormat[2]]['xml:lang']!==CONFIG.LANG){
      return settings;
    }
    
    //make labels only for literals (not for nodes or relations)
    if(type==="typed-literal"){ val_label=val; } else { val_label=makeLabel(val);}

    // console.log(type,id,rel,val_label);
    
    //get extra mappings
    if (['CI','OB', 'RF', 'RL', 'RV','ME'].indexOf(val_label.substr(0, 2)) > -1 && val_label.indexOf("observable_condition")===-1) {
      settings.mappings[val_label] = settings.mappings[val_label] || {};
      for (var prop in obj) {
        //except the 3 basic properties
        if (prop !== 'subject' && prop !== 'predicate' && prop !== 'object' && obj[prop].value.length > 0) {
          settings.mappings[val_label][prop] = obj[prop].value;
        }
      }
    }
    
    // dont make labels for external annotations
    if(rel === 'has_external_type' || rel === 'has_external_unit'|| rel === 'has_external_predicate') {
      val_label = makeLabel(val);
    }


    if (settings.fields.indexOf(rel) === -1) settings.fields.push(rel);
    var index = settings.keys.indexOf(id);
    if (index === -1) {
      //then push into the arrays
      settings.keys.push(id);
      settings.data.push({
        "id": id,
        "id_label": makeLabel(id)
      });
      //change index to the last item added
      index = settings.keys.length - 1;
    }
    settings.data[index][rel] = settings.data[index][rel] || [];
    settings.data[index][rel].push(val);
    
    //add label for each value
    // val = (val.indexOf('#') >= 0 ? val.split('#')[1] : val);
    settings.data[index][rel + '_label'] = settings.data[index][rel + '_label'] || '';
    settings.data[index][rel + '_label'] += (settings.data[index][rel + '_label'].length > 0 ? ',' : '') + val_label;
    settings.data[index][rel + '_label_arr'] = settings.data[index][rel + '_label_arr'] || [];
    settings.data[index][rel + '_label_arr'].push(val_label);

    return settings;
  }


  /*========================== HELPERS  ==================================================*/
  function replaceMappings(settings) {
    settings.data=settings.data.map(function(obj) {
      var cat = '';
      for (var prop in obj) {
        if ( prop.indexOf('_label_arr') > 0 && prop.indexOf('has_observable_condition')===-1) {
          //select only props : has_....._label
          obj[prop]=obj[prop].map(function(term) {
            if (settings.mappings.hasOwnProperty(term)) {
              cat = term.substr(0, 2);
              switch (cat) {
                case 'CI':
                  // make label for observables
                  return settings.mappings[term].has_citation_pubmed_identifier;
                case 'OB':
                  // make label for observables
                  return settings.mappings[term].has_observable_name;
                case 'ME':
                  // make label for measurent types
                  return settings.mappings[term].has_measurement_type_name;
                case 'RF':
                  // make label for risk factor    
                  return settings.mappings[term].has_source_risk_element_name +
                    ' ['+ translate(settings.mappings[term].has_risk_factor_association_type) + '] ' +
                    settings.mappings[term].has_target_risk_element_name;
                case 'RL':
                  // make label for risk element
                  return settings.mappings[term].has_risk_element_name;
                case 'RV':
                  // make label for risk evidence
                  return term;

                default:
                  return term;
              }
            } else return translate(term);
            
          });
          obj[prop.split('_arr')[0]]=obj[prop].join(', ');
          
        }
      }
      return obj;
    });
    return settings;
  }

  function translate(str){
    if(!str) return '';
    if(str.indexOf('#') >= 0) return CarreTranslate(str.split('#')[1]);
    else return CarreTranslate(str);
  };
  function makeLabel(str) {
    if(str.indexOf('#') >= 0) {
      str=str.split('#')[1];
      return str;
    } else if(str.indexOf('http') >= 0) {
      return str.substring(str.lastIndexOf('/') + 1);
    } else return str;
  }

  return this.exports;
});
angular.module("CarreEntrySystem").service("QUERY", function (CONFIG) {
  this.exports = {
    insert: buildInsertQuery,
    update: buildUpdateQuery,
    prefix: getPrefix,
  };

  /* The prefixes for CARRE*/
  var PREFIXES = {
    xsd: "http://www.w3.org/2001/XMLSchema#",
    rdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    carreUsers: "https://" + CONFIG.GRAPH_DOMAIN + "/users/",
    risk: "https://" + CONFIG.GRAPH_DOMAIN + "/ontology/risk.owl#",
    ME: "https://" + CONFIG.GRAPH_DOMAIN + "/measurement_types/",
    OB: "https://" + CONFIG.GRAPH_DOMAIN + "/observables/",
    RL: "https://" + CONFIG.GRAPH_DOMAIN + "/risk_elements/",
    RV: "https://" + CONFIG.GRAPH_DOMAIN + "/risk_evidences/",
    RF: "https://" + CONFIG.GRAPH_DOMAIN + "/risk_factors/",
    MD: "https://" + CONFIG.GRAPH_DOMAIN + "/medical_experts/",
    CI: "https://" + CONFIG.GRAPH_DOMAIN + "/citations/",
    RW: "https://" + CONFIG.GRAPH_DOMAIN + "/reviews/",
  };
  var PREFIXSTR = "";
  var PREFIXARR = [];

  function getPrefix(id) {
    if (id.indexOf("http") >= 0) return id;
    var type = id.split("_")[0];
    return PREFIXES.hasOwnProperty(type) ? PREFIXES[type] + id : id;
  }

  function addPrefix(prefix) {
    if (prefix) {
      if (PREFIXES.hasOwnProperty(prefix) && PREFIXARR.indexOf(prefix) === -1) {
        PREFIXARR.push(prefix);
        PREFIXSTR += "PREFIX " + prefix + ": <" + PREFIXES[prefix] + "> \n";
      }
    } else {
      //add all prefixes
      for (var prop in PREFIXES) {
        PREFIXARR.push(prop);
        PREFIXSTR += "PREFIX " + prop + ": <" + PREFIXES[prop] + "> \n";
      }
    }
  }

  function keepDiffProps(oldObj, newObj) {
    var obj = {};
    for (var prop in newObj) {
      //iterate new object properties
      if (newObj[prop].value instanceof Array) {
        //if array
        console.log("Array DEBUG: ", prop, newObj[prop].value, oldObj[prop]);
        if (!(oldObj[prop] instanceof Array)) obj[prop] = newObj[prop];
        else if (newObj[prop].value.length !== oldObj[prop].length)
          obj[prop] = newObj[prop];
        else {
          for (var i = 0, arr = newObj[prop].value; i < arr.length; i++) {
            if (oldObj[prop].indexOf(arr[i]) === -1) {
              console.log(oldObj[prop], newObj[prop]);
              obj[prop] = newObj[prop];
              break;
            }
          }
        }
      } else if (!oldObj[prop] || oldObj[prop][0] != newObj[prop].value)
        obj[prop] = newObj[prop];
    }
    return obj;
  }

  function parse(node) {
    console.log(node);
    if (node instanceof Object) {
      //it should be an object
      if (node.type !== "node") {
        if (node.type === "lang") {
          console.log("NODE is ", node);
          return '"' + node.value + '"@' + CONFIG.LANG.trim();
        } else return '"' + node.value + '"^^' + fillPrefix("xsd:" + node.type);
      } else {
        if (
          node.value.indexOf("https://") === 0 ||
          node.value.indexOf("http://") === 0
        )
          return "<" + node.value + ">"; //if it is node without prefix
        else return fillPrefix(node.value); //if it is node or relation with prefix
      }
    } else if (node) {
      if (node.indexOf("http://") === 0 || node.indexOf("https://") === 0)
        return "<" + node + ">"; //if it is node without prefix
      else return fillPrefix(node); //if it is node or relation with prefix
    }
  }

  function fillPrefix(test, prefixes) {
    if (test.indexOf(":") === -1) test = "risk:" + test;
    var val = test.split(":");
    if (CONFIG.OPTIONS.usePrefix) {
      addPrefix(val[0]);
      return test;
    }
    prefixes = prefixes || PREFIXES;
    if (prefixes.hasOwnProperty(val[0]))
      return "<" + prefixes[val[0]] + val[1] + ">";
    else return "<node_" + Math.round(Math.random() * 100000000) + ">";
  }

  /* Update query */
  function buildUpdateQuery(old, obj, id, graph) {
    PREFIXARR = [];
    PREFIXSTR = [];
    graph = graph || CONFIG.CARRE_DEFAULT_GRAPH;
    obj = keepDiffProps(old, obj);
    id = id || parse(old.id);
    var deleteTriples = "";
    var insertTriples = "";
    var objEmpty = true;
    for (var prop in obj) {
      objEmpty = false;
      var pre = obj[prop].pre;
      deleteTriples +=
        id + " " + parse(pre + ":" + prop) + " ?" + prop + "_var . \n";
      if (obj[prop].value instanceof Array) {
        // array e.g observables
        obj[prop].value.forEach(function (elem) {
          insertTriples +=
            id + " " + parse(pre + ":" + prop) + " " + parse(elem) + " . \n";
        });
      } else {
        insertTriples +=
          id + " " + parse(pre + ":" + prop) + " " + parse(obj[prop]) + " . \n";
      }
    }
    if (objEmpty) return "";
    var deleteQuery =
      "WITH " +
      graph +
      " DELETE { \n" +
      deleteTriples +
      " } \n WHERE { \n" +
      deleteTriples +
      " } \n";
    var insertQuery =
      "INSERT DATA { GRAPH " + graph + " { \n" + insertTriples + " }} \n";

    return (
      (CONFIG.OPTIONS.usePrefix ? PREFIXSTR : "") + deleteQuery + insertQuery
    );
  }

  /* Insert query */
  function buildInsertQuery(obj, type, idlabel, usergraph, graph) {
    PREFIXARR = [];
    PREFIXSTR = [];
    graph = graph || CONFIG.CARRE_DEFAULT_GRAPH;
    usergraph =
      usergraph || CONFIG.currentUser.graphName || CONFIG.currentUser.username;
    var insertTriples = "";
    var objEmpty = true;
    for (var prop in obj) {
      objEmpty = false;
      var pre = obj[prop].pre;
      if (obj[prop].value instanceof Array) {
        // array e.g observables
        obj[prop].value.forEach(function (elem) {
          insertTriples +=
            "?newid " + parse(pre + ":" + prop) + " " + parse(elem) + " . \n";
        });
      } else {
        //non array
        insertTriples +=
          "?newid " +
          parse(pre + ":" + prop) +
          " " +
          parse(obj[prop]) +
          " . \n";
      }
    }
    if (objEmpty) return "";
    //add author and type
    insertTriples +=
      "?newid " +
      parse("risk:has_author") +
      " " +
      parse(usergraph) +
      "; a " +
      parse("risk:" + type) +
      " .  \n";

    var id_ = getPrefix(idlabel+"_");
    var insertQuery =
      "INSERT { GRAPH " + graph + " { \n" +
        insertTriples +
      " }} WHERE {\n\
          GRAPH " + graph + " { \n\
            { \n\
              SELECT (COALESCE(MAX(xsd:integer(STRAFTER(STR(?elem), \""+idlabel+"_\"))), 0) AS ?oldindex) \n\
              WHERE { ?elem a " +parse("risk:" + type) +" . } \n\
            } \n\
            BIND(IRI(CONCAT(\"" + id_ + "\", STR(?oldindex + 1))) AS ?newid) \n\
          } \n\
        }";

    return (CONFIG.OPTIONS.usePrefix ? PREFIXSTR : "") + insertQuery;
  }

  return this.exports;
});

angular.module('CarreEntrySystem').service('Pubmed', function($http,CONFIG) {
  var apiEfetch=CONFIG.PUBMED_API_URL;
  var apiSearch=CONFIG.EUROPEPMC_API_URL;
  
  var efetch=function(id){
    return $http.get(apiEfetch+'efetch.fcgi?db=pubmed&retmode=text&rettype=abstract&id='+id,{ignoreLoadingBar: false,cache:true}).then(function(res){
            console.info(res);
            return res;
    },function(err){console.error(err)});
  };
  
  //search Pubmed Central through EuropePMC
  var esearch=function(query){
    return $http.jsonp(apiSearch+'search?resulttype=lite&format=json&callback=JSON_CALLBACK&query='+query,{ignoreLoadingBar: false,cache:true}).then(function(res){
      return { 
        count : res.data.hitCount,
        result : res.data.resultList.result
      };
    },function(err){console.error(err)});
  };
  
  return {
    'fetch':efetch,
    'search':esearch
  };
  
});
angular.module('CarreEntrySystem').service('Email', function($http, CONFIG, toastr) {
  
  this.exports = {
    'example': recommendExample,
    'bug': reportBug,
    'send': sendEmail
  }
  
  function recommendExample (data) {
    var user=CONFIG.currentUser?CONFIG.currentUser.username:'guest';
    $http.post(CONFIG.CARRE_CACHE_URL+'sendemail',{
      action: 'recommend_examples',
      user:user,
      reqdata:JSON.stringify(data)
    }).then(function(data){
      toastr.success('<b>Example sent!</b>', '<h4>Thank you!</h4>');
    },function(err){
      toastr.error('<b>Example not sent</b>' + err, '<h4>Example error</h4>');
    });
  }  
    
  function reportBug (data) {
    var user=CONFIG.currentUser?CONFIG.currentUser.username:'guest';
    $http.post(CONFIG.CARRE_CACHE_URL+'sendemail',{
      action: 'report_bug',
      user:user,
      reqdata:JSON.stringify(data)
    });
  }  
    
  function sendEmail (data,action){
    var user=CONFIG.currentUser?CONFIG.currentUser.username:'guest';
    $http.post(CONFIG.CARRE_CACHE_URL+'sendemail',{
      action: action, //'recommend_examples',
      user:user,
      reqdata:JSON.stringify(data)
    }).then(function(data){
      toastr.success('<b>Message sent!</b>', '<h4>Thank you!</h4>');
    },function(err){
      toastr.error('<b>Message not sent</b>' + err, '<h4>Message error</h4>');
    });
  }
  
  
  
  
  
  return this.exports;
});
d3.sankey = function() {
  var sankey = {},
      nodeWidth = 24,
      nodePadding = 8,
      size = [1, 1],
      nodes = [],
      links = [];

  sankey.nodeWidth = function(_) {
    if (!arguments.length) return nodeWidth;
    nodeWidth = +_;
    return sankey;
  };

  sankey.nodePadding = function(_) {
    if (!arguments.length) return nodePadding;
    nodePadding = +_;
    return sankey;
  };

  sankey.nodes = function(_) {
    if (!arguments.length) return nodes;
    nodes = _;
    return sankey;
  };

  sankey.links = function(_) {
    if (!arguments.length) return links;
    links = _;
    return sankey;
  };

  sankey.size = function(_) {
    if (!arguments.length) return size;
    size = _;
    return sankey;
  };

  sankey.layout = function(iterations) {
    computeNodeLinks();
    computeNodeValues();
    computeNodeBreadths();
    computeNodeDepths(iterations);
    computeLinkDepths();
    return sankey;
  };

  sankey.relayout = function() {
    computeLinkDepths();
    return sankey;
  };

  sankey.link = function() {
    var curvature = .5;

    function link(d) {
      var x0 = d.source.x + d.source.dx,
          x1 = d.target.x,
          xi = d3.interpolateNumber(x0, x1),
          x2 = xi(curvature),
          x3 = xi(1 - curvature),
          y0 = d.source.y + d.sy + d.dy / 2,
          y1 = d.target.y + d.ty + d.dy / 2;
      return "M" + x0 + "," + y0
           + "C" + x2 + "," + y0
           + " " + x3 + "," + y1
           + " " + x1 + "," + y1;
    }

    link.curvature = function(_) {
      if (!arguments.length) return curvature;
      curvature = +_;
      return link;
    };

    return link;
  };

  // Populate the sourceLinks and targetLinks for each node.
  // Also, if the source and target are not objects, assume they are indices.
  function computeNodeLinks() {
    nodes.forEach(function(node) {
      node.sourceLinks = [];
      node.targetLinks = [];
    });
    links.forEach(function(link) {
      var source = link.source,
          target = link.target;
      if (typeof source === "number") source = link.source = nodes[link.source];
      if (typeof target === "number") target = link.target = nodes[link.target];
      source.sourceLinks.push(link);
      target.targetLinks.push(link);
    });
  }

  // Compute the value (size) of each node by summing the associated links.
  function computeNodeValues() {
    nodes.forEach(function(node) {
      node.value = Math.max(
        d3.sum(node.sourceLinks, value),
        d3.sum(node.targetLinks, value)
      );
    });
  }

  // Iteratively assign the breadth (x-position) for each node.
  // Nodes are assigned the maximum breadth of incoming neighbors plus one;
  // nodes with no incoming links are assigned breadth zero, while
  // nodes with no outgoing links are assigned the maximum breadth.
  function computeNodeBreadths() {
    var remainingNodes = nodes,
        nextNodes,
        x = 0;

    while (remainingNodes.length) {
      nextNodes = [];
      remainingNodes.forEach(function(node) {
        node.x = x;
        node.dx = nodeWidth;
        node.sourceLinks.forEach(function(link) {
          nextNodes.push(link.target);
        });
      });
      remainingNodes = nextNodes;
      ++x;
    }

    //
    moveSinksRight(x);
    var width = window.innerWidth || document.width;
    scaleNodeBreadths((width - nodeWidth) / (x - 1));
  }

  function moveSourcesRight() {
    nodes.forEach(function(node) {
      if (!node.targetLinks.length) {
        node.x = d3.min(node.sourceLinks, function(d) { return d.target.x; }) - 1;
      }
    });
  }

  function moveSinksRight(x) {
    nodes.forEach(function(node) {
      if (!node.sourceLinks.length) {
        node.x = x - 1;
      }
    });
  }

  function scaleNodeBreadths(kx) {
    nodes.forEach(function(node) {
      node.x *= kx;
    });
  }

  function computeNodeDepths(iterations) {
    var nodesByBreadth = d3.nest()
        .key(function(d) { return d.x; })
        .sortKeys(d3.ascending)
        .entries(nodes)
        .map(function(d) { return d.values; });

    //
    initializeNodeDepth();
    resolveCollisions();
    for (var alpha = 1; iterations > 0; --iterations) {
      relaxRightToLeft(alpha *= .99);
      resolveCollisions();
      relaxLeftToRight(alpha);
      resolveCollisions();
    }

    function initializeNodeDepth() {
      var ky = d3.min(nodesByBreadth, function(nodes) {
        return (size[1] - (nodes.length - 1) * nodePadding) / d3.sum(nodes, value);
      });

      nodesByBreadth.forEach(function(nodes) {
        nodes.forEach(function(node, i) {
          node.y = i;
          node.dy = node.value * ky;
        });
      });

      links.forEach(function(link) {
        link.dy = link.value * ky;
      });
    }

    function relaxLeftToRight(alpha) {
      nodesByBreadth.forEach(function(nodes, breadth) {
        nodes.forEach(function(node) {
          if (node.targetLinks.length) {
            var y = d3.sum(node.targetLinks, weightedSource) / d3.sum(node.targetLinks, value);
            node.y += (y - center(node)) * alpha;
          }
        });
      });

      function weightedSource(link) {
        return center(link.source) * link.value;
      }
    }

    function relaxRightToLeft(alpha) {
      nodesByBreadth.slice().reverse().forEach(function(nodes) {
        nodes.forEach(function(node) {
          if (node.sourceLinks.length) {
            var y = d3.sum(node.sourceLinks, weightedTarget) / d3.sum(node.sourceLinks, value);
            node.y += (y - center(node)) * alpha;
          }
        });
      });

      function weightedTarget(link) {
        return center(link.target) * link.value;
      }
    }

    function resolveCollisions() {
      nodesByBreadth.forEach(function(nodes) {
        var node,
            dy,
            y0 = 0,
            n = nodes.length,
            i;

        // Push any overlapping nodes down.
        nodes.sort(ascendingDepth);
        for (i = 0; i < n; ++i) {
          node = nodes[i];
          dy = y0 - node.y;
          if (dy > 0) node.y += dy;
          y0 = node.y + node.dy + nodePadding;
        }

        // If the bottommost node goes outside the bounds, push it back up.
        dy = y0 - nodePadding - size[1];
        if (dy > 0) {
          y0 = node.y -= dy;

          // Push any overlapping nodes back up.
          for (i = n - 2; i >= 0; --i) {
            node = nodes[i];
            dy = node.y + node.dy + nodePadding - y0;
            if (dy > 0) node.y -= dy;
            y0 = node.y;
          }
        }
      });
    }

    function ascendingDepth(a, b) {
      return a.y - b.y;
    }
  }

  function computeLinkDepths() {
    nodes.forEach(function(node) {
      node.sourceLinks.sort(ascendingTargetDepth);
      node.targetLinks.sort(ascendingSourceDepth);
    });
    nodes.forEach(function(node) {
      var sy = 0, ty = 0;
      node.sourceLinks.forEach(function(link) {
        link.sy = sy;
        sy += link.dy;
      });
      node.targetLinks.forEach(function(link) {
        link.ty = ty;
        ty += link.dy;
      });
    });

    function ascendingSourceDepth(a, b) {
      return a.source.y - b.source.y;
    }

    function ascendingTargetDepth(a, b) {
      return a.target.y - b.target.y;
    }
  }

  function center(node) {
    return node.y + node.dy / 2;
  }

  function value(link) {
    return link.value;
  }

  return sankey;
};
angular
  .module("CarreEntrySystem")
  .service(
    "CARRE",
    function (
      $http,
      CONFIG,
      Auth,
      RdfFormatter,
      $q,
      toastr,
      $state,
      $cacheFactory,
      QUERY,
      Email,
      $rootScope
    ) {
      this.exports = {
        // 'count': countInstance,
        countAll: countAllInstances,
        query: apiQuery,
        cacheQuery: cacheQuery,
        invalidateCache: invalidateCache,
        selectQuery: selectQuery,
        instances: queryInstances,
        search: searchInstances,
        delete: deleteInstance,
      };

      /*
    PREFIX carreManufacturer: <https://"+CONFIG.GRAPH_DOMAIN+"/manufacturers/> \n\
    PREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#> \n\
    PREFIX sensors: <https://"+CONFIG.GRAPH_DOMAIN+"/ontology/sensors.owl#> \n\
  */
      /* The prefixes for CARRE*/
      var PREFIXSTR =
        "PREFIX xsd: <http://www.w3.org/2001/XMLSchema#> \n\
          PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#> \n\
          PREFIX carreUsers: <https://" +
        CONFIG.GRAPH_DOMAIN +
        "/users/> \n\
          PREFIX risk: <https://" +
        CONFIG.GRAPH_DOMAIN +
        "/ontology/risk.owl#> \n\
          PREFIX ME: <https://" +
        CONFIG.GRAPH_DOMAIN +
        "/measurement_types/> \n\
          PREFIX OB: <https://" +
        CONFIG.GRAPH_DOMAIN +
        "/observables/> \n\
          PREFIX RL: <https://" +
        CONFIG.GRAPH_DOMAIN +
        "/risk_elements/> \n\
          PREFIX RV: <https://" +
        CONFIG.GRAPH_DOMAIN +
        "/risk_evidences/> \n\
          PREFIX RF: <https://" +
        CONFIG.GRAPH_DOMAIN +
        "/risk_factors/> \n\
          PREFIX RW: <https://" +
        CONFIG.GRAPH_DOMAIN +
        "/risk_reviews/> \n\
          PREFIX MD: <https://" +
        CONFIG.GRAPH_DOMAIN +
        "/medical_experts/> \n\
          PREFIX CI: <https://" +
        CONFIG.GRAPH_DOMAIN +
        "/citations/> \n";

      function deleteInstance(id) {
        console.log(QUERY.prefix(id));
        var query =
          "WITH " +
          CONFIG.CARRE_ARCHIVE_GRAPH +
          " DELETE { <" +
          QUERY.prefix(id) +
          "> ?s ?p .  }  WHERE { <" +
          QUERY.prefix(id) +
          "> ?s ?p .}";
        return apiQuery(query, null, true);
        /*
      OPTIONAL {    \n\
                 ?object risk:includes_risk_element ?includes_risk_element. \n\
                 ?includes_risk_element risk:has_risk_element_name ?includes_risk_element_name. \n\
                } \n\
                */

        /*
                Another delete query


                PREFIX risk: <https://"+CONFIG.GRAPH_DOMAIN+"/ontology/risk.owl#>
PREFIX OB: <https://"+CONFIG.GRAPH_DOMAIN+"/observables/>
#select ?ob ?predicate FROM <https://"+CONFIG.GRAPH_DOMAIN+"/riskdata> WHERE { ?ob a risk:observable; risk:has_external_predicate ?predicate. FILTER (?ob=OB:OB_5 || ?ob=OB:OB_6) }

WITH <https://"+CONFIG.GRAPH_DOMAIN+"/public> DELETE { OB:OB_5 risk:has_external_predicate ?p .  }  WHERE { OB:OB_5 risk:has_external_predicate ?p .}

                */
      }

      function searchInstances(type, term) {
        if (!type || !term) {
          throw "CARRE Error: Cannot search without type and term!";
        }
        var listQuery =
          "SELECT * FROM " +
          CONFIG.CARRE_DEFAULT_GRAPH +
          " WHERE { \n\
             ?subject a risk:" +
          type +
          "; ?predicate ?object. \n\
              OPTIONAL {    \n\
               ?object a risk:citation. \n\
               ?object risk:has_citation_pubmed_identifier ?has_citation_pubmed_identifier  \n\
              } \n\
              OPTIONAL {    \n\
               ?object a risk:observable. \n\
               ?object risk:has_observable_name ?has_observable_name  \n\
              } \n\
              OPTIONAL {    \n\
               ?object a risk:risk_element. \n\
               ?object risk:has_risk_element_name ?has_risk_element_name  \n\
              } \n\
              OPTIONAL {    \n\
               ?object a risk:measurement_type. \n\
               ?object risk:has_measurement_type_name ?has_measurement_type_name  \n\
              } \n\
              OPTIONAL {    \n\
               ?object a risk:risk_factor.  \n\
               ?object risk:has_risk_factor_association_type ?has_risk_factor_association_type. \n\
               ?object risk:has_risk_factor_source ?has_risk_factor_source. \n\
               ?object risk:has_risk_factor_target ?has_risk_factor_target. \n\
               ?has_risk_factor_source risk:has_risk_element_name ?has_source_risk_element_name.  \n\
               ?has_risk_factor_target risk:has_risk_element_name ?has_target_risk_element_name.  \n\
              } \n";

        //add filter to query if a single observable is requested
        listQuery += 'FILTER (lcase(str(?object)) = "' + term + '") }';

        return selectQuery(listQuery);
      }

      function langFilter(variable_predicate) {
        var lang = CONFIG.LANG;
        return "FILTER(lang(" + variable_predicate + ")='" + lang + "') ";
      }
      /*
      OPTIONAL {    \n\
    #Language filter \n\
     VALUES ?predicate {"+CONFIG.LANGPredicates.join(" ")+" }. \n\
     "+langFilter('?predicate')+" \
    } \n\
  */

      function queryInstances(type, ArrayOfIDs) {
        var listQuery =
          "SELECT * FROM " +
          CONFIG.CARRE_DEFAULT_GRAPH +
          " WHERE { \n\
             ?subject a risk:" +
          type +
          "; ?predicate ?object. \n\
              OPTIONAL {    \n\
               ?object a risk:citation. \n\
               ?object risk:has_citation_pubmed_identifier ?has_citation_pubmed_identifier  \n\
              } \n\
              OPTIONAL {    \n\
               ?object a risk:observable. \n\
               ?object risk:has_observable_name ?has_observable_name  \n\
              " +
          langFilter("?has_observable_name") +
          " \n\
              } \n\
              OPTIONAL {    \n\
               ?object a risk:risk_element. \n\
               ?object risk:has_risk_element_name ?has_risk_element_name  \n\
              " +
          langFilter("?has_risk_element_name") +
          " \n\
              } \n\
              OPTIONAL {    \n\
               ?object a risk:measurement_type. \n\
               ?object risk:has_measurement_type_name ?has_measurement_type_name  \n\
              " +
          langFilter("?has_measurement_type_name") +
          " \n\
              } \n\
              OPTIONAL {    \n\
               ?object a risk:risk_factor.  \n\
               ?object risk:has_risk_factor_association_type ?has_risk_factor_association_type. \n\
               ?object risk:has_risk_factor_source ?has_risk_factor_source. \n\
               ?object risk:has_risk_factor_target ?has_risk_factor_target. \n\
               ?has_risk_factor_source risk:has_risk_element_name ?has_source_risk_element_name.  \n\
               ?has_risk_factor_target risk:has_risk_element_name ?has_target_risk_element_name.  \n\
              " +
          langFilter("?has_source_risk_element_name") +
          " \n\
              " +
          langFilter("?has_target_risk_element_name") +
          " \n\
              } \n";

        //add filter to query if a single observable is requested
        if (ArrayOfIDs) {
          listQuery +=
            "FILTER ( " +
            ArrayOfIDs.map(function (id) {
              return "?subject=" + id.split("_")[0] + ":" + id;
            }).join("||") +
            "  )\n }";

          return selectQuery(listQuery);
        } else {
          listQuery += "}";

          return selectQuery(
            listQuery,
            null,
            CONFIG.USECACHE ? type + "_all" : null
          );
        }
      }

      /* Dashboard count instances methods */
      function countAllInstances() {
        var query =
          "SELECT \n\
    (COUNT(?rf) as ?risk_factors) \n\
    (COUNT(?rf_r) as ?risk_factors_unreviewed) \n\
    (COUNT(?rl) as ?risk_elements) \n\
    (COUNT(?rl_r) as ?risk_elements_unreviewed) \n\
    (COUNT(?ob) as ?observables) \n\
    (COUNT(?ob_r) as ?observables_unreviewed) \n\
    (COUNT(?rv) as ?risk_evidences) \n\
    (COUNT(?rv_r) as ?risk_evidences_unreviewed) \n\
    (COUNT(?ci) as ?citations) \n\
    (COUNT(?me) as ?measurement_types)  \n\
    FROM " +
          CONFIG.CARRE_DEFAULT_GRAPH +
          " WHERE { \n\
    {?rf a risk:risk_factor} \n\
    UNION { ?rf_r a risk:risk_factor FILTER NOT EXISTS {?rf_r risk:has_reviewer ?anything} } \n\
    UNION {?rl a risk:risk_element} \n\
    UNION { ?rl_r a risk:risk_element FILTER NOT EXISTS {?rl_r risk:has_reviewer ?anything} } \n\
    UNION {?ob a risk:observable} UNION { ?ob_r a risk:observable FILTER NOT EXISTS {?ob_r risk:has_reviewer ?anything} } \n\
    UNION {?rv a risk:risk_evidence} UNION { ?rv_r a risk:risk_evidence FILTER NOT EXISTS {?rv_r risk:has_reviewer ?anything} } \n\
    UNION {?ci a risk:citation} \n\
    UNION {?me a risk:measurement_type}  }";
        if (CONFIG.USECACHE) return cacheQuery(query, null, "count_all");
        else return apiQuery(query);
      }

      /* Easy select query to transform triples to javascript objects */
      function selectQuery(sparqlQuery, raw, cache_id) {
        var props = [
          "subject",
          "predicate",
          "object",
          "has_observable_name",
          "has_risk_element_name",
          "has_measurement_type_name",
          "has_risk_factor_association_type",
          "has_risk_factor_source",
          "has_risk_factor_target",
          "has_source_risk_element_name",
          "has_target_risk_element_name",
          "has_citation_pubmed_identifier",
        ];
        if (cache_id) {
          // USE CACHE
          return cacheQuery(sparqlQuery, null, cache_id).then(function (res) {
            if (raw) return res;
            // console.log(res.data);
            var results = RdfFormatter.groupByProp(
              res.data,
              props,
              null,
              "value"
            );
            if (results.data.length > 0) return RdfFormatter.mappings(results);
            else return [];
          });
        } else {
          return apiQuery(sparqlQuery).then(function (res) {
            console.log("=========NO CACHE===================");

            // console.log("Sparql Query: ",sparqlQuery);
            console.log("Raw: ", res.data);
            if (raw) return res;
            var results = RdfFormatter.groupByProp(
              res.data,
              props,
              null,
              "value"
            );
            console.log("groupByProp: ", results);
            if (results.data.length > 0) {
              var MappedResults = RdfFormatter.mappings(results);
              console.log("MappedResults: ", results);
              return MappedResults;
            } else return [];
          });
        }
      }

      /* CORE query method*/
      function apiQuery(sparqlQuery, noprefix, sparqlAuth) {
        if ($rootScope.isOffline) {
          $state.go("500_API_ERROR");
          return $q.reject({});
        }

        var params = {};
        //add prefixes
        params.query = (noprefix ? "" : PREFIXSTR) + sparqlQuery;
        params.format = "application/sparql-results+json";

        // console.info("API query: ", params.query);
        var request;
        if (sparqlAuth) {
          request = $http.post(
            CONFIG.CARRE_API_URL + "api/sparql-auth",
            params.query,
            {
              headers: {
                Authorization: Auth.getToken(),
              },
            }
          );
        } else {
          // request = $http.get("https://devices.duth.carre-project.eu/sparql", {
          request = $http.get(CONFIG.CARRE_API_URL + "api/sparql", {
            params: params,
          });
        }
        return request
          .then(function (res) {
            if (
              res.data === "No JSON object could be decoded" ||
              !res.data.results
            ) {
              throw new Error({ data: { error: "No results" } });
            } else return { status: res.status, data: res.data.results.bindings };
          })
          .catch(function (err) {
            toastr.error("<p>" + err.data.error + "</p>", "<h4>Error</h4>");
            $state.go("500_API_ERROR");
            return $q.reject(err);
          });
      }

      /* CACHE methods */
      function cacheQuery(sparqlQuery, noprefix, req_url_id) {
        console.info(
          "CACHE query: ",
          (noprefix ? "" : PREFIXSTR) + sparqlQuery
        );

        var graphName = CONFIG.CARRE_DEFAULT_GRAPH.substring(
          CONFIG.CARRE_DEFAULT_GRAPH.lastIndexOf("/") + 1,
          CONFIG.CARRE_DEFAULT_GRAPH.lastIndexOf(">")
        );
        var token = Auth.getToken();
        var url =
          CONFIG.CARRE_CACHE_URL +
          "carreapi/" +
          graphName +
          "_" +
          CONFIG.LANG +
          "_" +
          req_url_id +
          "/" +
          encodeURIComponent(CONFIG.CARRE_API_URL + "query") +
          "/" +
          encodeURIComponent((noprefix ? "" : PREFIXSTR) + sparqlQuery) +
          (token ? "/" + token : "");

        return $http
          .get(url, { cache: false })
          .then(function (res) {
            if (res.data === "No JSON object could be decoded") {
              console.error(res);
              toastr.error("<p>" + res.data + "</p>", "<h4>Oh Error</h4>");
              return $q.reject(res);
            } else {
              //setup client caching
              // CONFIG.CACHED_QUERIES[graphName+'_'+req_url_id]=url;

              return res;
            }
          })
          .catch(function (err) {
            console.log(err);
            $state.go("500_API_ERROR");
          });
      }

      function invalidateCache(req_url_id) {
        if (!CONFIG.USECACHE) return;
        var graphName = CONFIG.CARRE_DEFAULT_GRAPH.substring(
          CONFIG.CARRE_DEFAULT_GRAPH.lastIndexOf("/") + 1,
          CONFIG.CARRE_DEFAULT_GRAPH.lastIndexOf(">")
        );
        var url =
          CONFIG.CARRE_CACHE_URL +
          "refresh_cache/" +
          graphName +
          "_" +
          CONFIG.LANG +
          "_" +
          req_url_id;

        // remove cached url
        // var cached_url=CONFIG.CACHED_QUERIES[graphName+'_'+req_url_id];
        // $cacheFactory.get('$http').remove(cached_url);

        return $http
          .get(url)
          .then(function (res) {
            console.log(res);
          })
          .catch(function (err) {
            console.log(err);
            $state.go("500_API_ERROR");
          });
      }

      return this.exports;
    }
  );

angular.module('CarreEntrySystem').service('Bioportal', function($http, CONFIG) {

  var apikey = CONFIG.BIOPORTAL_API_KEY;
  var apiurl = CONFIG.BIOPORTAL_API_URL;

  //pass the Bioportal supported options to override the default 
  var fetch = function(term, options,nocui) {
    return search(term, options).then(function(res) {
      var cuis = [];
      var results = [];
      res.data.collection.forEach(function(obj) {
        if (nocui||((obj.cui?obj.cui.length>0:false) && cuis.indexOf(obj.cui[0]) === -1)) {
          if(!nocui) cuis.push(obj.cui[0]);
          results.push({
            label: obj.prefLabel,
            value: nocui?obj['@id']:obj.cui[0],
            link:obj.links.ui
          });
        }
        
      });
      console.info(results);
      return results;

    });

  };


  /*Implement basic methods*/
  var cachesearch = function(input, options) {
    var params = options || {};
    params.q = input;
    params.apikey = apikey;
    return $http.get('http://beta.carre-project.eu:3002/bioportal/'+encodeURIComponent(apiurl + 'search/'+$.param( params )), {
      ignoreLoadingBar: true,
      cache: true
    });
  };
  
  /*Implement basic methods*/
  var search = function(input, options) {
    options = options || {};
    var params = {
      display_context: options.display_context||'false',
      require_exact_match: options.require_exact_match||'false',
      include: options.include||'prefLabel,definition,cui',
      display_links: options.display_links||'true',
      ontologies: options.ontologies||CONFIG.BIOPORTAL_ONTOLOGIES,
      require_definitions: options.require_definitions||'false'
    };
    params.q = input;
    params.apikey = apikey;
    return $http.get(apiurl + 'search', {
      params: params,
      ignoreLoadingBar: true,
      cache: true
    });
  };
  var annotator = function(input, options) {
    var params = options || {};
    params.text = input;
    params.apikey = apikey;
    return $http.get(apiurl + 'annotator', {
      params: params,
      ignoreLoadingBar: true,
      cache: true
    });
  };
  var recommender = function(input, options) {
    var params = options || {};
    params.input = input;
    params.apikey = apikey;
    return $http.get(apiurl + 'recommender', {
      params: params,
      ignoreLoadingBar: true,
      cache: true
    });
  };

  return {
    'fetch': fetch,
    'search': search,
    'annotator': annotator,
    'recommender': recommender
  }
  
  /* Unimplemented */

// var CUI_DETAILS = {};

// var BIOPORTAL_ONTOLOGIES="ICD10,ICD10CM";//",ICD10CM,ICD10PCS,ICD9CM";


// var BioPortalsearch = function(input, cuis) {
//     cuis = (cuis instanceof Array)?cuis:(cuis?cuis.split(','):'');
//     input=input||"";
//     request({
//         url: "https://data.bioontology.org/search?token=a15281a9-d87d-4c0f-b7aa-31debe0f6449&cui="+cuis.join(',')+"&q="+input+"&include=prefLabel,definition,cui&display_context=false&display_links=true&ontologies="+BIOPORTAL_ONTOLOGIES,
//         method: 'GET'
        
//     }, function(error, response, body){
//         if(error) { console.log(error); } else saveCuis(cuis,body.collection); });
     
// };
// /*Implement BioPortalsearch methods*/
// var saveCuis = (cuis,data)=>{
//     var arr=[];
//     arr.concat(data);
    
//     cuis.forEach((cui)=>{
//         for (var i=0,len=arr.length;i<len;i++){
//             if(arr[i].cui.indexOf(arr[i])>=0) {
//                 mcache.put(cui,arr[i]);
//                 getAncestors(cui,arr[i].links.ancestors);
//                 arr.splice(i,1);
//                 break;
//             }   
//         }        
//     })
// }

// var getAncestors = (cui,ancestorUrl) => {
//     var cachedAncestors = mcache.get(cui+'_ancestors');
//     if(cachedAncestors) return cachedAncestors; 
//     else return request(ancestorUrl,function(err,res,body){
//         if(err) console.log(err); else {
//             mcache.put(cui+'_ancestors',body);
//             return body;
//         }
//     });
// }

});
/* global angular */
(function() {
    'use strict';

    angular
        .module('CarreEntrySystem')
        .filter('trustAsResourceUrl', trustResourceFilter)
        .filter('hideSelected', hideSelected)
        .filter('sliceLast', sliceLast)
        .filter('prettySigns', prettySigns)
        .filter('propsFilter', propsFilter)
        .filter('exclude', excludeItems);


    /** @ngInject */
    function trustResourceFilter($sce) {
        return function(val) {
            return $sce.trustAsResourceUrl(val);
        };
    }

    /** @ngInject */
    function hideSelected() {
        return function(item, selectedItems) {
            if(selectedItems.length===0) return false; 
            selectedItems.forEach(function(obj){
                if(item.value===obj) return true;
            });
            return false;
        };
    }
    
    /** @ngInject */
    function sliceLast() {
        return function(item, char) {
            if(!item||item.length<=0||!char||char.length<=0) return ''; 
            return item.substring(item.lastIndexOf(char)+1);
        };
    }
    /** @ngInject */
    function prettySigns() {
        return function(val) {
            if(!val||val.length<=0) return ''; 
            else return val.replace(new RegExp(">=", 'g'), '≥').replace(new RegExp("<=", 'g'), '≤')
        };
    }

    /** @ngInject */
    function excludeItems() {
        return function(items, selectedItems) {
            var out=[];
            if(selectedItems.length===0) return items; 
            //you want to remove the selected items from items
            items.forEach(function(item){
                if(selectedItems.indexOf(item.value)===-1) out.push(item);
            });
            return out;
        };
    }


    /** @ngInject */
    function propsFilter() {
        return function(items, props) {
            var out = [];

            if (angular.isArray(items)) {
                items.forEach(function(item) {
                    var itemMatches = false;

                    var keys = Object.keys(props);
                    for (var i = 0; i < keys.length; i++) {
                        var prop = keys[i];
                        var text = props[prop].toLowerCase();
                        try {
                            if (item[prop].toString().toLowerCase().indexOf(text) !== -1) {
                                itemMatches = true;
                                break;
                            }
                        } catch(err) {
                            console.info(item,prop,item[prop]);
                            console.error('Error',err)
                        }
                    }

                    if (itemMatches) {
                        out.push(item);
                    }
                });
            }
            else {
                // Let the output be the input untouched
                out = items;
            }

            return out;
        };
    }

})();
/* global angular */
(function() {
    'use strict';

    angular
        .module('CarreEntrySystem')
        .directive('uiSrefActiveIf', uiSrefActiveIfDirective)
        .directive('countTo', countToDirective);

    /** @ngInject */
    function uiSrefActiveIfDirective($state) {
        return {
            restrict: "A",
            controller: ['$scope', '$element', '$attrs', 'CONFIG', function($scope, $element, $attrs, CONFIG) {
                
                var menuColor=function(state){
                    var elem=state.substr(state.lastIndexOf('.')+1);
                    console.log(elem);
                    var color="";
                    switch (elem) {
                        case 'risk_factors':
                            color=CONFIG.COLORS[0];
                            break;
                        case 'risk_evidences':
                            color=CONFIG.COLORS[1];
                            break;
                        case 'risk_elements':
                            color=CONFIG.COLORS[2];
                            break;
                        case 'observables':
                            color=CONFIG.COLORS[3];
                            break;
                        case 'citations':
                            color=CONFIG.COLORS[4];
                            break;
                        
                        default:
                            color="#EEEEEE";
                    }
                    return color;
                }
                function update() {
                    var state = $attrs.uiSrefActiveIf;
                    if ($state.includes(state) || $state.is(state)) {
                            // console.log(state,$state.includes(state),$state.is(state))
                            $element.css("border-right","5px solid "+menuColor(state))
                            $element.addClass("active");
                    }
                    else {
                        // angular.element("#side-menu li").each(function() {
                        //   $( this ).removeClass("active");
                        // });
                        $element.css("border-right","none");
                        $element.removeClass("active");
                    }
                }

                $scope.$on('$stateChangeSuccess', update);
                update();
            }]
        };
    }
    
    /** @ngInject */
    function countToDirective($timeout) {
        return {
            replace: false,
            scope: true,
            link: function (scope, element, attrs) {

                var e = element[0];
                var num, refreshInterval, duration, steps, step, countTo, value, increment;

                var calculate = function () {
                    refreshInterval = 30;
                    step = 0;
                    scope.timoutId = null;
                    countTo = parseInt(attrs.countTo) || 0;
                    scope.value = parseInt(attrs.value, 10) || 0;
                    duration = (parseFloat(attrs.duration) * 1000) || 0;

                    steps = Math.ceil(duration / refreshInterval);
                    increment = ((countTo - scope.value) / steps);
                    num = scope.value;
                };

                var tick = function () {
                    scope.timoutId = $timeout(function () {
                        num += increment;
                        step++;
                        if (step >= steps) {
                            $timeout.cancel(scope.timoutId);
                            num = countTo;
                            e.textContent = countTo;
                        } else {
                            e.textContent = Math.round(num);
                            tick();
                        }
                    }, refreshInterval);

                };

                var start = function () {
                    if (scope.timoutId) {
                        $timeout.cancel(scope.timoutId);
                    }
                    calculate();
                    tick();
                };

                attrs.$observe('countTo', function (val) {
                    if (val) {
                        start();
                    }
                });

                attrs.$observe('value', function (val) {
                    start();
                });

                return true;
            }
        };
    }
        
})();

(function () {
  "use strict";

  angular
    .module("CarreEntrySystem")
    .controller("MainController", MainController);

  /** @ngInject */
  function MainController(
    $timeout,
    toastr,
    $location,
    CONFIG,
    CARRE,
    $state,
    SweetAlert,
    Tutorial,
    $scope,
    $rootScope,
    $http,
    Auth
  ) {
    var vm = this;

    CONFIG.ROOT_URL = rootUrl();
    vm.config = CONFIG;
    vm.user = vm.config.currentUser || {};
    vm.loginForm = {};

    //show message for the user
    if (!$rootScope.isEmbedded) {
      if (vm.user.username) {
        toastr.success(
          "Welcome to the Risk Factor entry system!",
          "<h4>Hi " + vm.user.name + "!</h4>"
        );
      } else {
        toastr.info(
          "Please login if you want to add/edit data.",
          "<h4>Hello Guest!</h4>"
        );
      }
    }

    function rootUrl() {
      if (CONFIG.ENV === "DEV") {
        return window.location.host + "/#/";
      } else if (CONFIG.ENV === "PROD") {
        return window.location.host + "/";
      }
    }
    vm.logout = function () {
      Auth.logout()
        .then(function () {
          vm.user = {};
          $state.reload();
        })
        .catch(function (err) {
          console.log(err);
          toastr.error("Something went wrong!", "Logout Error");
        });
    };
    vm.login = function () {
      // capture the input fields from the loginForm
      var username = vm.loginForm.username;
      var password = vm.loginForm.password;
      vm.loginForm.loading = true;
      Auth.login(username, password)
        .then(function (user) {
          vm.user = user;
          vm.loginForm.isopen = false;
        })
        .catch(function (err) {
          var msg =
            (err.data && (err.data.error || err.data.message)) ||
            "Something went wrong!";
          toastr.error(msg, "Login Error");
        })
        .finally(function () {
          vm.loginForm.loading = false;
        });
    };
    vm.deleteCurrent = function (id) {
      if (!id) return;
      SweetAlert.swal(
        {
          title: "Are you sure?",
          text: "Your will not be able to recover this element!",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Yes, delete it!",
          closeOnConfirm: true,
          closeOnCancel: true,
        },
        function (isConfirm) {
          if (isConfirm) {
            if (CONFIG.AllowDelete) {
              CARRE.delete(id).then(function () {
                $state.go("^.list");
              });
            } else {
              toastr.info(id + " deleted!", "DEBUG");
              $timeout(function () {
                $state.go("^.list");
              }, 500);
            }
          }
        }
      );
    };

    // $scope.IntroOptions = Tutorial.options();

    // $timeout(function () {
    //   if (
    //     !CONFIG.currentUser.username &&
    //     CONFIG.ENV === "DEV" &&
    //     $state.includes("main.dashboard")
    //   )
    //     Tutorial.startGuest($scope.startIntro);
    // }, 1000);
  }
})();

(function () {
  "use strict";

  angular.module("CarreEntrySystem").run(runBlock).run(setPermissionValidator);

  /** @ngInject */
  function setPermissionValidator(Permission, Auth, $q) {
    // Define anonymous role
    console.log("Role Definition called!");
    Permission.defineRole("authenticated_user", function (stateParams) {
      console.log("authenticated_user role called!", stateParams);
      return Auth.isLoggedIn();
    });
  }

  /** @ngInject */
  function runBlock($rootScope, $state, $location, CONFIG, $http, $cookies) {
    // check if it is embeded
    if ($location.search().embed) {
      $rootScope.isEmbedded = true;
      if ($location.search().hidemenu) $rootScope.hideMenu = true;
      if ($location.search().showonlygraph) $rootScope.showOnlyGraph = true;
    }

    // handle ui-router error redirect
    if (CONFIG.useOfflineMode) {
      $rootScope.$on(
        "$stateChangeStart",
        function (event, toState, toParams, fromState, fromParams, options) {
          if (toState.name === "500_API_ERROR") {
            event.preventDefault();
            $rootScope.isOffline = true;
          }
        }
      );
    }

    //handle ui-router errors
    $rootScope.$on(
      "$stateChangeError",
      function (event, toState, toParams, fromState, fromParams, error) {
        // this is required if you want to prevent the $UrlRouter reverting the URL to the previous valid location
        event.preventDefault();
        console.error(
          "Ui Router error:",
          event,
          toState,
          toParams,
          fromState,
          fromParams,
          error
        );
        console.log(error);
        // $state.go(toState.name,toParams.id);
      }
    );

    // window.hexToRgb = function(hex) {
    //     var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    //     hex = hex.replace(shorthandRegex, function(m, r, g, b) {
    //         return r + r + g + g + b + b;
    //     });

    //     var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    //     return result ? {
    //         r: parseInt(result[1], 16),
    //         g: parseInt(result[2], 16),
    //         b: parseInt(result[3], 16)
    //     } : null;
    // }

    // allow language change hack
    var lang_cookie = $cookies.get("CARRE_LANG");
    CONFIG.LANG = lang_cookie && lang_cookie.length === 2 ? lang_cookie : "en";
    if ($location.search().lang) {
      CONFIG.LANG = $location.search().lang;
    }

    // load language file
    window.CARRE_TRANSLATIONS = { el: {}, lt: {}, en: {} };
    $http
      .get("/translation." + CONFIG.LANG + ".json", { cache: true })
      .then(function (res) {
        console.debug(res);
        window.CARRE_TRANSLATIONS[CONFIG.LANG] = res.data;
      });
  }
})();

/*JQUERY MetisMenu - external library for sidebar rendering */

$(function () {
  $("#side-menu").metisMenu();
});

//Loads the correct sidebar on window load,
//collapses the sidebar on window resize.
// Sets the min-height of #page-wrapper to window size
$(function () {
  $(window).bind("load resize", function () {
    topOffset = 50;
    width =
      this.window.innerWidth > 0 ? this.window.innerWidth : this.screen.width;
    if (width < 768) {
      $("div.navbar-collapse").addClass("collapse");
      topOffset = 100; // 2-row-menu
    } else {
      $("div.navbar-collapse").removeClass("collapse");
    }

    height =
      (this.window.innerHeight > 0
        ? this.window.innerHeight
        : this.screen.height) - 1;
    height = height - topOffset;
    if (height < 1) height = 1;
    if (height > topOffset) {
      $("#page-wrapper").css("min-height", height + "px");
    }
  });

  var url = window.location;
  var element = $("ul.nav a")
    .filter(function () {
      return this.href == url || url.href.indexOf(this.href) == 0;
    })
    .addClass("active")
    .parent()
    .parent()
    .addClass("in")
    .parent();
  if (element.is("li")) {
    element.addClass("active");
  }
});

/*global angular*/
(function() {
  'use strict';

  angular
    .module('CarreEntrySystem')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider) {

    $stateProvider
      .state('main', {
        'abstract': true,
        controller: 'MainController',
        controllerAs: 'main',
        templateUrl: 'app/main.html',
        resolve:{
          'currentUser':function(Auth){
            return Auth.getUser();
          }
        }
      })
      
      /*Error routes*/
      .state('404_error', {
        templateUrl: '404.html',
        url: '/404_error'
      })
      .state('500_API_ERROR', {
        templateUrl: '500_API.html',
        url: '/500_api_error'
      });
  }

})();

(function() {
  'use strict';

  angular
    .module('CarreEntrySystem')
    .constant("CONFIG", {    
      "currentUser":{},
      "USECACHE":false,
      "ENV": "PROD",
      "useOfflineMode":true,
      "AllowDelete":true,
    }).config(function($locationProvider, $compileProvider, $urlRouterProvider) {
      
      //show error
      $urlRouterProvider.otherwise( function($injector) {
        var $state = $injector.get("$state");
        $state.go('404_error');
      });
      
      //Set url handler  
      $locationProvider.html5Mode(true);
      
      // Disable log
      $compileProvider.debugInfoEnabled(false);
      
      //load the google analytics only in production
      // (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
      // (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
      // m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
      // })(window,document,'script','//www.google-analytics.com/analytics.js','ga');
      // ga('create', 'UA-60507179-2', 'auto');
      // ga('send', 'pageview');
  
    });

})();


(function () {
  "use strict";

  angular.module("CarreEntrySystem").config(config);

  const d = new URLSearchParams(document.location.search)
  var defaultGraph = d.get('graph') || "riskdata"

  /** @ngInject */
  function config(toastrConfig, $httpProvider, cfpLoadingBarProvider, CONFIG, $locationProvider) {
    // SYSTEM_CONFIGURATION
    var defaults = {
      language: "en",
      api_url: "https://app.thrombus.eu/",
      cache_url: "NO_CACHE",
      graph_url: "risk.thrombus.eu",
    };
    window.CARRE_ENTRY_SYSTEM_CONFIGURATION = angular.isObject(
      window.CARRE_ENTRY_SYSTEM_CONFIGURATION
    )
      ? angular.extend(defaults, window.CARRE_ENTRY_SYSTEM_CONFIGURATION)
      : defaults;
    CONFIG.GRAPH_DOMAIN = window.CARRE_ENTRY_SYSTEM_CONFIGURATION.graph_url;
    CONFIG.CARRE_DEFAULT_GRAPH =
      "<https://" +
      window.CARRE_ENTRY_SYSTEM_CONFIGURATION.graph_url +
      "/"+defaultGraph+">";
    CONFIG.CARRE_ARCHIVE_GRAPH =
      "<https://" +
      window.CARRE_ENTRY_SYSTEM_CONFIGURATION.graph_url +
      "/"+defaultGraph+">";
    CONFIG.CARRE_API_URL = window.CARRE_ENTRY_SYSTEM_CONFIGURATION.api_url;
    CONFIG.CARRE_CACHE_URL = window.CARRE_ENTRY_SYSTEM_CONFIGURATION.cache_url;

    // if(CONFIG.CARRE_CACHE_URL==='NO_CACHE') CONFIG.USECACHE=false;
    CONFIG.USECACHE = false;
    CONFIG.AllowDelete = true;

    //EXTERNAL API'S
    CONFIG.BIOPORTAL_API_URL = "https://data.bioontology.org/";
    CONFIG.BIOPORTAL_API_KEY = "a15281a9-d87d-4c0f-b7aa-31debe0f6449";
    CONFIG.BIOPORTAL_ONTOLOGIES = "ICD10,ICD10CM"; //",ICD10CM,ICD10PCS,ICD9CM";
    CONFIG.PUBMED_API_URL = "https://eutils.ncbi.nlm.nih.gov/entrez/eutils/";
    CONFIG.EUROPEPMC_API_URL =
      "https://www.ebi.ac.uk/europepmc/webservices/rest/";

    //Client caching
    CONFIG.CACHED_QUERIES = {};

    // Set options third-party lib
    CONFIG.OPTIONS = {
      usePrefix: true,
    };

    // Language
    CONFIG.LANG = window.CARRE_ENTRY_SYSTEM_CONFIGURATION.language || "en"; //el,lt
    CONFIG.LANGPredicates = [
      "risk:has_risk_element_name",
      "risk:has_observable_name",
      "risk:has_measurement_type_name",
      "risk:has_enumeration_values",
      "risk:has_label",
    ];

    // Sensor predicates
    //
    CONFIG.SENSOR_PREDICATES = [
      "bmi",
      "height",
      "provenance",
      "calories_metabolised",
      "steps",
      "o2saturation",
      "light_activity_duration",
      "sodium",
      "sleep_time",
      "sleep_efficiency",
      "asleep_duration",
      "deep_sleep_duration",
      "weight",
      "protein",
      "calories_b_m_r",
      "sedentary_activity_duration",
      "date",
      "body_fat",
      "muscle_mass",
      "water_mass",
      "bone_mass",
      "body_d_c_i",
      "intense_activity_duration",
      "intense_activity_distance",
      "logged_activity_distance",
      "sedentary_activity_distance",
      "actuality",
      "minutes_after_wakeup",
      "fat",
      "fibre",
      "blood_pressure_systolic",
      "blood_pressure_diastolic",
      "who_b_p_level",
      "pulse",
      "elevation",
      "floors",
      "moderate_activity_duration",
      "light_activity_distance",
      "moderate_activity_distance",
      "tracked_activity_distance",
      "distance",
      "times_restless",
      "time_to_fall_asleep",
      "awake_duration",
      "restless_duration",
      "calories",
      "activity_calories",
      "marginal_calories",
      "times_awake",
      "carbs",
      "glucose",
      "dinner_situation",
      "drug_situation",
      "start_date",
      "sleep_status",
      "note",
      "latitude",
      "longitude",
      "end_date",
      "light_sleep_duration",
      "water",
      "lean_mass",
      "location",
      "arrhythmia_type",
      "activity_points",
      "fat_mass",
      "timezone",
      "logged_activity_duration",
      "logged_activity_name",
      "https://risk.thrombus.eu/ontology/sensors.owl#date",
      "diagnosis",
      "left_ventricular_hypertrophy_diagnosis",
      "acute_kidney_injury_diagnosis",
      "egfr",
      "blood_pressure",
      "uric_acid_serum_concentration",
      "smoking_status",
      "blood_glucose_fasting",
      "blood_glucose_2h_glucose_after_oral_glucose_tolerance_test",
      "duration",
      "heartrate",
      "haemoglobin_hb",
      "high-density_lipoprotein_cholesterol_hdl-c",
      "ldl-c_low-density_lipoprotein_cholesterol",
      "total_cholesterol_tc",
      "triglycerides_serum_concentration_tg",
      "hemoglobin_hb_level",
      "diabetes_diagnosis",
      "hypertension_diagnosis",
    ];

    //chart colors
    var jnnnColors = [
      "#e08526",
      "#a118fb",
      "#2f739c",
      "#2db315",
      "#fb64b0",
      "#27af8d",
      "#4663db",
      "#706f42",
      "#ba4645",
      "#b68bce",
      "#ad36bc",
      "#ac9c1f",
      "#b3948f",
      "#2b7d1a",
      "#d32528",
      "#ad4a80",
      "#8f6521",
      "#4ea8ad",
      "#87a64a",
      "#3d7860",
      "#77687f",
      "#ea7790",
      "#fe4df0",
      "#cb2964",
      "#9d5962",
      "#f57550",
      "#d78670",
      "#4858fb",
      "#7499ee",
      "#c37eef",
      "#6f60bc",
      "#9a3cdb",
      "#7ca66d",
      "#107d40",
      "#3e6cbb",
      "#6ba78d",
      "#f067d0",
      "#939f8e",
      "#4f7741",
      "#bd4525",
      "#c52d81",
      "#c3924d",
      "#22a3ee",
      "#54717e",
      "#657061",
      "#58771c",
      "#d02747",
      "#766f1e",
      "#c589af",
      "#7d43fb",
      "#a696ae",
      "#81a0ae",
      "#8b6543",
      "#0d797e",
      "#69ad18",
      "#4dae6c",
      "#5fad49",
      "#a14c9e",
      "#8ea51c",
      "#c79223",
      "#a79d4b",
      "#bd936f",
      "#836661",
      "#9f9e6e",
      "#e26af0",
      "#65a1ce",
      "#63699d",
      "#a75823",
      "#935b7f",
      "#dd854e",
      "#9297ce",
      "#914fbc",
      "#d47bcf",
      "#b54863",
      "#d0878f",
      "#f17671",
      "#a08def",
      "#7753db",
      "#bb319e",
      "#e179af",
      "#f9742a",
      "#a35844",
      "#855d9d",
    ];
    //var myColors = ["#a6cee3","#1f78b4","#b2df8a","#33a02c","#fb9a99","#e31a1c","#fdbf6f","#ff7f00","#cab2d6","#6a3d9a","#ffff99","#b15928","#46BFBD", "#F7464A","#2E8B57", "#DB7093", "#FDB45C", "#949FB1", "#4D5360",'#a6cee3','#1f78b4','#b2df8a','#33a02c','#fb9a99','#e31a1c','#fdbf6f','#ff7f00','#cab2d6','#6a3d9a','#ffff99','#b15928'];
    // ["#46BFBD", "#F7464A","#2E8B57", "#DB7093", "#FDB45C", "#949FB1", "#4D5360"]
    var myColors = [
      "#377eb8",
      "#e41a1c",
      "#4daf4a",
      "#984ea3",
      "#ff7f00",
      "#ffff33",
      "#a65628",
      "#f781bf",
      "#999999",
    ].concat(jnnnColors);
    CONFIG.COLORS = myColors.concat(d3.scale.category20().range()); //mix the 20 default d3 color palette so you have almost 40
    Chart.defaults.global.colours = CONFIG.COLORS.map(function (color) {
      return { fillColor: color };
    });

    //toaster notification
    angular.extend(toastrConfig, {
      allowHtml: true,
      closeButton: false,
      closeHtml: "<button>&times;</button>",
      extendedTimeOut: 1000,
      iconClasses: {
        error: "toast-error",
        info: "toast-info",
        success: "toast-success",
        warning: "toast-warning",
      },
      positionClass: "toast-top-right",
      messageClass: "toast-message",
      onHidden: null,
      onShown: null,
      onTap: null,
      preventDuplicates: false,
      progressBar: false,
      tapToDismiss: true,
      // templates: {
      //   toast: 'directives/toast/toast.html',
      //   progressbar: 'directives/progressbar/progressbar.html'
      // },
      timeOut: 4000,
      titleClass: "toast-title",
      toastClass: "toast",
    });

    cfpLoadingBarProvider.spinnerTemplate =
      '<div style="position:absolute; top:-80px; z-index:99999; left:49%"><div class="loader">Loading...</div></div>';
    cfpLoadingBarProvider.latencyThreshold = 600;
    // cfpLoadingBarProvider.includeBar = false;

    //fix 500 and -1 errors
    $httpProvider.interceptors.push(function ($q, $injector) {
      var incrementalTimeout = 1000;

      function retryRequest(httpConfig) {
        var $timeout = $injector.get("$timeout");
        incrementalTimeout *= 2;
        return $timeout(function () {
          var $http = $injector.get("$http");
          return $http(httpConfig);
        }, incrementalTimeout);
      }

      return {
        request: function (config) {
          return config;
        },
        requestError: function (request) {
          console.warn("Error on request: ", request);
          return request;
        },
        responseError: function (response) {
          if (response.status === 500 || response.status === -1) {
            console.warn("Weird API 500 error intercepted! : ", response);
            if (incrementalTimeout < 4000) {
              return retryRequest(response.config);
            } else {
              // document.location.href = '/500_API_ERROR';
              console.log(
                "The remote server seems to be busy at the moment. Please try again in 5 minutes"
              );

              return $q.reject(response);
            }
          } else {
            incrementalTimeout = 1000;
          }
          return $q.reject(response);
        },
      };
    });
  }
})();

angular.module("CarreEntrySystem").run(["$templateCache", function($templateCache) {$templateCache.put("app/main.html","<div id=\"wrapper\" ng-intro-options=\"IntroOptions\" ng-intro-method=\"startIntro\" ng-intro-oncomplete=\"CompletedEvent\" ng-intro-onexit=\"ExitEvent\" ng-intro-onchange=\"ChangeEvent\" ng-intro-onbeforechange=\"BeforeChangeEvent\" ng-intro-autostart=\"false\"><div style=\"width:100%; height:19px; background-color:#E41A1C; color:white\" class=\"text-center\" ng-if=\"isOffline\">OFFLINE MODE</div><carre-header ng-hide=\"isEmbedded\"></carre-header><sidebar ng-if=\"!hideMenu\"></sidebar><div id=\"page-wrapper\" style=\"min-height: 561px;\" ng-style=\"hideMenu?{\'margin\':\'0 0 0 0\'}:{}\"><div uib-collapse=\"!main.DEBUG\" class=\"row\"><div class=\"col-xs-6\"><labe>Configuration<pre>{{main.config | json}}</pre></labe></div><div class=\"col-xs-6\"><labe>User<pre>{{main.user | json}}</pre></labe></div></div><div ui-view=\"\"></div></div><carre-footer ng-hide=\"isEmbedded\"></carre-footer></div>");
$templateCache.put("app/about/about.html","<h2 class=\"header\">More Information</h2><div><iframe src=\"//www.slideshare.net/slideshow/embed_code/key/rL6KQLdZuhK9Xu?startSlide=2\" width=\"595\" height=\"485\" frameborder=\"0\" marginwidth=\"0\" marginheight=\"0\" scrolling=\"no\" style=\"border:1px solid #CCC; border-width:1px; margin-bottom:5px; max-width: 100%;\" allowfullscreen=\"\"></iframe><p>The CARRE risk entry system enables the <a href=\"http://entry.carre-project.eu/medical_experts\">medical experts</a> in the <a href=\"http://www.carre-project.eu/\">CARRE project</a> to encode the risk factors between biological, demographic, lifestyle and environmental elements and clinical outcomes in accordance with evidence from the clinical literature. The presented system is based fundamentally on <a href=\"http://www.w3.org/DesignIssues/LinkedData.html\"></a>Linked Data principles, and so in order to make the best use of these encoded factors, they are available as Linked Data through the <a href=\"https://risk.thrombus.eu:8890/sparql\">CARRE SPARQL Endpoint</a>, making use of control vocabularies (<a href=\"https://www.nlm.nih.gov/research/umls/\">UMLS</a> , <a href=\"https://www.nlm.nih.gov/snomed/\"></a>SNOMED, etc.) and the <a href=\"http://bioportal.bioontology.org/ontologies/CARRE\">CARRE risk factor ontology</a>; specifically, they are encoded in the (standard) Resource Description Framework (<a href=\"http://www.w3.org/RDF/\">RDF</a>) format.</p><p>The system has been developed as a client side web application that follows the <a href=\"http://microservices.io/\">Microservices</a> architectural style and provides native RDF support via the <a href=\"https://risk.thrombus.eu/ws/\">CARRE API</a> and the <a href=\"https://risk.thrombus.eu:8890/sparql\">CARRE SPARQL Endpoint</a>. Moreover custom form components have been developed to reflect the structure of the <a href=\"http://bioportal.bioontology.org/ontologies/CARRE\">CARRE risk factor ontology</a>, so that citations, observables, risk elements, risk evidences and risk factors are automatically stored into the CARRE RDF triple store. The CARRE risk entry system is implemented in <a href=\"http://www.w3.org/TR/html5/\">HTML5</a>, <a href=\"http://www.w3.org/Style/CSS/\"></a>CSS and <a href=\"https://www.javascript.com/\">JavaScript</a> using the <a href=\"https://angularjs.org/\">AngularJS</a> framework. The system is open source and the source code is available at <a href=\"https://github.com/carre-project/carre-entry-system\">GitHub</a>. The system maintains referential integrity, so that if “diabetes” is entered as a risk element entity, then a risk factor representing an observed link between diabetes and hypertension will refer to the existing diabetes risk element entity. Medical experts are supported in the reuse of data already entered into the system by the user interface, which allows existing relevant entities to be selected via appropriate searchable lists wherever possible.</p><p>Web development: <a href=\"http://nporto.com/\">Nick Portokallidis</a></p><p>Data cleansing: <a href=\"http://drosatos.info/\">George Drosatos</a></p><p>Scientific supervision: <a href=\"http://iris.med.duth.gr/kaldoudi/en/\">Eleni Kaldoudi</a></p></div><br><br><footer class=\"footer\" style=\"height:60px;\"><div class=\"row\"><div class=\"col-xs-6\"><span><a href=\"//www.carre-project.eu\" target=\"_blank\"><img src=\"assets/images/CARRE-FooterLogo.png\" width=\"36\" height=\"40\" alt=\"CARRE\">&nbsp;CARRE Project © 2015</a></span></div><div class=\"col-xs-6\"><span class=\"pull-right\" style=\"\">FP7-ICT-611140.&nbsp; <a href=\"//cordis.europa.eu/\" target=\"_blank\"><img src=\"assets/images/Picture1-150x150.png\" width=\"40\" height=\"40\" alt=\"EU\"></a></span></div></div></footer>");
$templateCache.put("app/components/carre-element/template.html","<div class=\"carre-element\"><div cg-busy=\"loading\" style=\"position:relative;top:-15px;z-index:1\"></div><div ng-if=\"mode===\'view\'\" class=\"carre-element-view\"><div ng-class=\"{\'col-sm-6\':current.pubmedId,\'col-sm-12\':!current.pubmedId }\"><ul class=\"list-group\"><li ng-repeat=\"field in fields\" ng-if=\"current[field.value]\" class=\"list-group-item\">{{field.label}}:<carre-linker model=\"current\" property=\"{{field.value}}\"></carre-linker></li></ul><a ng-href=\"{{rdf_source | trustAsResourceUrl}}\" target=\"_blank\" class=\"btn btn-default btn-xs pull-right\">View RDF source</a></div><div ng-if=\"current.pubmedId\" class=\"col-sm-6\"><carre-view-pubmed id=\"{{current.pubmedId}}\"></carre-view-pubmed></div></div><div ng-if=\"mode!==\'view\'\" class=\"carre-element-form\"><risk-element-form ng-if=\"type===\'risk_element\'&&(current.id||mode===\'create\')\" model=\"current\"></risk-element-form><risk-factor-form ng-if=\"type===\'risk_factor\'&&(current.id||mode===\'create\')\" model=\"current\"></risk-factor-form><risk-evidence-form ng-if=\"type===\'risk_evidence\'&&(current.id||mode===\'create\')\" model=\"current\"></risk-evidence-form><citation-form ng-if=\"type===\'citation\'&&(current.id||mode===\'create\')\" model=\"current\"></citation-form><measurement-type-form ng-if=\"type===\'measurement_type\'&&(current.id||mode===\'create\')\" model=\"current\"></measurement-type-form><observable-form ng-if=\"type===\'observable\'&&(current.id||mode===\'create\')\" model=\"current\"></observable-form></div></div>");
$templateCache.put("app/components/carre-element-controls/template.html","<div class=\"well-sm\" ng-if=\"controls.user\"><a ng-show=\"\'**.view\'|includedByState\" class=\"btn btn-xs btn-primary\" ui-sref=\"^.edit({id:controls.carreId})\"><i class=\"fa fa-pencil\"></i> Edit</a> <a ng-show=\"\'**.edit\'|includedByState\" class=\"btn btn-xs btn-primary\" ui-sref=\"^.view({id:controls.carreId})\"><i class=\"fa fa-eye\"></i> View</a> <span ng-if=\"controls.dev&&controls.carreId\"><a class=\"btn btn-xs btn-danger\" href=\"\" ng-click=\"main.deleteCurrent(controls.carreId)\"><i class=\"fa fa-trash-o\"></i> Delete</a> <span class=\"badge\">{{controls.carreId}}</span></span></div>");
$templateCache.put("app/components/footer/footer.html","<footer class=\"footer\" style=\"height:60px;padding:10px\"><div class=\"col-xs-6\"></div><div class=\"col-xs-6\"></div></footer>");
$templateCache.put("app/components/graph-chord/template.html","<div cg-busy=\"loading\"><carre-graph-controls selected-id=\"selectedId\" disable-options=\"{showRiskEvidences:true,onlyPath:true}\" enable-rotation=\"true\" rotation=\"rotation\" refresh=\"init()\" add-size=\"addSize()\" remove-size=\"removeSize()\" navigate=\"goToSelected()\" expand=\"addNodeRelations()\" clear=\"deleteSelected()\"></carre-graph-controls><div id=\"chord\" class=\"carre-graph\"></div></div>");
$templateCache.put("app/components/graph-controls/template.html","<div class=\"carre-graph-controls\"><div class=\"col-xs-6 col-sm-7 col-md-5\"><div ng-show=\"selectedId\" class=\"panel panel-xs panel-default\" style=\"margin:0;position:absolute;z-index:4\"><div class=\"panel-heading\" style=\"padding-top:0;padding-bottom:0;padding-left:0;\"><button ng-show=\"!showDetails\" style=\"background:none\" ng-click=\"showDetails=!showDetails\" class=\"btn btn-sm\"><i class=\"fa fa-caret-square-o-down\"></i> Show details</button> <button ng-show=\"showDetails\" ng-click=\"showDetails=!showDetails\" class=\"btn btn-sm\"><i class=\"fa fa-caret-square-o-up\"></i> Hide details</button> <span class=\"hidden-xs\"><strong>{{controls.getType(controls.selectedId).label}}</strong></span> <button ng-click=\"controls.navigate({})\" class=\"btn btn-xs btn-primary\" title=\"Navigate\"><i class=\"fa fa-link\"></i></button> <button ng-show=\"controls.selectedId && controls.selectedId.indexOf(\'RL\')>=0\" title=\"Expand\" ng-click=\"controls.expand({id:controls.selectedId})\" class=\"btn btn-xs btn-info\"><i class=\"fa fa-share-alt\"></i></button> <button ng-show=\"controls.selectedId && controls.selectedId.indexOf(\'RL\')>=0\" title=\"Remove from graph\" ng-click=\"controls.clear({})\" class=\"btn btn-xs btn-danger\"><i class=\"fa fa-remove\"></i></button></div><div class=\"panel-body\" ng-if=\"showDetails&&controls.selectedId\"><carre-element elem-id=\"{{controls.selectedId}}\" mode=\"view\" not-fields=\"has_author,has_reviewer\" hide-pubmed=\"true\"></carre-element></div></div></div><div class=\"col-xs-6 col-sm-5 col-md-5 col-md-offset-2 text-right\"><div ng-if=\"controls.enableRotation\" class=\"btn-group\"><button ng-click=\"controls.rotation=controls.rotation-40\" class=\"btn btn-sm btn-default\"><i class=\"fa fa-chevron-left\"></i></button> <button class=\"btn btn-sm btn-default disabled\">ROTATE</button> <button ng-click=\"controls.rotation=controls.rotation+40\" class=\"btn btn-sm btn-default\"><i class=\"fa fa-chevron-right\"></i></button></div><div ng-hide=\"controls.disableOptions.showRiskEvidences&&controls.disableOptions.onlyPath\" class=\"btn-group\" uib-dropdown=\"\" is-open=\"status.isopen\"><button type=\"button\" class=\"btn btn-sm btn-default\" uib-dropdown-toggle=\"\">Options <span class=\"caret\"></span></button><ul uib-dropdown-menu=\"\" role=\"menu\"><li ng-hide=\"controls.disableOptions.showRiskEvidences\" role=\"menuitem\" style=\"width:180px\"><label class=\"carre-dropdown-checkbox\">Show Risk evidences <input type=\"checkbox\" ng-change=\"applyRefresh()\" ng-model=\"controls.showRiskEvidences\"></label></li><li ng-show=\"controls.showSlider\" role=\"menuitem\" style=\"width:180px\"><label style=\"width: 100%;\" class=\"carre-dropdown-checkbox\">Ratio filter<rzslider rz-slider-model=\"controls.ratioFilter.min\" rz-slider-high=\"controls.ratioFilter.max\" rz-slider-options=\"controls.slider_toggle.options\"></rzslider></label></li><li ng-hide=\"controls.disableOptions.onlyPath\" role=\"menuitem\" style=\"width:180px\"><label class=\"carre-dropdown-checkbox\">Show only path <input type=\"checkbox\" ng-change=\"applyRefresh()\" ng-model=\"controls.onlyPath\"></label></li></ul></div><button ng-click=\"controls.removeSize({})\" class=\"btn btn-sm btn-default\"><i class=\"fa fa-minus\"></i></button> <button ng-click=\"controls.addSize({})\" class=\"btn btn-sm btn-default\"><i class=\"fa fa-plus\"></i></button> <button ng-click=\"controls.refresh({})\" class=\"btn btn-sm btn-default\"><i class=\"fa fa-refresh\"></i></button></div></div>");
$templateCache.put("app/components/graph-network-d3/template.html","<div cg-busy=\"loading\"><carre-graph-controls selected-id=\"selectedId\" only-path=\"onlyCore\" show-risk-evidences=\"showRiskEvidences\" refresh=\"init()\" add-size=\"addSize()\" remove-size=\"removeSize()\" navigate=\"goToSelected()\" expand=\"addNodeRelations()\" clear=\"deleteSelected()\"></carre-graph-controls><div id=\"network\" class=\"carre-graph\"></div></div>");
$templateCache.put("app/components/graph-network-vis/template.html","<div cg-busy=\"loading\"><carre-graph-controls selected-id=\"selectedId\" only-path=\"onlyCore\" show-risk-evidences=\"showRiskEvidences\" refresh=\"init()\" add-size=\"addSize()\" remove-size=\"removeSize()\" navigate=\"goToSelected()\" expand=\"addNodeRelations()\" clear=\"deleteSelected()\"></carre-graph-controls><div id=\"network\" class=\"carre-graph\"></div></div>");
$templateCache.put("app/components/graph-sankey/template.html","<div cg-busy=\"loading\"><carre-graph-controls selected-id=\"selectedId\" only-path=\"onlyCore\" disable-options=\"{onlyPath:true}\" show-risk-evidences=\"showRiskEvidences\" ratio-filter=\"ratioFilter\" refresh=\"init()\" add-size=\"addSize()\" remove-size=\"removeSize()\" navigate=\"goToSelected()\" expand=\"addNodeRelations()\" clear=\"deleteSelected()\"></carre-graph-controls><div id=\"sankey\" class=\"carre-graph\"></div></div>");
$templateCache.put("app/components/header/header.html","<nav class=\"navbar navbar-default navbar-static-top\" role=\"navigation\" style=\"margin-bottom: 0\"><div class=\"navbar-header\"><button type=\"button\" class=\"navbar-toggle\" ng-click=\"toggleNavbar()\"><span class=\"sr-only\">Toggle navigation</span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span></button> <a class=\"navbar-brand\" href=\"/\"><img src=\"https://app.thrombus.eu/thrombus-short-logo.png\" class=\"logo\" alt=\"ThrombUS+\"> ThrombUS+ Risk entry system</a></div><header-notification></header-notification></nav>");
$templateCache.put("app/components/le_editor/le_editor.html","<div class=\"alert alert-default alert-group\"><div class=\"form-inline\"><select ng-options=\"o.name as o.name for o in operators\" ng-model=\"group.operator\" class=\"form-control input-sm\"></select><a style=\"margin-left: 5px\" ng-click=\"addCondition()\" class=\"btn btn-sm btn-default\"><span class=\"glyphicon glyphicon-plus-sign\"></span> Add Condition</a> <a style=\"margin-left: 5px\" ng-click=\"addGroup()\" class=\"btn btn-sm btn-default\"><span class=\"glyphicon glyphicon-plus-sign\"></span> Add Group</a> <a ng-show=\"$parent.group\" style=\"margin-left: 5px\" ng-click=\"removeGroup()\" class=\"btn btn-sm btn-danger\"><span class=\"glyphicon glyphicon-minus-sign\"></span> Remove Group</a></div><div class=\"group-conditions\"><div ng-repeat=\"rule in group.rules track by $index| orderBy:\'index\'\" class=\"condition\"><div ng-switch=\"rule.hasOwnProperty(\'group\')\"><div ng-switch-when=\"true\"><le-editor observables=\"observables\" metypes=\"metypes\" group=\"rule.group\"></le-editor></div><div ng-switch-default=\"ng-switch-default\"><div class=\"form-inline\"><div class=\"row\" uib-collapse=\"!rule.hiddenData\"><div class=\"text-center\">loading <img src=\"assets/images/ajax-loader.gif\"></div></div><div class=\"row\" uib-collapse=\"rule.hiddenData\"><ui-select class=\"le-editor observables input-sm\" ng-model=\"rule.field\" theme=\"bootstrap\" ng-init=\"getMeasurementType(null, rule.field, rule)\" on-select=\"getMeasurementType($item, $model, rule)\"><ui-select-match placeholder=\"Select observable\">{{$select.selected.label||\'Select Observable\'}}</ui-select-match><ui-select-choices repeat=\"ob.value as ob in observables | propsFilter: {label: $select.search}\"><div ng-bind-html=\"ob.label | highlight: $select.search\"></div></ui-select-choices></ui-select><select ng-options=\"c.value as c.name for c in conditions | filter: {types:rule.datatype}\" ng-model=\"rule.condition\" class=\"form-control\"></select><div class=\"input-group\"><input ng-if=\"rule.datatype===\'integer\'\" style=\"margin-left: 5px; width:100px\" min=\"0\" type=\"number\" ng-model=\"rule.data\" class=\"form-control\"> <input ng-if=\"rule.datatype===\'float\'\" style=\"margin-left: 5px; width:100px\" type=\"number\" step=\"0.01\" min=\"0\" ng-model=\"rule.data\" class=\"form-control\"><select ng-if=\"rule.datatype===\'enum\'||rule.datatype===\'boolean\'\" style=\"margin-left: 5px\" ng-options=\"c.value as c.name for c in rule.dataoptions\" ng-model=\"rule.data\" class=\"form-control\"><option value=\"\">Select</option></select><span popover-trigger=\"mouseenter\" uib-popover=\"{{rule.unit_label}}\" class=\"input-group-addon\" ng-show=\"rule.unit\">{{rule.unit}}</span></div><a style=\"margin-left: 10px\" ng-click=\"removeCondition($index)\" class=\"btn btn-xs btn-danger\"><span class=\"glyphicon glyphicon-minus-sign\"></span></a></div></div></div></div><span style=\"margin: 0 15%;\" class=\"text-center label label-default\">{{(($index+1)!==group.rules.length?group.operator:\"\")}}</span></div></div></div>");
$templateCache.put("app/components/linker/linker.html","<span><span ng-if=\"show===\'links\'\"><span ng-repeat=\"i in items\">&nbsp;<a href=\"/{{i.link | trustAsResourceUrl}}\">{{i.label}}</a><span ng-if=\"!$last\">,</span></span></span> <span ng-if=\"show===\'external_link\'\" ng-bind-html=\"external_link | trustAsResourceUrl\"></span> <span ng-if=\"show===\'condition\'\" ng-bind-html=\"label | trustAsResourceUrl\"></span> <span ng-if=\"show===\'label\'\">{{label}}</span></span>");
$templateCache.put("app/components/sidebar/sidebar.html","<div class=\"navbar-default sidebar\" role=\"navigation\"><div class=\"sidebar-nav navbar-collapse collapse\"><ul class=\"nav in\" id=\"side-menu\"><li><a ui-sref=\"main.dashboard\" ui-sref-active-if=\"main.dashboard\">Dashboard</a></li><li id=\"Explore\" ng-class=\"{active: Explore}\"><a href=\"\" ng-click=\"Explore=!Explore\">Explore<span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level\" uib-collapse=\"!Explore\"><li><a ui-sref=\"main.explore\" ui-sref-active-if=\"main.explore\">Explore risks</a></li><li><a target=\"_blank\" href=\"http://www.pubmed.gov\">Search PubMed</a></li></ul></li><li id=\"carreElements\" ng-class=\"{active: carreElements}\"><a href=\"\" ng-click=\"carreElements=!carreElements\">Data elements<span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level\" uib-collapse=\"!carreElements\"><li><a ui-sref=\"main.risk_factors.list\" ui-sref-active-if=\"main.risk_factors\">Risk Factors</a></li><li><a ui-sref=\"main.risk_evidences.list\" ui-sref-active-if=\"main.risk_evidences\">Risk Evidences</a></li><li><a ui-sref=\"main.risk_elements.list\" ui-sref-active-if=\"main.risk_elements\">Risk Elements</a></li><li><a ui-sref=\"main.observables.list\" ui-sref-active-if=\"main.observables\">Observables</a></li><li><a ui-sref=\"main.citations.list\" ui-sref-active-if=\"main.citations\">Citations</a></li><li><a ui-sref=\"main.measurement_types.list\" ui-sref-active-if=\"main.measurement_types\">Measurement Types</a></li></ul></li><li><a ui-sref=\"main.medical_experts.list\" ui-sref-active-if=\"main.medical_experts\">Medical experts</a></li></ul></div><div pageslide=\"\" ps-size=\"{{slideWidth}}px\" ps-open=\"showAbout\" ps-side=\"right\"><div class=\"row\" style=\"padding:30px; padding-top:15px; padding-bottom:0; margin-bottom:0;\"><a href=\"\" ng-click=\"showAbout=!showAbout\" class=\"btn btn-primary pull-left\"><i class=\"fa fa-times fa-lg\"></i></a></div><div class=\"row\" style=\"padding:50px; margin-top:0; padding-top:0; overflow: auto; height: 90%;\"><div autoscroll=\"\" ng-include=\"\" src=\"\'app/about/about.html\'\"></div></div></div></div>");
$templateCache.put("app/components/stats/stats.html","<div class=\"col-lg-3 col-md-6\"><a ui-sref=\"{{goto}}\"><div class=\"panel\" ng-style=\"{\'background-color\':color}\"><div class=\"panel-heading\" style=\"color:white\"><div class=\"row\"><div class=\"col-xs-3\"><i class=\"fa fa-{{type}} fa-5x\"></i></div><div class=\"col-xs-9 text-right\"><div class=\"huge\"><span count-to=\"{{number}}\" value=\"0\" duration=\"1\"></span></div><div>{{comments}}</div></div></div></div><div class=\"panel-footer\" style=\"color:black\"><span class=\"pull-left\"><b>{{title}}</b></span> <span class=\"pull-right\"><i class=\"fa fa-arrow-circle-right\"></i></span><div class=\"clearfix\"></div></div></div></a></div>");
$templateCache.put("app/components/view-pubmed/view-pubmed.html","<div cg-busy=\"loading\" class=\"panel panel-default\"><div class=\"panel-heading\">Article : {{id}} <a ng-href=\"http://www.ncbi.nlm.nih.gov/pubmed/{{id}}\" target=\"_blank\">link to PubMed</a></div><div class=\"panel-body\"><div style=\"white-space: pre-line; overflow-y: auto;\">{{pubmedArticle| trustAsResourceUrl}}</div></div></div>");
$templateCache.put("app/pages/citations/list.html","<div class=\"col-xs-12\"><div cg-busy=\"citations.gridLoading\" id=\"grid1\" ui-grid=\"citations.mygrid\" ui-grid-pagination=\"\" ui-grid-selection=\"\" ui-grid-resize-columns=\"\" ui-grid-move-columns=\"\" ui-grid-exporter=\"\" ui-grid-auto-resize=\"\" class=\"grid\"></div></div>");
$templateCache.put("app/pages/citations/main.html","<div><div class=\"row\"><div class=\"col-xs-12\"><h2 class=\"page-header\">Citations <a ng-hide=\"\'main.citations.list\' | isState\" class=\"btn btn-sm btn-default\" ui-sref=\"main.citations.list\"><i class=\"fa fa-arrow-left\"></i> Back</a> <a ng-hide=\"(\'main.citations.create\' | isState) ||(\'main.citations.createWithId\' | isState) || !main.user.username\" class=\"btn btn-sm btn-primary\" ui-sref=\"main.citations.create\"><i class=\"fa fa-plus\"></i> <b>Create new</b></a></h2></div></div><div class=\"row\" ui-view=\"\"></div></div>");
$templateCache.put("app/pages/dashboard/index.html","<div><div class=\"row\"><div class=\"col-lg-12\"><h2 class=\"page-header\">Dashboard</h2></div></div><div class=\"row\"><div class=\"col-lg-6 col-md-6\"><p id=\"intro-risk-model\" class=\"text-center\"><img style=\"width:100%; height:100%\" src=\"assets/images/model.jpg\"></p></div><div class=\"col-lg-6 col-md-6\"><canvas id=\"intro-stats\" height=\"210%\" class=\"chart chart-bar chart-sm\" chart-data=\"dashboard.counterchart_data\" chart-labels=\"dashboard.counterchart_labels\" chart-options=\"dashboard.counterchart_options\"></canvas></div></div><div class=\"row\"><hr></div><div class=\"row\"><stats id=\"intro-box-risk-factors\" goto=\"main.risk_factors.list\" title=\"Risk Factors\" number=\"{{dashboard.risk_factors.total||0}}\" comments=\"{{dashboard.risk_factors.noreviews||0}} unreviewed!\" color=\"{{dashboard.colors[0]}}\" type=\"info\"></stats><stats id=\"intro-box-risk-evidences\" goto=\"main.risk_evidences.list\" title=\"Risk Evidences\" number=\"{{dashboard.risk_evidences.total||0}}\" comments=\"{{dashboard.risk_evidences.noreviews||0}} unreviewed!\" color=\"{{dashboard.colors[1]}}\" type=\"info\"></stats><stats goto=\"main.risk_elements.list\" title=\"Risk Elements\" number=\"{{dashboard.risk_elements.total||0}}\" comments=\"{{dashboard.risk_elements.noreviews||0}} unreviewed!\" color=\"{{dashboard.colors[2]}}\" type=\"info\"></stats><stats goto=\"main.observables.list\" title=\"Observables\" number=\"{{dashboard.observables.total||0}}\" comments=\"{{dashboard.observables.noreviews||0}} unreviewed!\" color=\"{{dashboard.colors[3]}}\" type=\"info\"></stats><stats goto=\"main.citations.list\" title=\"Citations\" number=\"{{dashboard.citations.total||0}}\" comments=\"\" color=\"{{dashboard.colors[4]}}\" type=\"info\"></stats></div></div>");
$templateCache.put("app/pages/explore/index.html","<div><div class=\"row\" ng-hide=\"showOnlyGraph\"><div class=\"col-lg-12\"><h2 class=\"page-header\">Explore <small></small></h2></div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"row\" ng-hide=\"showOnlyGraph\"><div class=\"col-sm-9\"><div class=\"form-group\"><label>Graph search by risk elements</label><ui-select multiple=\"\" ng-model=\"explore.risk_elements_selected\" theme=\"bootstrap\" style=\"width:100%\" on-select=\"refreshColors()\" on-remove=\"refreshColors()\"><ui-select-match placeholder=\"Select...\">{{$item.label}}</ui-select-match><ui-select-choices repeat=\"el.value as el in explore.risk_elements | propsFilter: {label: $select.search}\"><div ng-bind-html=\"el.label | highlight: $select.search\"></div></ui-select-choices></ui-select><div style=\"margin-top:5px\"><div class=\"btn-group\"><button ng-click=\"explore.risk_elements_selected=[];\" class=\"btn btn-sm btn-default\">Reset</button> <button ng-click=\"explore.setNewId()\" ng-disabled=\"explore.risk_elements_selected.length===0\" class=\"btn btn-sm btn-primary\">Search</button></div><div class=\"btn-group\"><div class=\"btn-group\" uib-dropdown=\"\"><button id=\"single-button\" type=\"button\" class=\"btn btn-sm btn-default\" uib-dropdown-toggle=\"\" ng-disabled=\"disabled\"><i class=\"fa fa-youtube-play\"></i> Examples <span class=\"caret\"></span></button><ul uib-dropdown-menu=\"\" role=\"menu\" aria-labelledby=\"single-button\"><li role=\"menuitem\" ng-repeat=\"ex in explore.examples\"><a href=\"\" ng-click=\"runExample(ex.data)\">{{ex.label}}</a></li></ul></div><button popover-is-open=\"explore.popover_open\" ng-disabled=\"explore.risk_elements_selected.length===0\" popover-placement=\"bottom\" uib-popover-template=\"explore.recommendPopoverUrl\" popover-title=\"Recommend example\" type=\"button\" class=\"btn btn-sm btn-default\"><i class=\"fa fa-bookmark\"></i> Recommend</button></div></div></div></div><div class=\"col-sm-3\"><label for=\"visualization_type\">Visualization type</label><select id=\"visualization_type\" class=\"form-control\" ng-model=\"explore.graph_type\"><option value=\"network\">Network graph</option><option ng-if=\"main.config.ENV===\'DEV\'\" value=\"network-d3\">Network graph d3</option><option value=\"sankey\">Sankey graph</option><option value=\"chord\">Chord graph</option></select></div></div><div class=\"row\"><div class=\"col-xs-12\"><carre-graph-sankey-risk ng-if=\"explore.graph_type===\'sankey\' && explore.ready\" riskid=\"explore.id\"></carre-graph-sankey-risk><carre-graph-chord-risk ng-if=\"explore.graph_type===\'chord\' && explore.ready\" riskid=\"explore.id\"></carre-graph-chord-risk><carre-graph-risk ng-if=\"explore.graph_type===\'network\' && explore.ready\" riskid=\"explore.id\"></carre-graph-risk><carre-graph-network-d3 ng-if=\"explore.graph_type===\'network-d3\' && explore.ready\" riskid=\"explore.id\"></carre-graph-network-d3></div></div></div></div></div><script type=\"text/ng-template\" id=\"recommendExampleTemplate.html\"><div class=\"form-group\"> <label>Add a description for your example</label> <textarea ng-model=\"exampleDesc\" style=\"width:400px\" class=\"form-control\"></textarea> <hr> <div> <a href=\"\" ng-click=\"explore.popover_open=false;\" class=\"btn btn-default\"> Cancel </a> <a href=\"\" ng-click=\"explore.recommendExample(exampleDesc);explore.popover_open=false;\" class=\"btn btn-primary\"> Send </a> </div> </div></script>");
$templateCache.put("app/pages/explore/mine-literature.html","<div><div class=\"row\" ng-hide=\"showOnlyGraph\"><div class=\"col-lg-12\"><h2 class=\"page-header\">Mine Literature</h2></div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"row\"><iframe style=\"border:0 none; width:100%;height:700px\" id=\"mine-literature-iframe\" src=\"https://visual.duth.carre-project.eu/static/academy/list.html\" frameborder=\"0\" hspace=\"0\" vspace=\"0\" marginheight=\"0\" marginwidth=\"0\"></iframe></div></div></div></div>");
$templateCache.put("app/pages/measurement_types/list.html","<div class=\"col-xs-12\"><div cg-busy=\"measurement_types.gridLoading\" id=\"grid1\" ui-grid=\"measurement_types.mygrid\" ui-grid-pagination=\"\" ui-grid-selection=\"\" ui-grid-resize-columns=\"\" ui-grid-move-columns=\"\" ui-grid-exporter=\"\" ui-grid-auto-resize=\"\" class=\"grid\"></div></div>");
$templateCache.put("app/pages/measurement_types/main.html","<div><div class=\"row\"><div class=\"col-xs-12\"><h2 class=\"page-header\">Measurement Types <a ng-hide=\"\'main.measurement_types.list\' | isState\" class=\"btn btn-sm btn-default\" ui-sref=\"main.measurement_types.list\"><i class=\"fa fa-arrow-left\"></i> Back</a> <a ng-hide=\"(\'main.measurement_types.create\' | isState) || !main.user.username\" class=\"btn btn-sm btn-primary\" ui-sref=\"main.measurement_types.create\"><i class=\"fa fa-plus\"></i> <b>Create new</b></a></h2></div></div><div class=\"row\" ui-view=\"\"></div></div>");
$templateCache.put("app/pages/medical_experts/list.html","<div class=\"col-xs-12\"><div class=\"row\"><div class=\"col-sm-6 col-lg-4\" ng-repeat=\"item in medical_experts.users track by $index| orderBy:\'$index\'\"><div class=\"panel panel-default\" style=\"height:300px\"><div class=\"panel-heading\"><a href=\"\" ui-sref=\"main.medical_experts.view({id:item.id_label})\">{{item.has_firstname_label}} {{item.has_lastname_label}}, {{item.has_educational_degree_label}}</a><div class=\"box-tools pull-right\"><a href=\"\" ui-sref=\"main.medical_experts.view({id:item.id_label})\">View profile</a></div></div><div class=\"panel-body\" style=\"height:220px\"><ul style=\"padding-left:5px\"><li style=\"list-style-type: none; margin-top:10px\" ng-repeat=\"pos in item.has_medical_position\"><i class=\"fa fa-angle-right fa-lg fa-x2\"></i> {{ pos}}</li></ul></div><div class=\"panel-footer\" style=\"padding-bottom:26px\"><span style=\"float:left\"><span ng-if=\"item.is_coordinator_of_team\"><b>Coordinator</b></span></span> <span style=\"float:right\">{{item.has_team_name[0]}} Team</span></div></div></div></div></div>");
$templateCache.put("app/pages/medical_experts/main.html","<div><div class=\"row\"><div class=\"col-xs-12\"><h2 class=\"page-header\">Medical Experts <a ng-hide=\"\'main.medical_experts.list\' | isState\" class=\"btn btn-sm btn-default\" ui-sref=\"main.medical_experts.list\"><i class=\"fa fa-arrow-left\"></i> Back</a></h2></div></div><div class=\"row\" ui-view=\"\"></div></div>");
$templateCache.put("app/pages/observables/list.html","<div class=\"col-xs-12\"><div cg-busy=\"observables.gridLoading\" id=\"grid1\" ui-grid=\"observables.mygrid\" ui-grid-pagination=\"\" ui-grid-selection=\"\" ui-grid-resize-columns=\"\" ui-grid-move-columns=\"\" ui-grid-exporter=\"\" ui-grid-auto-resize=\"\" class=\"grid\"></div></div>");
$templateCache.put("app/pages/observables/main.html","<div><div class=\"row\"><div class=\"col-xs-12\"><h2 class=\"page-header\">Observables <a ng-hide=\"\'main.observables.list\' | isState\" class=\"btn btn-sm btn-default\" ui-sref=\"main.observables.list\"><i class=\"fa fa-arrow-left\"></i> Back</a> <a ng-hide=\"(\'main.observables.create\' | isState) || !main.user.username\" class=\"btn btn-sm btn-primary\" ui-sref=\"main.observables.create\"><i class=\"fa fa-plus\"></i> <b>Create new</b></a></h2></div></div><div class=\"row\" ui-view=\"\"></div></div>");
$templateCache.put("app/pages/risk_elements/list.html","<div class=\"col-xs-12\"><div cg-busy=\"risk_elements.gridLoading\" id=\"grid1\" ui-grid=\"risk_elements.mygrid\" ui-grid-pagination=\"\" ui-grid-selection=\"\" ui-grid-resize-columns=\"\" ui-grid-move-columns=\"\" ui-grid-exporter=\"\" ui-grid-auto-resize=\"\" class=\"grid\"></div></div>");
$templateCache.put("app/pages/risk_elements/main.html","<div><div class=\"row\"><div class=\"col-xs-12\"><h2 class=\"page-header\">Risk elements <a ng-hide=\"\'main.risk_elements.list\' | isState\" class=\"btn btn-sm btn-default\" ui-sref=\"main.risk_elements.list\"><i class=\"fa fa-arrow-left\"></i> Back</a> <a ng-hide=\"(\'main.risk_elements.create\' | isState) || !main.user.username\" class=\"btn btn-sm btn-primary\" ui-sref=\"main.risk_elements.create\"><i class=\"fa fa-plus\"></i> <b>Create new</b></a></h2></div></div><div class=\"row\" ui-view=\"\"></div></div>");
$templateCache.put("app/pages/risk_evidences/list.html","<div class=\"col-xs-12\"><div cg-busy=\"risk_evidences.gridLoading\" id=\"grid1\" ui-grid=\"risk_evidences.mygrid\" ui-grid-pagination=\"\" ui-grid-selection=\"\" ui-grid-resize-columns=\"\" ui-grid-move-columns=\"\" ui-grid-exporter=\"\" ui-grid-auto-resize=\"\" class=\"grid\"></div></div><div pageslide=\"\" ps-size=\"640px\" ps-open=\"risk_evidences.selectedRisk_evidence\" ps-side=\"right\"><div cg-busy=\"risk_evidences.loading\" style=\"padding:10px;\"><a ui-sref=\"main.risk_evidences.view({id:risk_evidences.selectedRisk_evidence})\" class=\"btn btn-primary\">Profile</a> <a href=\"\" ng-click=\"risk_evidences.setPubmed()\" class=\"btn btn-primary\"><i class=\"fa fa-times fa-lg\"></i></a><br><br><div ng-if=\"risk_evidences.selectedRisk_evidence\"><div ng-if=\"risk_evidences.pubmedApi\" style=\"white-space: pre-line; overflow-y: auto;height: 95%; width:620px; position: fixed;\" ng-bind-html=\"risk_evidences.pubmedArticle\"></div><iframe ng-if=\"!risk_evidences.pubmedApi\" style=\"border:none; position: fixed; height:90%; width:620px\" height=\"90%\" width=\"620px\" src=\"{{\'http://www.ncbi.nlm.nih.gov/pubmed/\'+risk_evidences.selectedRisk_evidence | trustAsResourceUrl}}\"></iframe></div></div></div>");
$templateCache.put("app/pages/risk_evidences/main.html","<div><div class=\"row\"><div class=\"col-xs-12\"><h2 class=\"page-header\">Risk evidences <a ng-hide=\"\'main.risk_evidences.list\' | isState\" class=\"btn btn-sm btn-default\" ui-sref=\"main.risk_evidences.list\"><i class=\"fa fa-arrow-left\"></i> Back</a> <a ng-hide=\"(\'main.risk_evidences.create\' | isState) || !main.user.username\" class=\"btn btn-sm btn-primary\" ui-sref=\"main.risk_evidences.create\"><i class=\"fa fa-plus\"></i> <b>Create new</b></a></h2></div></div><div class=\"row\" ui-view=\"\"></div></div>");
$templateCache.put("app/pages/risk_factors/list.html","<div class=\"col-xs-12\"><div cg-busy=\"risk_factors.gridLoading\" id=\"grid1\" ui-grid=\"risk_factors.mygrid\" ui-grid-pagination=\"\" ui-grid-selection=\"\" ui-grid-resize-columns=\"\" ui-grid-move-columns=\"\" ui-grid-exporter=\"\" ui-grid-auto-resize=\"\" class=\"grid\"></div></div>");
$templateCache.put("app/pages/risk_factors/main.html","<div><div class=\"row\"><div class=\"col-xs-12\"><h2 class=\"page-header\">Risk factors <a ng-hide=\"\'main.risk_factors.list\' | isState\" class=\"btn btn-sm btn-default\" ui-sref=\"main.risk_factors.list\"><i class=\"fa fa-arrow-left\"></i> Back</a> <a ng-hide=\"(\'main.risk_factors.create\' | isState) || !main.user.username\" class=\"btn btn-sm btn-primary\" ui-sref=\"main.risk_factors.create\"><i class=\"fa fa-plus\"></i> <b>Create new</b></a></h2></div></div><div class=\"row\" ui-view=\"\"></div></div>");
$templateCache.put("app/components/header/header-notification/header-notification.html","<ul class=\"nav navbar-top-links navbar-right\"><li style=\"position: relative;top: 10px;\"><toggle-switch ng-show=\"main.config.ENV===\'DEV\'\" ng-model=\"main.DEBUG\" knob-label=\"Debug\"><toggle-switch></toggle-switch></toggle-switch></li><li ng-if=\"main.user.username\" class=\"dropdown\" uib-dropdown=\"\"><a href=\"\" uib-dropdown-toggle=\"\">{{main.user.name}} <i class=\"fa fa-user fa-fw\"></i> <i class=\"fa fa-caret-down\"></i></a><ul class=\"uib-dropdown-menu\"><li><a ng-click=\"main.logout()\"><i class=\"fa fa-sign-out fa-fw\"></i> Logout</a></li></ul></li><li ng-if=\"!main.user.username\" class=\"dropdown\" uib-dropdown=\"\" auto-close=\"disabled\" is-open=\"main.loginForm.isopen\"><a href=\"\" uib-dropdown-toggle=\"\">Hello Guest, Login <i class=\"fa fa-caret-down\"></i></a><ul class=\"uib-dropdown-menu\"><li><form class=\"form\" role=\"form\" name=\"loginForm\" ng-submit=\"main.login()\" style=\"padding:10px\"><div class=\"form-group\" ng-class=\"{\'has-error\': loginForm.username.$invalid && loginForm.username.$dirty}\"><input type=\"text\" class=\"form-control\" name=\"username\" placeholder=\"Username\" ng-model=\"main.loginForm.username\" required=\"\"></div><div class=\"form-group\" ng-class=\"{\'has-error\': loginForm.password.$invalid && loginForm.password.$dirty}\"><input type=\"password\" class=\"form-control\" name=\"password\" placeholder=\"Password\" ng-model=\"main.loginForm.password\" required=\"\"></div><button type=\"submit\" class=\"btn btn-primary\" style=\"width:100%\" ng-disabled=\"loginForm.$invalid\"><span ng-show=\"main.loginForm.loading\"><i class=\"fa fa-spinner\"></i></span> <span ng-hide=\"main.loginForm.loading\">Login</span></button></form></li></ul></li></ul>");
$templateCache.put("app/components/sidebar/sidebar-search/sidebar-search.html","<li class=\"sidebar-search\"><div class=\"input-group custom-search-form\"><input type=\"text\" class=\"form-control\" placeholder=\"Search...\"> <span class=\"input-group-btn\"><button class=\"btn btn-default\" type=\"button\"><i class=\"fa fa-search\"></i></button></span></div></li>");
$templateCache.put("app/pages/citations/form_component/form.html","<div><div ng-class=\"{\'col-sm-6\':!noPubmed}\"><form name=\"form\" ng-submit=\"saveModel()\"><div class=\"form-group\" ng-class=\"{ \'has-error\': form.email.$touched && form.email.$invalid }\"><span ng-show=\"loadingElementIdentifier\" class=\"loadingSelect\"></span> <label>Evidence source (Pubmed ID)</label> <span class=\"badge badge-default\">{{pubmedAutocompleteResultsCount}} Result(s)</span><ui-select on-select=\"selectPubmed($item,$model)\" class=\"ui-select-big-text\" ng-model=\"citation.pubmedId\" theme=\"bootstrap\"><ui-select-match placeholder=\"Enter Pubmed ID\"><div>{{$select.selected.title}}</div><div>{{$select.selected.authorString}}</div><div>{{$select.selected.source}} - {{$select.selected.pubYear}}</div></ui-select-match><ui-select-choices style=\"max-height: 500px;\" repeat=\"obj.pmid as obj in pubmedAutocompleteResults | propsFilter: { title: $select.search, authorString: $select.search, source: $select.search, pmid: $select.search, pubYear: $select.search }\" refresh=\"searchPubmed($select.search)\" refresh-delay=\"1000\"><div class=\"ui-select-big-text\"><div ng-bind-html=\"obj.title | highlight: $select.search\"></div><div><small ng-bind-html=\"obj.authorString | highlight: $select.search\"></small></div><div><small ng-bind-html=\"obj.source | highlight: $select.search\"></small> / <small ng-bind-html=\"obj.pubYear | highlight: $select.search\"></small> / <small ng-bind-html=\"obj.pmid | highlight: $select.search\"></small></div></div></ui-select-choices></ui-select></div><div class=\"form-group\" ng-class=\"{ \'has-error\': form.email.$touched && form.email.$invalid }\"><label>Citation summary</label> <textarea class=\"form-control\" rows=\"6\" ng-model=\"citation.summary\"></textarea></div><div class=\"form-group\" ng-class=\"{ \'has-error\': form.email.$touched && form.email.$invalid }\"><label>Study type</label><ui-select ng-model=\"citation.studyType\" limit=\"1\" multiple=\"\" tagging=\"\" tagging-label=\"(add new type)\" theme=\"bootstrap\"><ui-select-match placeholder=\"Select study type\">{{$item}}</ui-select-match><ui-select-choices repeat=\"type in types | filter: $select.search\"><div ng-bind-html=\"type | highlight: $select.search\"></div></ui-select-choices></ui-select><div class=\"help-block\" ng-messages=\"form.email.$error\" ng-if=\"form.email.$touched\"><div ng-messages-include=\"messages.html\"></div></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\': form.email.$touched && form.email.$invalid }\"><label>Study Level</label> <input type=\"number\" min=\"1\" max=\"4\" class=\"form-control\" ng-model=\"citation.level\"></div><div class=\"form-group\"><button type=\"button\" ng-click=\"cancelForm()\" class=\"btn btn-danger\">Cancel</button> <button type=\"submit\" class=\"btn btn-primary\">Submit</button></div></form></div><div ng-hide=\"noPubmed||!showPubmed\" class=\"col-sm-6\"><label>Pubmed Viewer</label><carre-view-pubmed ng-if=\"showPubmed\" id=\"{{citation.pubmedId}}\"></carre-view-pubmed></div></div>");
$templateCache.put("app/pages/citations/single/single.html","<div uib-collapse=\"!main.DEBUG\" class=\"row\"><div class=\"col-xs-12\">Current citation<pre>{{citation | json}}</pre></div></div><div class=\"col-xs-12\"><carre-element-controls carre-id=\"{{id}}\"></carre-element-controls><carre-element ng-if=\"mode\" type=\"citation\" elem-id=\"{{id}}\" mode=\"{{mode}}\" elem=\"current\"></carre-element></div>");
$templateCache.put("app/pages/measurement_types/form_component/form.html","<div><form name=\"form\" novalidate=\"\" ng-submit=\"saveModel()\"><div class=\"form-group\" ng-class=\"{ \'has-error\': form.name.$touched && form.name.$invalid }\"><label>Name</label> <input type=\"text\" name=\"name\" placeholder=\"e.g filtration rate\" class=\"form-control\" ng-model=\"measurement_type.name\" required=\"\"><div class=\"help-block\" ng-messages=\"form.name.$error\" ng-if=\"form.name.$touched\"><p ng-message=\"required\">Name is required.</p></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\': form.email.$touched && form.email.$invalid }\"><label>Date type</label><ui-select ng-model=\"measurement_type.datatype\" theme=\"bootstrap\"><ui-select-match placeholder=\"Select datatype\">{{$select.selected}}</ui-select-match><ui-select-choices repeat=\"type in datatypes\"><div ng-bind-html=\"type | highlight: $select.search\"></div></ui-select-choices></ui-select><div class=\"help-block\" ng-messages=\"form.email.$error\" ng-if=\"form.email.$touched\"><div ng-messages-include=\"messages.html\"></div></div></div><div class=\"form-group\" ng-if=\"measurement_type.datatype===\'integer\' || measurement_type.datatype===\'float\'\" ng-class=\"{ \'has-error\': form.unit.$touched && form.unit.$invalid }\"><label>Unit</label> <input type=\"text\" name=\"unit\" placeholder=\"e.g ml/min/1.73 m^2\" class=\"form-control\" ng-model=\"measurement_type.unit\" required=\"\"><div class=\"help-block\" ng-messages=\"form.unit.$error\" ng-if=\"form.unit.$touched\"><p ng-message=\"required\">Unit is required.</p></div></div><div class=\"form-group\" ng-if=\"measurement_type.datatype===\'enum\'\" ng-class=\"{ \'has-error\': form.email.$touched && form.email.$invalid }\"><label>Values</label><ui-select multiple=\"\" tagging=\"\" tagging-label=\"(custom \'new\' value)\" ng-model=\"measurement_type.values\" theme=\"bootstrap\"><ui-select-match placeholder=\"Select values...\">{{$item}}</ui-select-match><ui-select-choices repeat=\"val in []\">{{val}}</ui-select-choices></ui-select><div class=\"help-block\" ng-messages=\"form.email.$error\" ng-if=\"form.email.$touched\"><div ng-messages-include=\"messages.html\"></div></div></div><div class=\"form-group\" ng-if=\"measurement_type.datatype===\'boolean\'\" ng-class=\"{ \'has-error\': form.email.$touched && form.email.$invalid }\"><label>Values</label><ui-select multiple=\"\" limit=\"2\" tagging=\"\" tagging-label=\"(custom \'new\' value)\" ng-model=\"measurement_type.values\" theme=\"bootstrap\"><ui-select-match placeholder=\"Select values...\">{{$item}}</ui-select-match><ui-select-choices repeat=\"val in [\'yes\',\'no\']\">{{val}}</ui-select-choices></ui-select><div class=\"help-block\" ng-messages=\"form.email.$error\" ng-if=\"form.email.$touched\"><div ng-messages-include=\"messages.html\"></div></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\': form.email.$touched && form.email.$invalid }\"><label>Semantic annotation for \"{{measurement_type.name||\'e.g age\'}}\"</label><div class=\"alert alert-warning\" style=\"margin-bottom: 0\">{{measurement_type.identifier}}</div><uib-accordion close-others=\"true\"><uib-accordion-group><uib-accordion-heading><span uib-popover=\"Units of Measurement Ontology by Bioportal\" popover-trigger=\"mouseenter\">UO ontology</span><div ng-show=\"loadingElementIdentifier\" class=\"loadingSelect\"></div></uib-accordion-heading><ui-select ng-model=\"measurement_type.identifier\" theme=\"bootstrap\"><ui-select-match allow-clear=\"true\" placeholder=\"Search...\">{{$select.selected.label}} - {{$select.selected.value | sliceLast:\'/\' }}</ui-select-match><ui-select-choices repeat=\"elem.value as elem in bioportalAutocompleteResults | propsFilter: {label: $select.search}\" refresh=\"bioportalAutocomplete($select.search)\" refresh-delay=\"500\"><div ng-bind-html=\"elem.label | highlight: $select.search\"></div><small>{{elem.value}}</small></ui-select-choices></ui-select></uib-accordion-group><uib-accordion-group heading=\"Custom\"><input type=\"text\" name=\"name\" placeholder=\"e.g {{measurement_type.name}}\" class=\"form-control\" ng-change=\"transformItem(customIdentifier)\" ng-model=\"customIdentifier\"></uib-accordion-group></uib-accordion></div><div class=\"form-group\"><button type=\"button\" ng-click=\"cancelForm()\" class=\"btn btn-danger\">Cancel</button> <button type=\"submit\" class=\"btn btn-primary\">Submit</button></div></form></div>");
$templateCache.put("app/pages/measurement_types/single/single.html","<div uib-collapse=\"!main.DEBUG\" class=\"row\"><div class=\"col-xs-12\">Current measurement_type<pre>{{measurement_type | json}}</pre></div></div><div class=\"col-xs-12\"><carre-element-controls carre-id=\"{{id}}\"></carre-element-controls><carre-element type=\"measurement_type\" elem-id=\"{{id}}\" mode=\"{{mode}}\"></carre-element></div>");
$templateCache.put("app/pages/medical_experts/single/view.html","<div uib-collapse=\"!main.DEBUG\" class=\"row\"><div class=\"col-xs-12\">Current medical_expert<pre>{{medical_expert | json}}</pre></div></div><div class=\"col-xs-12\"><div class=\"col-sm-6\"><div ng-show=\"main.user.username && main.config.ENV===\'DEV\'\">ID: <b>{{medical_expert.id}}</b> <a class=\"btn btn-xs btn-danger\" href=\"\" ng-click=\"medical_expert.deleteCurrent()\"><i class=\"fa fa-trash-o\"></i> Delete</a></div><div class=\"thumbnail\" style=\"display: inline-block;\"><img class=\"avatar-img\" ng-src=\"{{medical_expert.current.has_avatar[0]}}\"></div><ul class=\"list-group\"><li class=\"list-group-item\">Name: <b>{{medical_expert.current.has_firstname_label}} {{medical_expert.current.has_lastname_label}}, {{medical_expert.current.has_educational_degree_label}}</b></li><li class=\"list-group-item\">Medical specialty: <b><a target=\"_blank\" ng-href=\"{{medical_expert.current.has_medical_specialty_link}}\">{{medical_expert.current.has_medical_specialty_label}}</a></b></li><li class=\"list-group-item\">Medical Positions:<ul style=\"padding-left:5px\"><li style=\"list-style-type: none;\" ng-repeat=\"pos in medical_expert.current.has_medical_position\"><b><i class=\"fa fa-angle-right fa-lg fa-x2\"></i> {{ pos}}</b></li></ul></li><li ng-if=\"medical_expert.current.has_short_cv.length>1\" class=\"list-group-item\">Short CV: <b>{{medical_expert.current.has_short_cv}}</b></li><li ng-if=\"medical_expert.current.has_personal_page_url\" class=\"list-group-item\">More details: <b><a target=\"_blank\" ng-href=\"{{medical_expert.current.has_personal_page_url[0]}}\">link</a></b></li><li ng-if=\"medical_expert.current.is_coordinator_of_team\" class=\"list-group-item\">Coordinator: <b>{{medical_expert.current.is_coordinator_of_team[0]}} team</b></li><li ng-if=\"!medical_expert.current.is_coordinator_of_team\" class=\"list-group-item\">Team: <b>{{medical_expert.current.has_team_name[0]}}</b></li><b></b><hr></ul></div><div class=\"col-sm-6\"><canvas height=\"170%\" class=\"chart chart-bar chart-sm\" chart-legend=\"true\" chart-data=\"medical_expert.counterchart_data\" chart-series=\"medical_expert.counterchart_series\" chart-labels=\"medical_expert.counterchart_labels\" chart-options=\"medical_expert.counterchart_options\"></canvas></div></div>");
$templateCache.put("app/pages/observables/form_component/form.html","<div><form name=\"form\" novalidate=\"\" ng-submit=\"saveModel()\"><div class=\"form-group\" ng-class=\"{ \'has-error\': form.name.$touched && form.name.$invalid }\"><label>Name</label> <input type=\"text\" name=\"name\" placeholder=\"e.g glucose tolerance test\" class=\"form-control\" ng-model=\"observable.name\" required=\"\"><div class=\"help-block\" ng-messages=\"form.name.$error\" ng-if=\"form.name.$touched\"><p ng-message=\"required\">Name is required.</p></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\': form.email.$touched && form.email.$invalid }\"><label>Type</label><ui-select ng-model=\"observable.type\" theme=\"bootstrap\"><ui-select-match placeholder=\"Select observable type\">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat=\"type.value as type in types | propsFilter: {label: $select.search}\"><div ng-bind-html=\"type.label | highlight: $select.search\"></div></ui-select-choices></ui-select><div class=\"help-block\" ng-messages=\"form.email.$error\" ng-if=\"form.email.$touched\"><div ng-messages-include=\"messages.html\"></div></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\': form.email.$touched && form.email.$invalid }\"><label>Measurement type</label><ui-select ng-model=\"observable.measurement_type\" theme=\"bootstrap\"><ui-select-match placeholder=\"Select measurement type\">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat=\"obj.value as obj in measurement_types | propsFilter: {label: $select.search}\"><div ng-bind-html=\"obj.label | highlight: $select.search\"></div></ui-select-choices></ui-select><div class=\"help-block\" ng-messages=\"form.email.$error\" ng-if=\"form.email.$touched\"><div ng-messages-include=\"messages.html\"></div></div></div><div class=\"form-group\"><label>Semantic annotation for \"{{observable.name||\'e.g age\'}}\"</label><div class=\"alert alert-warning\" style=\"margin-bottom: 0\">{{observable.identifier}}</div><uib-accordion close-others=\"true\"><uib-accordion-group><uib-accordion-heading><span uib-popover=\"Clinical Measurement Ontology by Bioportal\" popover-trigger=\"mouseenter\">CMO ontology</span><div ng-show=\"loadingElementIdentifier\" class=\"loadingSelect\"></div></uib-accordion-heading><ui-select ng-model=\"observable.identifier\" theme=\"bootstrap\"><ui-select-match allow-clear=\"true\" placeholder=\"Search...\">{{$select.selected.label}} - {{$select.selected.value | sliceLast:\'/\' }}</ui-select-match><ui-select-choices repeat=\"elem.value as elem in bioportalAutocompleteResults | propsFilter: {label: $select.search}\" refresh=\"bioportalAutocomplete($select.search)\" refresh-delay=\"500\"><div ng-bind-html=\"elem.label | highlight: $select.search\"></div><small>{{elem.value}}</small></ui-select-choices></ui-select></uib-accordion-group><uib-accordion-group heading=\"Custom\"><input type=\"text\" name=\"name\" placeholder=\"e.g {{observable.name}}\" class=\"form-control\" ng-change=\"transformIdentifier(customIdentifier)\" ng-model=\"customIdentifier\"></uib-accordion-group></uib-accordion></div><div class=\"form-group\" ng-class=\"{ \'has-error\': form.email.$touched && form.email.$invalid }\"><label>Sensor annotation for \"{{observable.name||\'e.g age\'}}\"</label><div class=\"alert alert-warning\" style=\"margin-bottom: 0\">{{observable.predicate}}</div><uib-accordion close-others=\"true\"><uib-accordion-group><uib-accordion-heading><span uib-popover=\"CARRE Sensors ontology\" popover-trigger=\"mouseenter\">CARRE Sensors ontology</span><div ng-show=\"loadingElementIdentifier\" class=\"loadingSelect\"></div></uib-accordion-heading><ui-select on-select=\"transformPredicate(customPredicate)\" ng-model=\"customPredicate\" theme=\"bootstrap\"><ui-select-match allow-clear=\"true\" placeholder=\"Select from sensors ontology..\">{{$select.selected }}</ui-select-match><ui-select-choices repeat=\"elem in SensorPredicates | filter : $select.search\"><div ng-bind-html=\"elem | highlight: $select.search\"></div></ui-select-choices></ui-select></uib-accordion-group><uib-accordion-group heading=\"Custom\"><input type=\"text\" name=\"name\" placeholder=\"Or type a custom name\" class=\"form-control\" ng-change=\"transformPredicate(customPredicate)\" ng-model=\"customPredicate\"></uib-accordion-group></uib-accordion></div><div class=\"form-group\"><button type=\"button\" ng-click=\"cancelForm()\" class=\"btn btn-danger\">Cancel</button> <button type=\"submit\" class=\"btn btn-primary\">Submit</button></div></form></div>");
$templateCache.put("app/pages/observables/single/single.html","<div uib-collapse=\"!main.DEBUG\" class=\"row\"><div class=\"col-xs-12\">Current observable<pre>{{observable | json}}</pre></div></div><div class=\"col-xs-12\"><carre-element-controls carre-id=\"{{id}}\"></carre-element-controls><carre-element type=\"observable\" elem-id=\"{{id}}\" mode=\"{{mode}}\"></carre-element></div>");
$templateCache.put("app/pages/risk_elements/form_component/form.html","<div><form name=\"form\" novalidate=\"\" ng-submit=\"saveModel()\"><div class=\"form-group\" ng-class=\"{ \'has-error\': form.name.$touched && form.name.$invalid }\"><label>Name</label> <input type=\"text\" name=\"name\" placeholder=\"Risk element name e.g acute kidney disease\" class=\"form-control\" ng-model=\"risk_element.name\" required=\"\"><div class=\"help-block\" ng-messages=\"form.name.$error\" ng-if=\"form.name.$touched\"><p ng-message=\"required\">Name is required.</p></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\': form.email.$touched && form.email.$invalid }\"><label>Modifiable status</label> <input type=\"checkbox\" ng-true-value=\"\'yes\'\" ng-false-value=\"\'no\'\" ng-model=\"risk_element.modifiable_status\"></div><div class=\"form-group\" ng-class=\"{ \'has-error\': form.email.$touched && form.email.$invalid }\"><label>Type</label><ui-select ng-model=\"risk_element.type\" theme=\"bootstrap\"><ui-select-match placeholder=\"Select risk element type\">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat=\"type.value as type in types | propsFilter: {label: $select.search}\"><div ng-bind-html=\"type.label | highlight: $select.search\"></div></ui-select-choices></ui-select><div class=\"help-block\" ng-messages=\"form.email.$error\" ng-if=\"form.email.$touched\"><div ng-messages-include=\"messages.html\"></div></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\': form.email.$touched && form.email.$invalid }\"><label>Identifier</label><div ng-show=\"loadingElementIdentifier\" class=\"loadingSelect\"></div><ui-select ng-model=\"risk_element.identifier\" theme=\"bootstrap\"><ui-select-match style=\"min-width: 100px;\" placeholder=\"Search for CUI...\">{{$select.selected.label+\' - \'+$select.selected.value}}</ui-select-match><ui-select-choices repeat=\"elem.value as elem in bioportalAutocompleteResults | propsFilter: {label: $select.search}\" refresh=\"bioportalAutocomplete($select.search)\" refresh-delay=\"500\"><div ng-bind-html=\"elem.label | highlight: $select.search\"></div><small>{{elem.value}}</small></ui-select-choices></ui-select><div class=\"help-block\" ng-messages=\"form.email.$error\" ng-if=\"form.email.$touched\"><div ng-messages-include=\"messages.html\"></div></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\': form.email.$touched && form.email.$invalid }\"><label>Observables</label><ui-select multiple=\"\" ng-model=\"risk_element.observables\" theme=\"bootstrap\"><pre>{{$model| json}}</pre><ui-select-match placeholder=\"Select observables\">{{$item.label}}</ui-select-match><ui-select-choices repeat=\"ob.value as ob in observables | propsFilter: {label: $select.search}\"><div ng-bind-html=\"ob.label | highlight: $select.search\"></div></ui-select-choices></ui-select><div class=\"help-block\" ng-messages=\"form.email.$error\" ng-if=\"form.email.$touched\"><div ng-messages-include=\"messages.html\"></div></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\': form.email.$touched && form.email.$invalid }\"><label>Include other risk elements</label><ui-select multiple=\"\" ng-model=\"risk_element.risk_elements\" theme=\"bootstrap\"><ui-select-match placeholder=\"Select risk elements\">{{$item.label}}</ui-select-match><ui-select-choices repeat=\"el.value as el in risk_elements | propsFilter: {label: $select.search}\"><div ng-bind-html=\"el.label | highlight: $select.search\"></div></ui-select-choices></ui-select><div class=\"help-block\" ng-messages=\"form.email.$error\" ng-if=\"form.email.$touched\"><div ng-messages-include=\"messages.html\"></div></div></div><div class=\"form-group\"><button type=\"button\" ng-click=\"cancelForm()\" class=\"btn btn-danger\">Cancel</button> <button type=\"submit\" class=\"btn btn-primary\">Submit</button></div></form></div>");
$templateCache.put("app/pages/risk_elements/single/single.html","<div uib-collapse=\"!main.DEBUG\" class=\"row\"><div class=\"col-xs-12\">Current risk_element<pre>{{risk_element | json}}</pre></div></div><div class=\"col-xs-12\"><div class=\"col-sm-4\"><carre-element-controls carre-id=\"{{id}}\"></carre-element-controls><carre-element ng-if=\"mode\" type=\"risk_element\" elem-id=\"{{id}}\" mode=\"{{mode}}\"></carre-element></div><div class=\"col-sm-8\"><carre-graph-chord-risk ng-if=\"mode!==\'create\'\" height=\"400\" riskid=\"id\"></carre-graph-chord-risk></div></div>");
$templateCache.put("app/pages/risk_evidences/form_component/form.html","<div><div class=\"col-sm-6\"><form name=\"form\" novalidate=\"\" ng-submit=\"saveModel()\"><div class=\"form-group\" ng-class=\"{ \'has-error\': form.email.$touched && form.email.$invalid }\"><label>Risk factor</label><ui-select ng-model=\"risk_evidence.risk_factor\" theme=\"bootstrap\"><ui-select-match placeholder=\"Select risk factor\">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat=\"rl.value as rl in risk_factors | propsFilter: {label: $select.search}\"><div ng-bind-html=\"rl.label | highlight: $select.search\"></div></ui-select-choices></ui-select></div><div class=\"form-group\" ng-class=\"{ \'has-error\': form.email.$touched && form.email.$invalid }\"><label>Observables</label><ui-select multiple=\"\" ng-model=\"risk_evidence.observables\" theme=\"bootstrap\"><ui-select-match placeholder=\"Select observables\">{{$item.label}}</ui-select-match><ui-select-choices repeat=\"ob.id as ob in observables | propsFilter: {label: $select.search}\"><div ng-bind-html=\"ob.label | highlight: $select.search\"></div></ui-select-choices></ui-select></div><div class=\"form-group\"><label>Condition <a class=\"btn btn-xs btn-default\" ng-click=\"leEditEnabled=!leEditEnabled\"><span ng-if=\"!leEditEnabled\">Show editor <i class=\"fa fa-plus-square\"></i></span> <span ng-if=\"leEditEnabled\">Hide editor <i class=\"fa fa-minus-square\"></i></span></a></label><div><div class=\"alert alert-warning\" ng-bind-html=\"output | prettySigns\"></div></div><div uib-collapse=\"!leEditEnabled\"><le-editor ng-if=\"showLeEditor\" observables=\"observables\" metypes=\"metypes\" group=\"filter.group\"></le-editor></div></div><div class=\"row\"><div class=\"form-group col-sm-6\" ng-class=\"{ \'has-error\': form.email.$touched && form.email.$invalid }\"><label>Ratio value</label> <input type=\"number\" min=\"{{risk_evidence.confidence_interval_min||0}}\" max=\"{{risk_evidence.confidence_interval_max}}\" step=\"0.01\" class=\"form-control\" ng-model=\"risk_evidence.ratio_value\"></div><div class=\"form-group col-sm-6\" ng-class=\"{ \'has-error\': form.email.$touched && form.email.$invalid }\"><label>Confidence Interval Minimum</label> <input type=\"number\" step=\"0.01\" class=\"form-control\" min=\"0\" max=\"{{risk_evidence.confidence_interval_max}}\" ng-model=\"risk_evidence.confidence_interval_min\"></div><div class=\"form-group col-sm-6\" ng-class=\"{ \'has-error\': form.email.$touched && form.email.$invalid }\"><label>Ratio Type</label><ui-select ng-model=\"risk_evidence.ratio_type\" theme=\"bootstrap\"><ui-select-match placeholder=\"Select ratio type\">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat=\"type.value as type in ratiotypes\"><div ng-bind-html=\"type.label | highlight: $select.search\"></div></ui-select-choices></ui-select></div><div class=\"form-group col-sm-6\" ng-class=\"{ \'has-error\': form.email.$touched && form.email.$invalid }\"><label>Confidence Interval Maximum</label> <input type=\"number\" step=\"0.01\" class=\"form-control\" min=\"{{risk_evidence.confidence_interval_min||0}}\" max=\"\" ng-model=\"risk_evidence.confidence_interval_max\"></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\': form.email.$touched && form.email.$invalid }\"><label>Evidence source</label><ui-select on-select=\"viewPubmed($item,$model)\" class=\"ui-select-big-text\" ng-model=\"risk_evidence.evidence_source\" theme=\"bootstrap\"><ui-select-match placeholder=\"Select evidence source\"><div>{{$select.selected.title}}</div><div>{{$select.selected.authors}}</div><div>{{$select.selected.date}}</div></ui-select-match><ui-select-choices repeat=\"obj.value as obj in citations | propsFilter: {title: $select.search,authors: $select.search,date: $select.search}\"><div class=\"ui-select-big-text\"><div ng-bind-html=\"obj.title | highlight: $select.search\"></div><div><small ng-bind-html=\"obj.authors | highlight: $select.search\"></small></div><div><small ng-bind-html=\"obj.date | highlight: $select.search\"></small></div></div></ui-select-choices></ui-select></div><div class=\"form-group\" ng-class=\"{ \'has-error\': form.email.$touched && form.email.$invalid }\"><label>Adjusted for</label><ui-select multiple=\"\" tagging=\"\" tagging-label=\"(custom \'new\' value)\" ng-model=\"risk_evidence.adjusted_for\" theme=\"bootstrap\"><ui-select-match placeholder=\"Select values...\">{{$item}}</ui-select-match><ui-select-choices repeat=\"val in adjusted_for | filter: $select.search\"><div ng-bind-html=\"val| highlight: $select.search\"></div></ui-select-choices></ui-select><div class=\"help-block\" ng-messages=\"form.email.$error\" ng-if=\"form.email.$touched\"><div ng-messages-include=\"messages.html\"></div></div></div><div class=\"form-group\"><button type=\"button\" ng-click=\"cancelForm()\" class=\"btn btn-danger\">Cancel</button> <button type=\"submit\" class=\"btn btn-primary\">Submit</button></div></form></div><script type=\"text/ng-template\" id=\"newCitationTemplate.html\"><carre-element ng-if=\"showAddCitation\" type=\"citation\" mode=\"create\" elem=\"{pubmedId:risk_evidence.pubmedId,noPubmed:true}\"></carre-element></script><div class=\"col-sm-6\"><label>Pubmed Id <a href=\"\" ng-show=\"!risk_evidence.evidence_source\" popover-is-open=\"showAddCitation\" popover-placement=\"bottom\" uib-popover-template=\"\'newCitationTemplate.html\'\" popover-title=\"Create a new citation and add it to the collection\" class=\"btn btn-xs btn-default\" ng-click=\"\">Add to Citations <i class=\"fa fa-plus\"></i></a></label> <input type=\"text\" name=\"name\" placeholder=\"Enter pubmed Id\" class=\"form-control\" ng-change=\"loadPubmed()\" ng-model=\"risk_evidence.pubmedId\" required=\"\"><carre-view-pubmed ng-if=\"showPubmed\" id=\"{{risk_evidence.pubmedId}}\"></carre-view-pubmed></div></div>");
$templateCache.put("app/pages/risk_evidences/single/single.html","<div uib-collapse=\"!main.DEBUG\" class=\"row\"><div class=\"col-xs-12\">Current risk_evidence<pre>{{risk_evidence | json}}</pre></div></div><div class=\"col-xs-12\"><carre-element-controls carre-id=\"{{id}}\"></carre-element-controls><carre-element ng-if=\"mode\" type=\"risk_evidence\" elem-id=\"{{id}}\" mode=\"{{mode}}\" elem=\"current\"></carre-element></div>");
$templateCache.put("app/pages/risk_factors/form_component/form.html","<div><form name=\"form\" novalidate=\"\" ng-submit=\"saveModel()\"><div class=\"form-group\" ng-class=\"{ \'has-error\': form.email.$touched && form.email.$invalid }\"><label>Source risk element</label><ui-select ng-model=\"risk_factor.source\" theme=\"bootstrap\"><ui-select-match placeholder=\"Select risk element\">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat=\"rl.value as rl in risk_elements | propsFilter: {label: $select.search}\"><div ng-bind-html=\"rl.label | highlight: $select.search\"></div></ui-select-choices></ui-select><div class=\"help-block\" ng-messages=\"form.email.$error\" ng-if=\"form.email.$touched\"><div ng-messages-include=\"messages.html\"></div></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\': form.email.$touched && form.email.$invalid }\"><label>Target risk element</label><ui-select ng-model=\"risk_factor.target\" theme=\"bootstrap\"><ui-select-match placeholder=\"Select risk element\">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat=\"rl.value as rl in risk_elements | propsFilter: {label: $select.search}\"><div ng-bind-html=\"rl.label | highlight: $select.search\"></div></ui-select-choices></ui-select><div class=\"help-block\" ng-messages=\"form.email.$error\" ng-if=\"form.email.$touched\"><div ng-messages-include=\"messages.html\"></div></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\': form.email.$touched && form.email.$invalid }\"><label>Association Type</label><ui-select ng-model=\"risk_factor.type\" theme=\"bootstrap\"><ui-select-match placeholder=\"Select risk association type\">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat=\"type.value as type in types | propsFilter: {label: $select.search}\"><div ng-bind-html=\"type.label | highlight: $select.search\"></div></ui-select-choices></ui-select><div class=\"help-block\" ng-messages=\"form.email.$error\" ng-if=\"form.email.$touched\"><div ng-messages-include=\"messages.html\"></div></div></div><div class=\"form-group\"><button type=\"button\" ng-click=\"cancelForm()\" class=\"btn btn-danger\">Cancel</button> <button type=\"submit\" class=\"btn btn-primary\">Submit</button></div></form></div>");
$templateCache.put("app/pages/risk_factors/single/single.html","<div uib-collapse=\"!main.DEBUG\" class=\"row\"><div class=\"col-xs-12\">Current risk_factor<pre>{{risk_factor | json}}</pre></div></div><div class=\"col-xs-12\"><div class=\"col-sm-6\"><carre-element-controls carre-id=\"{{id}}\"></carre-element-controls><carre-element type=\"risk_factor\" elem-id=\"{{id}}\" mode=\"{{mode}}\"></carre-element></div><div ng-if=\"mode===\'view\'\" class=\"col-sm-6\"><carre-graph-risk height=\"250\" riskid=\"id\"></carre-graph-risk></div></div><div ng-if=\"mode===\'view\'\" class=\"col-xs-12\"><h4 class=\"page-header\">Related risk evidences</h4><div cg-busy=\"gridLoading\" id=\"grid1\" ui-grid=\"mygrid\" ui-grid-pagination=\"\" ui-grid-selection=\"\" ui-grid-resize-columns=\"\" ui-grid-move-columns=\"\" ui-grid-exporter=\"\" ui-grid-auto-resize=\"\" class=\"grid\"></div></div>");}]);